// Türkçe metinler (varsayılan dil). Kullanıcıya dönen her metin buradan çözülür.
export const tr = {
  GET: "GET",
  POST: "POST",
  a: "a",
  access: {
    actionHelp: {
      approve: "{{resource}} kayıtlarını kontrol edip onaylı duruma geçirebilir.",
      archive: "{{resource}} kayıtlarını arşive taşıyabilir; arşivlenen kayıtlar listelerde gizlenir.",
      create: "Yeni {{resource}} kaydı oluşturabilir.",
      delete: "{{resource}} kayıtlarını kalıcı olarak silebilir.",
      edit: "Mevcut {{resource}} kayıtlarını düzenleyebilir.",
      export: "{{resource}} verilerini indirebilir ve dışa aktarabilir.",
      view: "{{resource}} kayıtlarını görüntüleyebilir."
    },
    actions: {
      approve: "Onayla",
      archive: "Arşivle",
      create: "Oluştur",
      delete: "Sil",
      edit: "Düzenle",
      export: "İndir",
      view: "Görüntüle"
    },
    allStatuses: "Tüm durumlar",
    breadcrumb: "Roller ve Yetkiler",
    departments: {
      columns: {
        actions: "İşlemler",
        created: "Oluşturma",
        manager: "Yönetici",
        members: "Çalışan sayısı",
        name: "Departman",
        parent: "Üst departman",
        people: "Üyeler",
        roles: "Bağlı roller",
        status: "Durum"
      },
      count: "{{count}} / {{total}} departman",
      create: "Departman Oluştur",
      created: "Departman eklendi",
      deleteBody: "\"{{name}}\" departmanı silinecek. Bu işlem geri alınamaz.",
      deleteTitle: "Departman silinsin mi?",
      deleted: "Departman silindi",
      detail: {
        childrenEmpty: "Alt departman yok",
        childrenTitle: "Alt Departmanlar ({{count}})",
        columns: {
          email: "E-posta",
          name: "Ad Soyad",
          role: "Rol"
        },
        documentsEmpty: "Belge gerekliliği tanımlanmamış",
        historyEmpty: "İşlem geçmişi henüz yok",
        managerBadge: "Yönetici",
        memberBadge: "Üye",
        memberSearch: "Çalışan ara…",
        membersEmpty: "Bu departmanda personel yok",
        membersTitle: "Departman Üyeleri ({{count}})",
        noDescription: "Açıklama eklenmemiş",
        shellHint: "Bu bölüm API bağlandığında doldurulacak."
      },
      empty: "Henüz departman yok",
      form: {
        code: "Kod",
        codeInvalid: "Kod 2–10 harf veya rakamdan oluşmalı",
        createTitle: "Departman Oluştur",
        description: "Açıklama",
        editTitle: "Departmanı Düzenle",
        hint: "Departman adını, yöneticisini ve isteğe bağlı üst departmanı belirleyin. Yönetici zorunludur.",
        manager: "Departman yöneticisi",
        managerNone: "Atanmamış",
        managerPick: "Yönetici seçin",
        managerRequired: "Yönetici seçimi zorunlu",
        members: "Departman üyeleri",
        membersEmpty: "Aramanıza uyan personel yok",
        membersHint: "Departman üyeliği tek başına yetki vermez; yetkiler roller üzerinden yönetilir.",
        membersSelected: "{{count}} seçili",
        name: "Departman adı",
        nameRequired: "Departman adı en az 2 karakter olmalı",
        parent: "Üst departman",
        parentNone: "Üst departman yok (kök)",
        statusHint: "Pasif departmanlar yeni atamalara kapalıdır."
      },
      memberCount: "{{count}} personel",
      noMatch: "Aramanıza uyan departman yok",
      reassign: {
        body: "Seçilen personeller başka departmanda ve/veya uyumsuz pozisyonda kayıtlı. Onaylarsanız departmanları güncellenir.",
        confirm: "Onayla ve kaydet",
        otherDepartment: "Şu an {{name}} departmanında",
        positionFallback: "mevcut pozisyon",
        positionOther: "Pozisyon ({{title}}) bağlanacak / kaldırılacak",
        title: "Personel ataması onayı",
        willClearPosition: "Onaydan sonra mevcut pozisyon ({{title}}) temizlenir"
      },
      searchPlaceholder: "Departman ara (ad, kod)…",
      subtitle: "Organizasyonun departman yapısını, yöneticilerini ve bağlı personel sayılarını yönetin.",
      tabs: {
        children: "Alt Departmanlar ({{count}})",
        documents: "Belge Gereklilikleri",
        general: "Genel",
        history: "İşlem Geçmişi",
        members: "Üyeler ({{count}})"
      },
      title: "Departmanlar",
      tree: {
        empty: "Organizasyon ağacı boş",
        title: "Organizasyon Yapısı"
      },
      updated: "Departman güncellendi"
    },
    directory: {
      activate: "Aktifleştir",
      activateBody: "\"{{name}}\" kullanıcısı tekrar giriş yapabilir hale gelecek.",
      activateTitle: "Kullanıcı aktifleştirilsin mi?",
      activated: "Kullanıcı aktifleştirildi",
      columns: {
        actions: "İşlemler",
        department: "Departman / Pozisyon",
        name: "Kullanıcı",
        roles: "Roller",
        status: "Durum"
      },
      count: "{{count}} / {{total}} kullanıcı",
      create: "Kullanıcı Ekle",
      created: "Kullanıcı oluşturuldu (ilk girişte şifre değiştirme zorunlu)",
      deactivate: "Pasifleştir",
      deactivateBody: "\"{{name}}\" kullanıcısı giriş yapamaz hale gelecek.",
      deactivateTitle: "Kullanıcı pasifleştirilsin mi?",
      deactivated: "Kullanıcı pasifleştirildi",
      empty: "Henüz kullanıcı yok",
      form: {
        createHint: "Personel ve roller zorunlu. Sistem giriş şifresi ile Gmail uygulama şifresi ayrıdır; karıştırmayın.",
        createTitle: "Kullanıcı Ekle",
        editHint: "Ad, soyad, roller ve iş maili kutusunu güncelleyin. Secret API’de görünmez.",
        editTitle: "Kullanıcıyı Düzenle",
        email: "E-posta",
        emailInvalid: "Geçerli bir e-posta girin",
        employee: "Personel",
        employeeNone: "Yok",
        employeePick: "Personel seçin",
        employeeRequired: "Personel seçimi zorunlu",
        firstName: "Ad",
        firstNameRequired: "Ad en az 2 karakter olmalı",
        lastName: "Soyad",
        lastNameRequired: "Soyad en az 2 karakter olmalı",
        loginEmail: "Giriş e-postası",
        loginPassword: "Sistem giriş şifresi",
        loginPasswordHint: "Opsiyonel. Boş bırakılırsa geçici şifre iş mailine gider; ilk girişte değiştirme zorunlu.",
        loginPasswordPlaceholder: "Boş = geçici şifre maili",
        loginPasswordMin: "Giriş şifresi en az 8 karakter olmalı",
        mailboxAssign: "Kutu ata",
        mailboxEmail: "Kutu e-postası",
        mailboxHasSecret: "Şifre kayıtlı",
        mailboxHint: "Opsiyonel. SMTP/IMAP için Gmail App Password; sistem giriş şifresi değildir. Firma için genelde tek Gmail sağlayıcısı yeter.",
        mailboxNoSecret: "Şifre yok",
        mailboxProvider: "Mail sağlayıcısı",
        mailboxProviderPick: "Sağlayıcı seçin",
        mailboxProviderRequired: "Sağlayıcı seçin",
        mailboxRemove: "Bağlantıyı kaldır",
        mailboxRemoveHint: "Kaydedince iş maili kutusu bu kullanıcıdan silinir.",
        mailboxSecret: "Gmail uygulama şifresi",
        mailboxSecretHint: "Yalnızca mail gönder/al için. Encryptor ile saklanır; API yanıtında dönmez. Giriş şifresiyle aynı değil.",
        mailboxSecretKeep: "Boş = mevcut şifre kalsın",
        mailboxSecretKeepHint: "Yeni App Password yazarsanız eskisi değişir; boş bırakırsanız secret korunur.",
        mailboxSecretPlaceholder: "Gmail App Password",
        mailboxSecretRequired: "Uygulama şifresi zorunlu",
        mailboxSignature: "İmza (HTML, opsiyonel)",
        mailboxTitle: "İş maili kutusu",
        role: "Rol",
        rolePick: "Rol seçin",
        roleRequired: "En az bir rol seçin",
        roleSearch: "Rol ara…",
        roleSelected: "{{count}} rol seçili",
        roles: "Roller"
      },
      noMatch: "Aramanıza uyan kullanıcı yok",
      passwordReset: "Geçici şifre e-posta ile gönderildi",
      resetBody: "\"{{name}}\" için geçici şifre oluşturulup e-posta gönderilecek; bir sonraki girişte parola değiştirmesi istenecek.",
      resetPassword: "Şifre sıfırla",
      resetTitle: "Şifre sıfırlansın mı?",
      searchPlaceholder: "Kullanıcı ara (ad, e-posta)…",
      subtitle: "Sistem kullanıcılarını, rollerini ve hesap durumlarını yönetin.",
      title: "Kullanıcılar",
      updated: "Kullanıcı güncellendi"
    },
    positions: {
      allDepartments: "Tüm departmanlar",
      columns: {
        actions: "İşlemler",
        department: "Departman",
        employees: "Personel",
        level: "Seviye",
        title: "Pozisyon"
      },
      count: "{{count}} / {{total}} pozisyon",
      create: "Pozisyon Ekle",
      created: "Pozisyon eklendi",
      deleteBody: "\"{{name}}\" pozisyonu silinecek.",
      deleteForceBody: "\"{{name}}\" pozisyonuna bağlı personel var. Onaylarsanız personeller pozisyondan ayrılır ve kayıt silinir.",
      deleteTitle: "Pozisyon silinsin mi?",
      deleteWarn: "Bu pozisyona bağlı personel var. Tekrar onaylayarak silebilirsiniz.",
      deleted: "Pozisyon silindi",
      empty: "Henüz pozisyon yok",
      form: {
        code: "Kod",
        confirmDepartmentChange: "Departman değişince bağlı personeller pozisyonsuz kalacak. Devam edilsin mi?",
        createTitle: "Pozisyon Ekle",
        department: "Departman",
        departmentPick: "Departman seçin",
        departmentRequired: "Departman seçimi zorunlu",
        description: "Açıklama",
        editTitle: "Pozisyonu Düzenle",
        hint: "Pozisyon unvanını, seviyesini ve bağlı olduğu departmanı belirleyin. Kod sistem tarafından üretilir.",
        level: "Seviye",
        title: "Pozisyon adı",
        titleRequired: "Pozisyon adı en az 2 karakter olmalı"
      },
      levels: {
        DIRECTOR: "Direktör",
        JUNIOR: "Junior",
        LEAD: "Lead",
        MANAGER: "Manager",
        MID: "Mid",
        SENIOR: "Senior"
      },
      detail: {
        columns: {
          email: "E-posta",
          name: "Ad Soyad"
        },
        employeesEmpty: "Bu pozisyona atanmış personel yok",
        employeesTitle: "Atanan Personeller ({{count}})",
        noDescription: "Açıklama eklenmemiş"
      },
      noMatch: "Aramanıza uyan pozisyon yok",
      searchPlaceholder: "Pozisyon ara (unvan, kod)…",
      subtitle: "Departmanlara bağlı pozisyonları ve atanan personelleri yönetin.",
      title: "Pozisyonlar",
      updated: "Pozisyon güncellendi"
    },
    detail: {
      addedCount: "{{count}} yetki eklendi",
      addedShort: "yetki eklendi",
      affectedUsers: "Etkilenecek kullanıcılar",
      backToRoles: "Rollere dön",
      changeSummary: "Değişiklik Özeti",
      confirmSave: "Onayla ve Kaydet",
      createdAt: "Oluşturulma",
      currentVersion: "Geçerli sürüm",
      discard: "Geri al",
      discardBody: "Kaydedilmemiş {{count}} yetki değişikliği silinecek ve matris son kaydedilen hâline dönecek. Onaylıyor musunuz?",
      discardTitle: "Değişiklikler geri alınsın mı?",
      editInfo: "Bilgileri düzenle",
      generalHint: "Rolün temel tanımı, kapsamı ve kullanım özeti",
      notFound: "Rol bulunamadı",
      removedCount: "{{count}} yetki kaldırıldı",
      removedShort: "yetki kaldırıldı",
      reviewAction: "Değişiklikleri İncele",
      reviewHint: "Aşağıdaki değişiklikler kaydedildiğinde role atanmış {{count}} kullanıcı yeni yetkileri anında alır. Onaylıyor musunuz?",
      reviewTitle: "Yetki Değişikliği Onayı",
      review: {
        absent: "Yok",
        columns: {
          after: "Yeni",
          before: "Önceki",
          permission: "Yetki"
        },
        present: "Var"
      },
      save: "Değişiklikleri Kaydet",
      saved: "Yetkiler kaydedildi",
      stats: {
        added: "Eklenecek",
        affected: "Etkilenen kullanıcı",
        changed: "Değişen yetki",
        removed: "Kaldırılacak"
      },
      tabs: {
        general: "Genel Bilgiler",
        history: "Değişiklik Geçmişi",
        permissions: "Yetkiler",
        users: "Atanan Kullanıcılar ({{count}})",
        version: "Sürüm Bilgisi"
      },
      title: "Rol Detayı • {{name}}",
      unsaved: "Henüz kaydedilmemiş değişiklikleriniz var.",
      createdBy: "Oluşturan",
      updatedBy: "Güncelleyen",
      versionHint: "İzin matrisi sürümü ve oluşturma / son güncelleme bilgileri",
      versionNote: "Sürüm yalnızca izin matrisi gerçekten değişince artar. Ad/açıklama değişimi updated_* alanlarını günceller; aynı izinlerle kayıt sürümü ve geçmişi değiştirmez."
    },
    form: {
      clearAll: "Temizle",
      createTitle: "Rol Oluştur",
      created: "Rol oluşturuldu",
      departments: "Departmanlar",
      description: "Açıklama",
      descriptionPlaceholder: "Rolün amacını ve sorumluluklarını kısaca açıklayın.",
      descriptionRequired: "Açıklama gerekli",
      descriptionTooLong: "Açıklama en fazla 500 karakter olabilir",
      editTitle: "Rolü Düzenle",
      hint: "Rolün bilgilerini, kapsamını, yetkilerini ve atanacak kullanıcıları belirleyin.",
      name: "Rol adı",
      namePlaceholder: "Örn. Proje Yöneticisi",
      nameRequired: "Rol adı en az 2 karakter olmalı",
      nameTooLong: "Rol adı en fazla 60 karakter olabilir",
      previewBody: "Bu rol kaydedildiğinde {{count}} kullanıcı etkilenecek ve {{permissions}} yetkiyi anında alacak.",
      previewEmpty: "Henüz kullanıcı seçilmedi. Rolü daha sonra da atayabilirsiniz.",
      previewTitle: "Güncelleme Önizlemesi",
      projects: "Projeler",
      scopeHint: "Rolün yetkileri yalnızca bu kapsamdaki veride geçerli olur (personel, projeler, görevler ve CRM müşterileri).",
      selectAll: "Tümünü seç",
      submitCreate: "Rol Oluştur",
      submitEdit: "Değişiklikleri Kaydet",
      systemNameLocked: "Sistem rollerinin adı değiştirilemez.",
      tabInfo: "Bilgiler",
      tabPermissions: "Yetkiler ({{count}})",
      tabUsers: "Kullanıcılar ({{count}})",
      targetsRequired: "En az bir seçim yapın",
      template: "Şablon",
      templateHint: "Hızlı başlangıç için mevcut bir rolün yetkilerini kopyalayabilirsiniz.",
      templateNone: "Yok (boş rol oluştur)",
      updated: "Rol güncellendi"
    },
    history: {
      actions: {
        ROLE_CREATE: "Rol oluşturuldu",
        ROLE_DELETE: "Rol silindi",
        ROLE_PERMISSIONS_UPDATE: "İzinler güncellendi",
        ROLE_UPDATE: "Rol bilgileri güncellendi",
        ROLE_USERS_UPDATE: "Kullanıcı atamaları güncellendi"
      },
      created: "Rol oluşturuldu",
      empty: "Henüz değişiklik kaydı yok",
      filters: {
        all: "Tümü",
        meta: "Meta",
        permissions: "İzinler",
        users: "Kullanıcılar"
      },
      next: "Sonraki",
      permissions: "Yetkiler güncellendi: +{{added}} / −{{removed}}",
      prev: "Önceki",
      status: "Durum değiştirildi: {{status}}",
      updated: "Rol bilgileri güncellendi",
      users: "Kullanıcı ataması güncellendi"
    },
    matrix: {
      allModules: "Tüm modüller",
      clearGroup: "Gruptakileri temizle",
      empty: "Aramaya uyan yetki yok",
      expandGroup: "Grubu aç",
      moduleColumn: "Modül / Yetki",
      notApplicable: "Bu kaynak için geçerli değil",
      search: "Modül veya yetki ara…",
      selectGroup: "Bu gruptakileri seç",
      toggle: "{{resource}} – {{action}}"
    },
    modules: {
      departments: "Departmanlar",
      documents: "Belgeler",
      finance: "Finans",
      personnel: "Personeller",
      projects: "Projeler",
      reports: "Raporlar"
    },
    moreCount: "+{{count}}",
    panel: {
      affectedHint: "Bu yetki, role atanmış {{count}} kullanıcıyı etkiler.",
      affectedUsers: "Etkilenen kullanıcılar",
      empty: "Ayrıntılarını görmek için matristen bir yetki seçin.",
      grant: "Ver",
      granted: "Verildi",
      noPrerequisites: "Ön koşul yok",
      noRestrictions: "Ek kısıtlama yok",
      notGranted: "Verilmedi",
      note: "Bu yetki yalnızca \"{{action}}\" işlemini kapsar. Diğer işlemler için ilgili yetkiler ayrıca verilmelidir.",
      prerequisiteMissing: "Ön koşul eksik: görüntüleme yetkisi olmadan bu yetki kullanılamaz.",
      prerequisites: "Ön koşullar",
      restrictionApproveOwn: "Kullanıcı kendi oluşturduğu kaydı onaylayamaz.",
      restrictionApproveRejected: "Reddedilmiş bir kayıt doğrudan onaylanamaz; önce yeniden incelemeye alınmalıdır.",
      restrictionDelete: "Silinen kayıtlar geri alınamaz; mümkünse arşivlemeyi tercih edin.",
      restrictionExport: "Dışa aktarılan dosyalar kişisel veri içerebilir; KVKK kurallarına uyulmalıdır.",
      restrictionSensitive: "Hassas işlem: her kullanım denetim kaydına yazılır.",
      restrictions: "Kısıtlamalar",
      sensitive: "Hassas",
      viewUsers: "Kullanıcıları görüntüle"
    },
    resources: {
      budget: "Bütçe",
      department: "Departman",
      document: "Personel belgesi",
      invoice: "Fatura",
      leave: "İzin talepleri",
      members: "Departman üyeleri",
      profile: "Personel profili",
      project: "Proje",
      report: "Rapor",
      salary: "Ücret bilgileri",
      task: "Proje görevi",
      template: "Belge şablonu"
    },
    roles: {
      actions: {
        activate: "Aktifleştir",
        assignUsers: "Kullanıcı Ata",
        deactivate: "Pasifleştir",
        delete: "Sil",
        edit: "Düzenle",
        more: "Diğer işlemler",
        openDetail: "Yetki matrisini aç"
      },
      columns: {
        actions: "İşlemler",
        description: "Açıklama",
        name: "Rol adı",
        permissions: "Yetki sayısı",
        scope: "Kapsam",
        status: "Durum",
        system: "Sistem",
        updated: "Son güncelleme",
        userCount: "Kullanıcı sayısı",
        users: "Kullanıcılar"
      },
      systemBadge: "Sistem",
      activateBody: "\"{{name}}\" rolü aktifleştirilecek. Bu role atanmış {{count}} kullanıcı rolün yetkilerini anında kullanmaya başlayacak. Onaylıyor musunuz?",
      activateTitle: "Rol aktifleştirilsin mi?",
      count: "{{count}} / {{total}} rol",
      create: "Rol Oluştur",
      deactivateBody: "\"{{name}}\" rolü pasifleştirilecek. Bu role atanmış {{count}} kullanıcı rolden gelen yetkilerini kaybedecek. Onaylıyor musunuz?",
      deactivateTitle: "Rol pasifleştirilsin mi?",
      deleteBody: "\"{{name}}\" rolü silinecek. Bu role atanmış {{count}} kullanıcı ilgili yetkileri kaybedecek. Bu işlem geri alınamaz.",
      deleteTitle: "Rol silinsin mi?",
      empty: "Henüz rol yok",
      emptyHint: "İlk rolü oluşturarak başlayın.",
      noMatch: "Aramanıza uyan rol yok",
      permissionCount: "{{count}} yetki",
      searchPlaceholder: "Rol ara…",
      statusChanged: "Rol durumu güncellendi",
      subtitle: "Kullanıcıların erişim haklarını rol bazlı yönetin. Roller; organizasyon, proje, departman veya kendi verisi kapsamında yetki tanımlar.",
      title: "Roller"
    },
    scope: {
      department: "Departman",
      departmentHint: "Sadece seçilen departmanlarda geçerlidir.",
      label: "Kapsam",
      organization: "Organizasyon",
      organizationHint: "Tüm organizasyon genelinde geçerlidir.",
      own: "Kendi verisi",
      ownHint: "Sadece kullanıcının kendi verisi üzerinde geçerlidir.",
      project: "Proje",
      projectHint: "Sadece seçilen projelerde geçerlidir."
    },
    status: {
      active: "Aktif",
      passive: "Pasif"
    },
    summary: {
      grantedOf: "{{granted}} / {{total}} yetki",
      noPermissions: "Bu modülde yetki verilmemiş",
      tabHistory: "Geçmiş",
      tabPermissions: "Yetkiler",
      tabUsers: "Kullanıcılar ({{count}})"
    },
    users: {
      alreadyAssigned: "Atanmış",
      assignHint: "Listedeki kullanıcılar bu role atanır; listede olmayanlar rolden çıkarılır. Başka rolü olanlar için onay istenir.",
      assignRole: "Atanacak rol",
      assignSubmit: "{{count}} kullanıcıyı kaydet",
      assignTitle: "Kullanıcı Ata · {{role}}",
      assigned: "Rol kullanıcıları güncellendi ({{count}})",
      columns: {
        assignedAt: "Atanma tarihi",
        department: "Departman",
        email: "E-posta",
        name: "Kullanıcı",
        position: "Pozisyon"
      },
      effectivePermissions: "Etkili yetkiler ({{count}})",
      empty: "Bu role atanmış kullanıcı yok",
      mergeHint: "Bu role halihazırda {{count}} kullanıcı atanmış. Yeni seçimler mevcut yetkilerle birleşir.",
      noPermissions: "Bu rolde henüz yetki yok",
      pickTitle: "Kullanıcı seç",
      previewTitle: "Atama özeti",
      reassign: {
        body: "Seçilen kullanıcıların mevcut rolleri değişecek. Onaylarsanız rolleri bu rolle değiştirilir.",
        confirm: "Onayla ve kaydet",
        currentRoles: "Mevcut roller: {{names}}",
        sessionHint: "Onaylarsanız etkilenen kullanıcıların oturumları 30 saniye içinde kapanır.",
        title: "Rol ataması onayı"
      },
      remove: "Rolden çıkar",
      removeBody: "{{name}}, \"{{role}}\" rolünden çıkarılacak ve bu rolden gelen tüm yetkilerini anında kaybedecek. Onaylıyor musunuz?",
      removeTitle: "Kullanıcı rolden çıkarılsın mı?",
      removed: "Kullanıcı rolden çıkarıldı",
      replaceHint: "Kayıt, seçili listeyi bu rolün kullanıcıları olarak yazar (replace). Listede olmayanlar bu rolden çıkarılır.",
      search: "Kullanıcı ara…",
      selectedTitle: "Seçilen kullanıcılar ({{count}})"
    }
  },
  account_id: "account id",
  me: {
    documents: {
      allDone: "Tamamlanması gereken belgeniz yok",
      download: "İndir",
      due: "Son tarih {{date}}",
      history: "Geçmiş",
      noDue: "Son tarih yok",
      open: "Tamamlamanız gerekenler ({{count}})",
      pendingHint: "Bu belgeler için İK henüz talep açmadı; talep açıldığında buradan yükleyebilirsiniz.",
      pendingRequests: "Sizden beklenen diğer belgeler",
      reupload: "Yeniden yükle",
      status: {
        awaiting_review: "İncelemede",
        cancelled: "İptal",
        completed: "Onaylandı",
        correction_requested: "Düzeltme istendi",
        open: "Bekliyor",
        waived: "Muaf"
      },
      subtitle: "Sizden istenen belgeler ve son tarihleri. PDF veya görsel olarak yükleyebilirsiniz.",
      title: "Belgelerim",
      upload: "Yükle",
      uploaded: "“{{name}}” yüklendi; inceleme bekliyor"
    }
  },
  account: {
    errors: {
      confirm: "Yeni parolayı tekrar girin",
      currentForEmail: "E-posta değişikliği için mevcut parolanızı girin",
      firstName: "Ad en az 2 karakter olmalı",
      lastName: "Soyad en az 2 karakter olmalı",
      phone: "Telefon numarası eksik; ör. +90 532 111 22 33",
      sameAsCurrent: "Yeni parola mevcut paroladan farklı olmalı",
      weak: "Parola aşağıdaki kuralların tümünü karşılamalı"
    },
    fields: {
      email: "E-posta",
      firstName: "Ad",
      lastName: "Soyad",
      phone: "Telefon"
    },
    passwordChanged: "Parolanız güncellendi. Güvenliğiniz için tüm oturumlar kapatıldı; yeni parolanızla giriş yapın.",
    otpSent: "Doğrulama kodu e-posta adresinize gönderildi. Kodu girerek parola değişikliğini onaylayın.",
    resendCode: "Kodu tekrar gönder",
    sendCode: "Doğrulama kodu gönder",
    profile: {
      emailNotice: "E-posta adresiniz giriş ve doğrulama kodları için kullanılır. Değişikliği onaylamak için mevcut parolanızı girin.",
      hrManaged: "Ad, soyad ve e-posta personel kaydınızdan (İK) yönetilir; değişiklik için İK ile iletişime geçin.",
      hint: "Ad, soyad, iletişim telefonu ve giriş e-postanız.",
      phoneHint: "İki adımlı doğrulama ve acil durum iletişimi için.",
      title: "Kişisel bilgiler"
    },
    reset: "Geri al",
    rules: {
      case: "Büyük ve küçük harf",
      digit: "En az bir rakam",
      length: "En az 8 karakter",
      symbol: "En az bir sembol (! ? . * vb.)"
    },
    save: "Değişiklikleri kaydet",
    saved: "Bilgileriniz güncellendi",
    savedEmail: "Bilgileriniz güncellendi; giriş e-postanız {{email}} oldu",
    security: {
      tip1: "Başka sitelerde kullandığınız bir parolayı kullanmayın.",
      tip2: "Parolanızı kimseyle paylaşmayın; destek ekibi parolanızı asla istemez.",
      tip3: "Şüpheli bir giriş fark ederseniz parolanızı hemen değiştirin.",
      tipsTitle: "Güvenli parola önerileri",
      title: "Parola değiştir"
    },
    strength: {
      fair: "Orta",
      good: "İyi",
      strong: "Güçlü",
      weak: "Zayıf"
    },
    subtitle: "Kişisel bilgilerinizi ve hesap güvenliğinizi yönetin.",
    tabs: {
      profile: "Kişisel bilgiler",
      security: "Güvenlik"
    },
    title: "Hesabım"
  },
  accounts: {
    columns: {
      created: "Oluşturma",
      email: "İş e-postası",
      install: "Kurulum",
      sales: "Satış aşaması",
      title: "Firma"
    },
    edit: "Hesabı düzenle",
    bindEmail: "E-posta bağla",
    bindEmailDone: "E-posta hesaba bağlandı",
    bindEmailHint: "Zaman çizelgesine bağlanacak posta kimliğini girin.",
    mailId: "Posta kimliği (mail_id)",
    exportCsv: "CSV dışa aktar",
    exportDone: "Dışa aktarma tamamlandı",
    exportXlsx: "Excel dışa aktar",
    form: {
      hint: "Firma bilgilerini girin.",
      titleRequired: "Firma adı gerekli"
    },
    loadMore: "Daha eski kayıtlar",
    new: "Yeni hesap",
    searchPlaceholder: "Firma adı, vergi no, e-posta…",
    subtitle: "Potansiyel ve mevcut müşteriler",
    tabs: {
      contacts: "Kişiler",
      entitlements: "Haklar",
      installations: "Kurulumlar",
      timeline: "Zaman çizelgesi"
    },
    taxId: "Vergi no",
    timelineFilter: "Tür filtresi",
    title: "Hesaplar"
  },
  admin: {
    categories: {
      active: "Aktif",
      add: "Kategori ekle",
      color: "Renk",
      deactivated: "Kullanımda olduğu için pasife alındı",
      deleteBody: "“{{name}}” kategorisi silinecek.",
      deleteInUse: "“{{name}}” {{count}} müşteride kullanılıyor; silinmez, pasife alınır.",
      deleteTitle: "Kategori kaldırılsın mı?",
      empty: "Kategori yok",
      inUse: "{{count}} müşteri",
      listTitle: "Kategoriler",
      name: "Kategori adı",
      saved: "Kategori kaydedildi",
      subtitle: "Müşterileri ilgi ve durumlarına göre ayırmak için kullanılan sınıflar (ör. Sıcak, İlgisiz, İstemiyor).",
      title: "Müşteri Kategorileri",
      tones: { danger: "Kırmızı", info: "Mavi", neutral: "Gri", primary: "Mor", success: "Yeşil", warning: "Turuncu" }
    },
    discounts: {
      add: "Limit tanımla",
      deleteBody: "“{{name}}” için iskonto limiti kaldırılacak.",
      deleteTitle: "Limit kaldırılsın mı?",
      empty: "Tanımlı iskonto limiti yok",
      emptyHint: "Limit tanımlanmadıkça teklif ve siparişlerde iskonto sınırlanmaz.",
      listTitle: "Tanımlı limitler",
      max: "Azami %",
      note: "Not",
      rule: "Teklif ve siparişte kişiye uyan limitlerin en düşüğü uygulanır (kişi limiti rol limitinin yerine geçer; proje ve müşteri limiti ayrıca sınar). Birim fiyat düşürme ve kalem iskontoları da orana dahildir. Limiti aşmak yalnız “İndirim limitini aşma” yetkisiyle mümkündür.",
      saved: "Limit kaydedildi",
      scope: "Kapsam",
      scopes: {
        account: "Müşteri",
        project: "Proje",
        role: "Rol",
        user: "Kişi"
      },
      subtitle: "Personelin teklif ve siparişte uygulayabileceği azami iskonto.",
      target: "Hedef",
      targetPlaceholder: "Seçin",
      title: "İskonto Limitleri"
    },
    common: {
      allStatuses: "Tüm durumlar",
      choose: "Seçin",
      count: "{{count}} kayıt",
      days: "{{count}} gün",
      exportCsv: "CSV indir",
      noMatch: "Filtrelere uyan kayıt yok",
      status: "Durum",
      updated: "Güncellendi: {{date}}"
    },
    audit: {
      actions: {
        approve: "Onay",
        create: "Oluşturma",
        delete: "Silme",
        export: "Dışa aktarım",
        login: "Giriş",
        permission: "Yetki değişikliği",
        reveal: "Hassas veri görüntüleme",
        update: "Güncelleme"
      },
      allActors: "Tüm kullanıcılar",
      allModules: "Tüm modüller",
      allSeverities: "Tüm önem düzeyleri",
      changes: "Değişiklikler",
      columns: {
        action: "Eylem",
        actor: "Kullanıcı",
        at: "Zaman",
        module: "Modül",
        summary: "Özet",
        target: "Kayıt"
      },
      detail: "Kayıt ayrıntısı",
      detailFor: "“{{summary}}” kaydının ayrıntısını göster",
      device: "Cihaz",
      kpi: {
        actors: "İşlem yapan kullanıcı",
        actorsHint: "Kayıtlı dönemde",
        critical: "Kritik olay (7 gün)",
        criticalHint: "Yalnız kritikleri göster",
        exports: "Dışa aktarım ve görüntüleme",
        exportsHint: "CSV, paylaşım ve maskeli veri",
        today: "Bugünkü olaylar",
        todayHint: "Toplam {{count}} kayıt"
      },
      modules: {
        access: "Roller ve yetkiler",
        auth: "Oturum",
        catalog: "Ürün kataloğu",
        crm: "Müşteri yönetimi",
        finance: "Finans",
        hr: "Personel",
        infra: "Altyapı",
        licensing: "Lisans",
        mail: "Mail",
        tax: "Vergi ve muhasebe"
      },
      openRecord: "Kayda git",
      search: "Kayıt, özet, kullanıcı ya da IP ara…",
      severities: {
        critical: "Kritik",
        info: "Bilgi",
        notice: "Dikkat"
      },
      severity: "Önem",
      subtitle: "Paneldeki tüm değişikliklerin, girişlerin ve hassas veri erişimlerinin değiştirilemez izi.",
      title: "Denetim kayıtları"
    },
    infra: {
      allProjects: "Tüm projeler",
      customerServer: "Müşteri sunucusu",
      noProjects: "Bu sunucuda çalışan proje yok",
      billingCycle: {
        monthly: "Aylık faturalama",
        yearly: "Yıllık faturalama"
      },
      contract: {
        billingCycle: "Faturalama dönemi",
        contractNo: "Sözleşme / müşteri no",
        editTitle: "Sözleşme bilgileri: {{name}}",
        hint: "Sağlayıcı planı, maliyet ve yenileme bilgileri; ödeme önerileri buradan hesaplanır.",
        monthlyCost: "Aylık maliyet",
        monthlyCostHint: "Yıllık faturalamada aylık karşılığı girin.",
        nextRenewalAt: "Sonraki yenileme",
        notes: "Notlar",
        plan: "Plan / paket",
        provider: "Sağlayıcı",
        startedAt: "Kullanıma başlama"
      },
      detail: {
        contract: "Sözleşme ve maliyet",
        hostname: "Ana bilgisayar adı",
        inUseFor: "Kullanım süresi",
        lastBackup: "Son yedek",
        monthlyCost: "Aylık maliyet",
        months: "{{count}} ay",
        noPlacements: "Bu sunucuda yerleşim yok",
        open: "Detay",
        openCustomer: "{{name}} müşteri kartını aç",
        os: "İşletim sistemi",
        pending: "Ödenmemiş",
        renewIn: "Yenileme {{date}} · {{count}} gün kaldı",
        renewLate: "Yenileme {{count}} gün gecikti",
        resources: "Kaynaklar",
        since: "{{date}} tarihinden beri kullanımda",
        tabs: {
          general: "Genel",
          payments: "Ödemeler",
          placements: "Yerleşimler ({{count}})",
          usage: "Kaynak Kullanımı"
        },
        technical: "Teknik bilgiler",
        thisYear: "Bu yıl {{amount}}",
        totalPaid: "Toplam ödenen",
        uptime: "Çalışma süresi",
        usageHint: "Son 30 günün günlük ortalama CPU, RAM ve disk doluluğu.",
        usageTitle: "Kaynak kullanımı (30 gün)"
      },
      payment: {
        add: "Ödeme Ekle",
        amount: "Tutar",
        amountRequired: "Geçerli bir tutar girin",
        createTitle: "Sunucu ödemesi ekle",
        dateRequired: "Ödenen kayıtta ödeme tarihi zorunlu",
        deleteBody: "{{invoice}} ödeme kaydı silinecek.",
        deleted: "Ödeme silindi",
        deleteTitle: "Ödeme silinsin mi?",
        editTitle: "Ödemeyi düzenle",
        empty: "Henüz ödeme kaydı yok",
        hint: "{{name}} · {{plan}} için dönem ödemesi.",
        invoiceNo: "Fatura no",
        markPaid: "Ödendi olarak işaretle",
        method: "Ödeme yöntemi",
        note: "Not",
        paidAt: "Ödeme tarihi",
        period: "Dönem",
        periodEnd: "Dönem bitişi",
        periodStart: "Dönem başlangıcı",
        status: {
          overdue: "Gecikmiş",
          paid: "Ödendi",
          pending: "Bekliyor"
        }
      },
      paymentMethod: {
        card: "Kredi kartı",
        transfer: "Havale / EFT"
      },
      perMonth: "/ ay",
      allEnvs: "Tüm ortamlar",
      allServers: "Tüm sunucular",
      backup: "Yedek: {{when}}",
      columns: {
        project: "Proje",
        actions: "İşlemler",
        customer: "Müşteri",
        db: "Veritabanı boyutu",
        url: "Adres",
        version: "Sürüm"
      },
      decommission: "Kaldır",
      decommissionBody: "{{url}} yerleşimi durdurulup verisi arşivlenecek. Bu işlem geri alınamaz.",
      decommissioned: "Yerleşim kaldırıldı",
      decommissionTitle: "Yerleşim kaldırılsın mı?",
      disk: "Disk",
      env: "Ortam",
      envs: {
        demo: "Demo",
        production: "Canlı",
        staging: "Test"
      },
      inMaintenance: "Bakımda",
      kpi: {
        alerts: "Uyarı",
        alertsOk: "Tüm sunucular normal",
        cpu: "Ortalama CPU",
        cpuHint: "Son 5 dakika",
        placements: "Çalışan yerleşim",
        placementsHint: "{{count}} canlı müşteri ortamı",
        servers: "Sağlıklı sunucu",
        serversHint: "Sağlıklı / toplam"
      },
      maintenanceOff: "Bakımdan çıkar",
      maintenanceOffBody: "{{name}} yeniden trafiğe açılacak.",
      maintenanceOffTitle: "Bakım modu kapatılsın mı?",
      maintenanceOn: "Bakıma al",
      maintenanceOnBody: "{{name}} üzerindeki {{count}} yerleşim bakım süresince salt okunur olacak. Müşterilere bildirim gönderilir.",
      maintenanceOnTitle: "Sunucu bakıma alınsın mı?",
      noBackup: "Yedek alınmıyor",
      placementCount: "{{count}} yerleşim",
      placements: "Yerleşimler",
      placementStatus: {
        decommissioned: "Kaldırıldı",
        running: "Çalışıyor",
        stopped: "Durduruldu"
      },
      roles: {
        backup: "Yedek",
        demo: "Demo",
        production: "Canlı",
        staging: "Test"
      },
      search: "Sunucu, adres, müşteri ya da IP ara…",
      server: "Sunucu",
      servers: "Sunucular",
      since: "{{date}} itibarıyla",
      start: "Başlat",
      status: {
        degraded: "Yüksek yük",
        down: "Erişilemiyor",
        healthy: "Sağlıklı",
        maintenance: "Bakımda"
      },
      stop: "Durdur",
      subtitle: "Sunucular ve müşteri yerleşimleri; kaynak kullanımı, yedek ve sürüm durumu.",
      title: "Altyapı",
      updateAvailable: "{{version}} mevcut",
      uptime: "{{count}} gündür açık"
    },
    mail: {
      allPurposes: "Tüm kullanım türleri",
      errorBanner: "{{count}} hesapta eşitleme hatası var",
      kpi: {
        accounts: "Bağlı hesap",
        accountsHint: "Toplam {{count}} hesap",
        sent: "Bugün gönderilen",
        sentHint: "Tüm hesaplardan",
        shared: "Ortak kutu",
        sharedHint: "{{count}} personel erişiyor",
        storage: "Kullanılan alan",
        storageHint: "{{total}} GB kotadan"
      },
      lastSync: "Son eşitleme {{when}}",
      members: "{{count}} üye",
      noMembers: "Yalnız sistem gönderimi",
      openMailbox: "Posta kutusuna git",
      pause: "Eşitlemeyi duraklat",
      providerAdd: "Sağlayıcı ekle",
      providerCreated: "Mail sağlayıcısı eklendi",
      providerDefault: "Varsayılan",
      providerKind: "Tür",
      providerKinds: {
        google: "Gmail / Google Workspace",
        smtp_imap: "SMTP + IMAP (elle)",
        smtp_relay: "SMTP relay (sistem maili)"
      },
      providerName: "Ad",
      providers: {
        google: "Google Workspace",
        imap: "IMAP/SMTP",
        microsoft: "Microsoft 365"
      },
      providersEmpty: "Henüz sağlayıcı yok. Gmail için bir tane eklemeniz yeter.",
      providersGoogleHint: "Herkes Gmail kullanıyorsa tek google sağlayıcısı yeter; App Password kullanıcı kutusunda tutulur.",
      providersHint: "Host/port tanımı. Personel App Password’leri burada değil, kullanıcı kutusunda şifreli saklanır.",
      providersTitle: "Mail sağlayıcıları",
      purpose: "Kullanım",
      purposes: {
        personal: "Kişisel",
        shared: "Ortak kutu",
        system: "Sistem"
      },
      quota: "Kota {{used}} / {{total}} GB",
      reconnect: "Yeniden bağla",
      resume: "Eşitlemeyi sürdür",
      search: "Adres, ad ya da üye ara…",
      sendLimit: "Bugün {{sent}} / {{limit}} gönderim",
      status: {
        connected: "Bağlı",
        error: "Hata",
        paused: "Duraklatıldı"
      },
      subtitle: "Kurumsal posta hesapları, ortak kutu üyeleri, kota ve gönderim limitleri.",
      sync: "Eşitle",
      synced: "Hesap eşitlendi",
      title: "Mail hesapları"
    },
    pipelines: {
      avgVsSla: "Ort. {{avg}} gün · SLA {{sla}}",
      closingHint: "Kapanış aşamaları sabittir; yalnız ad ve zorunlu alanlar düzenlenebilir.",
      closingTitle: "Kapanış aşamaları",
      copyDefaults: "Varsayılanları yükle",
      editStage: "{{name}} aşamasını düzenle",
      editTitle: "Aşama: {{name}}",
      fixedHint: "Kapanış aşamasında sabittir",
      flowTitle: "Akış ve darboğazlar",
      invalid: "Olasılık 0–100, SLA 1–365 arasında tam sayı olmalı",
      kinds: {
        install: "Kurulum hattı",
        sales: "Satış hattı"
      },
      kpi: {
        cycle: "Ortalama döngü",
        cycleHint: "Açık aşamalarda geçen ortalama süre",
        open: "Açık kayıt",
        openHint: "{{count}} açık aşamada",
        sla: "SLA aşımı",
        slaOk: "Tüm aşamalar süre içinde",
        steps: "Kurulum adımı",
        stepsHint: "Canlıya geçişe kadar",
        weighted: "Ağırlıklı fırsat değeri",
        weightedHint: "Tutar × aşama olasılığı"
      },
      moveDown: "{{name}} aşamasını aşağı taşı",
      moveUp: "{{name}} aşamasını yukarı taşı",
      name: "Aşama adı",
      noRequired: "Zorunlu alan yok",
      noSla: "SLA yok",
      openBoard: "Satış panosu",
      openDelivery: "Demo ve kurulum",
      outcome: {
        lost: "Kayıp",
        open: "Açık",
        won: "Kazanım"
      },
      probability: "Olasılık (%)",
      required: "Geçiş için: {{fields}}",
      requiredFields: "Zorunlu alanlar",
      requiredHint: "Virgülle ayırın; aşamaya geçerken doldurulması istenir.",
      resetBody: "{{pipeline}} için tüm aşama ayarları varsayılana dönecek. Mevcut kayıtların aşaması değişmez.",
      resetTitle: "Varsayılan aşamalar yüklensin mi?",
      sla: "SLA (gün)",
      slaBreach: "Ortalama süre SLA'yı aşıyor",
      slaDays: "SLA {{count}} gün",
      slaHint: "Boş bırakılırsa süre takibi yapılmaz.",
      stagesTitle: "Aşama sırası ve kuralları",
      subtitle: "Satış ve kurulum hatlarının aşamaları, olasılıkları ve süre (SLA) kuralları.",
      title: "Satış aşamaları"
    },
    regions: {
      activeHint: "Pasif bölgeler müşteri formunda seçilemez.",
      activeLabel: "Bölge aktif",
      cities: "İller",
      citiesHint: "Virgülle ayırın, örn. İzmir, Aydın",
      code: "Kod",
      customers: "Müşteri",
      deals: "Açık fırsat",
      edit: "Bölgeyi düzenle",
      editFor: "{{name}} bölgesini düzenle",
      empty: "Henüz bölge tanımlanmadı",
      inactive: "Pasif",
      invalidTarget: "Hedef geçerli bir tutar olmalı",
      kpi: {
        active: "Aktif bölge",
        activeHint: "{{count}} il kapsanıyor",
        customers: "Bölgedeki müşteri",
        customersHint: "{{count}} tanesi canlıda",
        pipeline: "Açık fırsat değeri",
        pipelineHint: "{{count}} açık fırsat",
        target: "Çeyrek hedef gerçekleşme",
        targetHint: "{{actual}} / {{target}}"
      },
      live: "Canlıda",
      manager: "Sorumlu: {{name}}",
      managerLabel: "Bölge sorumlusu",
      name: "Ad",
      new: "Yeni bölge",
      noTarget: "Bu çeyrek için hedef tanımlı değil",
      pipeline: "Açık fırsat: {{value}}",
      quarter: "4. çeyrek satış hedefi",
      search: "Bölge, il ya da sorumlu ara…",
      showCustomers: "Müşterileri gör",
      subtitle: "Satış ve erişim bölgeleri; müşteri dağılımı, sorumlular ve çeyrek hedefleri.",
      targetLabel: "Çeyrek hedefi (₺)",
      title: "Bölgeler"
    },
  },
  app: {
    name: "Ürünver",
    product: "Control Plane",
    tagline: "Müşteri, lisans ve operasyon yönetimi"
  },
  auth: {
    idle: {
      title: "Oturumunuz kapanmak üzere",
      body: "Bir süredir işlem yapmadınız. {{time}} içinde oturumunuz güvenlik için kapanacak.",
      stay: "Oturuma devam et"
    },
    changePassword: {
      confirm: "Yeni parola (tekrar)",
      current: "Mevcut parola",
      mismatch: "Parolalar eşleşmiyor",
      next: "Yeni parola",
      submit: "Parolayı güncelle",
      subtitle: "Devam etmeden önce yeni bir parola belirlemeniz gerekiyor.",
      title: "Parolanızı değiştirin",
      tooShort: "Parola en az 8 karakter olmalı",
      voluntarySubtitle: "Hesap güvenliğiniz için parolanızı güncelleyin."
    },
    permissionsChanged: {
      body: "Menü ve yetkileriniz yenilendi. Oturumunuz açık kalır.",
      title: "Yetkileriniz güncellendi"
    },
    sessionEnding: {
      hint: "Rolünüz değişti. Süre dolunca oturumunuz kapanacak.",
      logoutNow: "Şimdi oturumu kapat",
      roleHint: "\"{{role}}\" rol atamanız değişti. Süre dolunca oturumunuz kapanacak.",
      title: "Oturum kapanıyor"
    },
    email: "E-posta",
    forgot: "Parolamı unuttum",
    forgotTitle: "Parola sıfırlama",
    forgotSubtitle: "E-posta adresinize doğrulama kodu ve anahtar gönderilir.",
    forgotSubmit: "Kod gönder",
    forgotSentTitle: "E-posta gönderildi",
    forgotSentBody: "Hesap varsa sıfırlama kodu ve doğrulama anahtarı e-posta adresinize iletildi. Gelen kutunuzu kontrol edin.",
    resetContinue: "Kodu gir ve sıfırla",
    resetTitle: "Yeni parola belirleyin",
    resetSubtitle: "E-postadaki doğrulama anahtarı, 6 haneli kod ve yeni parolanızı girin.",
    resetToken: "Doğrulama anahtarı",
    resetTokenRequired: "Doğrulama anahtarı gerekli",
    resetSubmit: "Parolayı sıfırla",
    resetDoneTitle: "Parola güncellendi",
    resetDoneBody: "Yeni parolanızla giriş yapabilirsiniz.",
    invalidEmail: "Geçerli bir e-posta girin",
    otp: "Kod",
    otpInvalid: "Kod 6 haneli olmalı",
    otpSubtitle: "{{email}} adresine gönderilen 6 haneli kodu girin. Kod 5 dakika geçerlidir.",
    rememberDevice: "Bu cihazı 30 gün hatırla",
    rememberDeviceHint: "Bu cihazdan girişte 30 gün boyunca yalnız şifre sorulur. Ortak kullanılan bilgisayarlarda işaretlemeyin. Şifreniz değişirse hatırlama sona erer.",
    otpTitle: "Doğrulama kodu",
    password: "Parola",
    passwordRequired: "Parola gerekli",
    profile: "Hesabım",
    security: "Güvenlik bildirimi: tüm girişler e-posta koduyla doğrulanır ve denetim kaydına yazılır.",
    signOut: "Oturumu kapat",
    submit: "Devam et",
    subtitle: "Kurumsal hesabınızla devam edin",
    title: "Oturum açın",
    useOther: "Farklı hesapla giriş",
    verify: "Doğrula ve giriş yap",
    sessionEnded: "Oturumunuz sona erdi. Lütfen yeniden giriş yapın.",
    welcome: "Tekrar hoş geldiniz",
    emailPlaceholder: "ad.soyad@urunver.com.tr",
    showPassword: "Parolayı göster",
    hidePassword: "Parolayı gizle",
    steps: { label: "Giriş adımları", credentials: "Hesap bilgileri", verify: "Doğrulama" },
    brand: {
      subtitle: "Mühendislik Kontrol Paneli",
      badge: "Ürünver Control Plane",
      headline: "Tüm operasyonunuz tek bir panelde.",
      description: "Müşteri, lisans, kurulum ve ekip süreçlerinizi tek yerden, güvenle ve uçtan uca yönetin.",
      features: {
        customers: { title: "Müşteri ve satış yönetimi", body: "Hesaplar, görüşmeler, teklif ve yenilemeler" },
        licensing: { title: "Lisans ve kurulum takibi", body: "İmzalı lisanslar, kurulum sağlığı ve sürümler" },
        security: { title: "Kurumsal güvenlik", body: "E-posta kodlu doğrulama ve denetim kaydı" }
      },
      copyright: "© {{year}} Ürünver. Tüm hakları saklıdır."
    }
  },
  before: "before",
  board_id: "board id",
  common: {
    error: "İşlem tamamlanamadı",
    total: "Toplam",
    all: "Tümü",
    list: {
      next: "Sonraki sayfa",
      page: "{{page}} / {{pages}}",
      pageSize: "Sayfa boyutu",
      perPage: "{{count}} / sayfa",
      prev: "Önceki sayfa",
      range: "{{total}} kayıttan {{from}}–{{to}} arası"
    },
    back: "Geri",
    cancel: "Vazgeç",
    close: "Kapat",
    collapseNav: "Menüyü daralt",
    comingSoon: "Yakında",
    comingSoonBody: "Bu ekran sıradaki tasarım adımında eklenecek. API uçları Control Plane tarafında hazır.",
    confirm: "Onayla",
    ok: "Tamam",
    days: "{{count}} gün",
    edit: "Düzenle",
    empty: "Kayıt bulunamadı",
    expandNav: "Menüyü genişlet",
    mainNav: "Ana menü",
    menu: "Menü",
    notifications: "Bildirimler",
    overdue: "Gecikmiş",
    noComparison: "Önceki dönem verisi yok",
    retry: "Tekrar dene",
    rowActions: "{{name}} için işlemler",
    vsPrevMonth: "Geçen aya göre",
    save: "Kaydet",
    saved: "Kaydedildi",
    search: "Ara",
    searchPlaceholder: "Hesap, görev, sayfa ara…",
    select: "Seçin",
    seeAll: "Tümünü gör",
    theme: {
      dark: "Koyu tema",
      light: "Açık tema",
      system: "Sistem teması"
    },
    themeToggle: "Tema",
    loading: "Yükleniyor…",
    none: "Yok",
    today: "Bugün",
    clear: "Temizle",
    datePlaceholder: "Tarih seçin",
    timePlaceholder: "Saat seçin",
    timeHint: "Saat ve dakika",
    hour: "Saat",
    minute: "Dk",
    phonePlaceholder: "+90 5XX XXX XX XX",
    numberPlaceholder: "0",
    prevMonth: "Önceki ay",
    nextMonth: "Sonraki ay",
    add: "Ekle",
    delete: "Sil",
    deleted: "Silindi",
    noOptions: "Seçenek bulunamadı",
    selectSearch: "Ara…",
    useValue: "“{{value}}” kullan",
  },
  confirm: {
    entitlementPerpetual: {
      body: "\"{{code}}\" kalemi kalıcı hâle getirilecek ve bitiş tarihi kaldırılacak. Onaylıyor musunuz?",
      title: "Kalıcıya çevrilsin mi?"
    },
    followupComplete: {
      body: "Bu takip tamamlandı olarak işaretlenecek ve açık takipler arasından çıkacak. Onaylıyor musunuz?",
      title: "Takip tamamlansın mı?"
    },
    installationImport: {
      body: "\"{{file}}\" dosyasındaki imzalı sertifikalar bu kuruluma içe aktarılacak. Onaylıyor musunuz?",
      title: "Sertifikalar içe aktarılsın mı?"
    },
    licenseImport: {
      body: "\"{{file}}\" dosyasındaki imzalı lisans paketi içe aktarılacak ve ilgili lisanslar güncellenecek. Onaylıyor musunuz?",
      title: "Lisans paketi içe aktarılsın mı?"
    },
    mailDeleteForever: {
      body: "{{count}} e-posta kalıcı olarak silinecek; Gmail'deki kopyası da silinir. Bu işlem geri alınamaz.",
      confirm: "Kalıcı olarak sil",
      title: "E-posta kalıcı olarak silinsin mi?"
    },
    mailSpam: {
      body: "{{count}} e-posta spam klasörüne taşınacak. Spam klasöründen gelen kutusuna geri alabilirsiniz.",
      confirm: "Spam olarak işaretle",
      title: "Spam olarak işaretlensin mi?"
    },
    mailTrash: {
      body: "{{count}} e-posta çöp kutusuna taşınacak. Çöp kutusundan geri alabilir ya da kalıcı olarak silebilirsiniz.",
      confirm: "Çöp kutusuna taşı",
      title: "E-posta silinsin mi?"
    },
    mailGroupDelete: {
      body: "\"{{name}}\" grubu silinecek. Gruptaki e-postalar silinmez, yalnızca bu gruptan çıkarılır.",
      title: "Grup silinsin mi?"
    },
    orderFinalize: {
      body: "Teklif kesinleştirilecek ve bir sonraki aşamaya geçecek. Onaylıyor musunuz?",
      title: "Teklif kesinleştirilsin mi?"
    },
    belgeDelete: {
      body: "\"{{name}}\" belgesi personel dosyasından kaldırılacak. Onaylıyor musunuz?",
      title: "Belge silinsin mi?"
    },
    bordroCreate: {
      body: "Bu dönem bordrosu olmayan {{n}} personel için taslak bordro oluşturulacak. Onaylıyor musunuz?",
      title: "Bordro taslakları oluşturulsun mu?"
    },
    odemeDelete: {
      body: "{{name}} için {{amount}} tutarındaki ödeme kaydı silinecek. Onaylıyor musunuz?",
      title: "Ödeme silinsin mi?"
    },
    odemePayAll: {
      body: "{{n}} planlı ödeme ödendi olarak işaretlenecek. Onaylıyor musunuz?",
      title: "Ödemeler tamamlansın mı?"
    },
    personelDelete: {
      body: "\"{{name}}\" personel kaydı listeden kaldırılacak. Bu işlem geri alınamaz.",
      title: "Personel kaydı silinsin mi?"
    },
    taskArchive: {
      body: "\"{{title}}\" görevi arşivlenecek ve panodan kaldırılacak. Onaylıyor musunuz?",
      title: "Görev arşivlensin mi?"
    },
    templatePageDelete: {
      body: "\"{{name}}\" sayfası, içindeki tüm bölüm ve alanlarla birlikte silinecek. Onaylıyor musunuz?",
      title: "Sayfa silinsin mi?"
    },
    templateSectionDelete: {
      body: "\"{{name}}\" bölümü, içindeki tüm alan ve içeriklerle birlikte silinecek. Onaylıyor musunuz?",
      title: "Bölüm silinsin mi?"
    },
    ticketStatus: {
      body: "\"{{title}}\" talebinin durumu \"{{from}}\" yerine \"{{to}}\" olarak değiştirilecek. Onaylıyor musunuz?",
      title: "Talep durumu değiştirilsin mi?"
    },
    uploadRemove: {
      body: "Yüklenen \"{{name}}\" dosyası kaldırılacak. Onaylıyor musunuz?",
      title: "Dosya kaldırılsın mı?"
    }
  },
  contacts: {
    columns: {
      email: "E-posta",
      fullName: "fullName",
      name: "Ad",
      phone: "phone",
      primary: "primary",
      title: "Unvan"
    },
    delete: "delete",
    deleteConfirm: "deleteConfirm",
    edit: "edit",
    empty: "Kişi yok",
    fields: {
      email: "E-posta",
      full_name: "Ad soyad",
      phone: "Telefon",
      title: "Unvan"
    },
    form: {
      fullNameRequired: "fullNameRequired",
      hint: "hint"
    },
    new: "Yeni kişi",
    primary: "Birincil",
    title: "title"
  },
  csv: "csv",
  crm: {
    footprint: {
      title: "Altyapı ve modüller",
      empty: "Bu müşteri için kayıtlı modül ya da sunucu yerleşimi yok",
      emptyHint: "Sunucu yerleşimleri Yönetim › Altyapı'dan eklenir; lisanslı modüller siparişten gelir.",
      modules: "Lisanslı modüller ve çalıştığı yer",
      until: "{{date}} tarihine kadar",
      notPlaced: "Yerleşim yok",
      noModules: "Modül eşlenmemiş",
      unplacedDomains: "Sunucuya bağlanmamış domainler",
      editModules: "Modülleri düzenle",
      editTitle: "{{server}} · çalışan modüller",
      editHint: "Bu sunucu yerleşiminde çalışan lisanslı modülleri işaretleyin.",
      noLicensedModules: "Müşterinin lisanslı modülü yok",
      saved: "Modül eşlemesi kaydedildi",
      env: {
        production: "Canlı",
        demo: "Demo",
        staging: "Test"
      },
      status: {
        to_decommission: "Kaldırılacak",
        paused: "Durduruldu"
      }
    },
    access: {
      title: "Müşteri erişim talepleri",
      subtitleOwn: "Yetkiniz dışındaki bir müşteriyi görmeniz gerekiyorsa gerekçesiyle süreli erişim isteyin.",
      subtitleApprover: "Kapsam dışı müşteri erişim taleplerini onaylayın; süren erişimleri ve bu sürede yapılanları izleyin.",
      new: "Erişim talep et",
      listTitle: "Talepler",
      everyone: "Tümü",
      mine: "Taleplerim",
      empty: "Bu görünümde talep yok",
      filter: {
        pending: "Bekleyen",
        active: "Süren",
        expired: "Süresi dolan",
        rejected: "Reddedilen",
        revoked: "Geri alınan",
        all: "Tümü"
      },
      status: {
        pending: "Onay bekliyor",
        active: "Erişim açık",
        expired: "Süresi doldu",
        rejected: "Reddedildi",
        revoked: "Geri alındı",
        cancelled: "Geri çekildi"
      },
      durations: {
        "60": "1 saat",
        "480": "8 saat",
        "1440": "1 gün",
        "4320": "3 gün",
        "10080": "7 gün"
      },
      method: {
        GET: "Görüntüleme",
        POST: "Ekleme",
        PUT: "Düzenleme",
        PATCH: "Düzenleme",
        DELETE: "Silme"
      },
      requestTitle: "Müşteri erişimi talep et",
      requestHint: "Talep yetkili yöneticiye gider. Onaylanırsa müşteri seçtiğiniz süre boyunca görünür; süre dolunca erişim kendiliğinden kapanır. Erişim süresince yaptıklarınız kayıt altındadır.",
      customer: "Müşteri",
      thisCustomer: "Bu müşteri",
      searchPlaceholder: "Müşteri adı ya da VKN/TCKN",
      searchHint: "En az 3 karakter yazın; yalnızca göremediğiniz müşteriler listelenir.",
      noResults: "Eşleşen kapsam dışı müşteri yok",
      pickCustomer: "Bir müşteri seçin",
      alreadyPending: "Talebiniz bekliyor",
      reason: "Gerekçe",
      reasonPlaceholder: "Bu müşteriyi neden görmeniz gerekiyor? (ör. teklif hazırlığı, destek talebi, devir)",
      reasonRequired: "Gerekçe en az 10 karakter olmalı",
      duration: "Süre",
      durationHint: "İşiniz için gereken en kısa süreyi seçin.",
      shortenHint: "Talep edilen süreyi yalnızca kısaltabilirsiniz.",
      send: "Talebi gönder",
      requested: "Erişim talebiniz gönderildi",
      requestedBy: "{{name}} · {{at}}",
      decidedBy: "Karar: {{name}} · {{at}}",
      until: "Bitiş: {{at}}",
      revokedAt: "Geri alındı: {{at}}",
      decisionNote: "Açıklama",
      approve: "Onayla",
      reject: "Reddet",
      revoke: "Erişimi geri al",
      withdraw: "Geri çek",
      cancelled: "Talep geri çekildi",
      activity: "Yapılanlar",
      approveTitle: "Erişim onaylansın mı?",
      approveBody: "{{name}}, {{customer}} müşterisini seçilen süre boyunca görebilecek.",
      approveDone: "Erişim onaylandı",
      rejectTitle: "Talep reddedilsin mi?",
      rejectBody: "{{name}} adlı personelin {{customer}} için talebi reddedilecek.",
      rejectDone: "Talep reddedildi",
      revokeTitle: "Erişim geri alınsın mı?",
      revokeBody: "{{name}} adlı personelin {{customer}} erişimi hemen kapanacak.",
      revokeDone: "Erişim geri alındı",
      noteRequiredLabel: "Açıklama (zorunlu)",
      noteOptionalLabel: "Not (isteğe bağlı)",
      noteRequired: "Açıklama yazın",
      activityTitle: "{{customer}} · erişim süresince yapılanlar",
      activityHint: "{{name}} adlı personelin onaylı erişim süresince bu müşteride görüntüleme dahil yaptığı işlemler.",
      activityEmpty: "Bu sürede kayıtlı işlem yok",
      forbiddenTitle: "Bu müşteriyi görüntüleme yetkiniz yok",
      forbiddenHint: "Müşteri yetki kapsamınız dışında ya da kaldırılmış olabilir. İşiniz için gerekiyorsa süreli erişim isteyebilirsiniz.",
      quote: {
      formHint: "Kalemleri projenin modüllerinden seçin; modül dışı işleri açıklamasıyla ek iş kalemi olarak ekleyin. Teklif kaydedildikten sonra onaya gönderilir.",
      reviseTitle: "{{number}} — revizyon {{rev}}",
      reviseApprovedHint: "Onaylı teklif düzenlenince taslağa döner ve yeniden onay gerekir.",
      saveRevision: "Revizyonu kaydet",
      revised: "Yeni revizyon kaydedildi",
      project: "Proje",
      projectHint: "Kalemler bu projenin modüllerinden; taslak projeler de seçilebilir.",
      noProject: "Müşterinin projesi",
      pickProject: "Önce proje seçin",
      addModule: "Modül ekle",
      noModules: "Eklenecek modül kalmadı",
      addExtra: "Ek iş kalemi",
      extraDescription: "Ek iş açıklaması (zorunlu)",
      lineDiscount: "Kalem iskontosu",
      lineInvalid: "Kalemlerde fiyat ve adet girin; ek iş kaleminin açıklaması en az 3 karakter olmalı.",
      limitHint: "İskonto sınırınız %{{max}}; aşarsa yönetici/firma sahibi onayı gerekir.",
      reason: "Değişiklik açıklaması",
      reasonHint: "Bu revizyonda ne değişti ve neden (zorunlu; geçmişte görünür).",
      reasonRequired: "Açıklama zorunlu",
      previewTotal: "Tahmini toplam {{total}} (KDV hariç); kesin tutarı sunucu hesaplar.",
      flowTitle: "{{number}} teklif süreci",
      flowHint: "Her değişiklik yeni revizyondur. İskonto personel sınırını aşarsa yönetici, her durumda firma sahibi onaylar; onaylı revizyon gönderilebilir.",
      openFlow: "Süreç",
      revision: "Rev. {{rev}}",
      final: "Nihai teklif",
      tier: { staff: "İskonto %{{pct}} · sınır içinde", manager: "İskonto %{{pct}} · yönetici onayı", owner: "İskonto %{{pct}} · firma sahibi kademesi" },
      approvedBy: "Onaylayan: {{name}} · {{at}}",
      status: {
        taslak: "Taslak", manager_review: "Yönetici onayında", owner_review: "Firma sahibi onayında", approved: "Onaylandı", sent: "Gönderildi",
        negotiation: "Pazarlıkta", final: "Kesinleşmiş", accepted: "Kabul edildi", rejected: "Reddedildi"
      },
      revise: "Revize et",
      document: "Belge",
      showPrices: "Kalem fiyatlarını göster",
      hidePrices: "Kalem fiyatlarını gizle",
      showPricesTitle: "Kalem fiyatları gösterilsin mi?",
      showPricesBody: "Varsayılan olarak müşteriye yalnız toplam fiyat gösterilir. Kalem fiyatlarını açmak için gerekçe yazın; değişiklik geçmişte tutulur.",
      hidePricesTitle: "Kalem fiyatları gizlensin mi?",
      hidePricesBody: "Belgede yalnız toplam fiyat görünecek. Gerekçe yazın; değişiklik geçmişte tutulur.",
      pricesChanged: "Fiyat görünürlüğü güncellendi",
      send: "Müşteriye gönder",
      submit: "Onaya gönder",
      markFinal: "Nihai teklif olarak işaretle",
      submitted: "Onaya gönderildi",
      submitNote: "Onaylayıcıya not (isteğe bağlı)",
      decisionNote: "Karar notu (düzenleme isteği ve redde zorunlu)",
      negotiationNote: "Müşterinin karşı teklifi / itirazı",
      requestChanges: "Düzenleme iste",
      reject: "Reddet",
      approveManager: "Yönetici olarak onayla",
      approveOwner: "Onayla (son hali bu)",
      decideHint: "Gerekirse önce kendiniz revize edip ardından onaylayabilirsiniz; tüm kararlar notlarıyla geçmişe yazılır.",
      changesRequested: "Düzenleme istendi",
      rejected: "Teklif reddedildi",
      approved: "Onaylandı",
      negotiate: "Pazarlık notu ekle",
      negotiationSaved: "Pazarlık notu kaydedildi",
      tabs: { process: "Süreç", revisions: "Revizyonlar ({{count}})", sends: "Gönderimler ({{count}})", visibility: "Fiyat görünürlüğü" },
      system: "Sistem",
      commentKind: { comment: "Yorum", negotiation: "Pazarlık", decision: "Karar", system: "Kayıt" },
      commentPlaceholder: "Yorum yazın (firma sahibi, yönetici ve personel görür)",
      comment: "Gönder",
      commented: "Yorum eklendi",
      approvedRev: "Onaylı",
      diff: { added: "Eklendi", removed: "Çıkarıldı", changed: "Değişti" },
      diffField: { discount_percent: "Genel iskonto %", total: "Toplam", valid_until: "Geçerlilik", notes: "Notlar", show_line_prices: "Kalem fiyatları" },
      sentTo: "Alıcı: {{to}} · CC: {{cc}}",
      noSends: "Henüz gönderilmedi.",
      pricesShown: "Kalem fiyatları açıldı",
      pricesHidden: "Kalem fiyatları gizlendi",
      noVisibility: "Değişiklik yok.",
      sendTitle: "Teklifi e-postayla gönder",
      sendHint: "E-posta sizin şirket posta kutunuzdan gider; teklif belgesi eklenir. Tüm firma sahipleri CC'ye otomatik eklenir ve kaldırılamaz.",
      to: "Alıcılar",
      badEmail: "Geçersiz e-posta adresi var.",
      ownersCc: "Firma sahipleri (CC, zorunlu)",
      ownersCcHint: "Bu adresler her gönderimde CC'dedir.",
      extraCc: "Ek CC",
      subject: "Konu",
      message: "Mesaj",
      attachment: "Ek",
      sent: "Teklif gönderildi",
      template: "Teklif şablonu",
      templateHint: "Teklif belgesinin başlığı, giriş metni, koşullar ve altbilgisi; gönderim e-postasının konusu ve metni; yönetici onay sınırı.",
      tpl: {
        title: "Belge başlığı",
        managerMax: "Yönetici iskonto sınırı (%)",
        managerMaxHint: "Personel sınırını aşan iskonto bu orana kadar yönetici, üstünde firma sahibi kademesine gider.",
        intro: "Giriş metni",
        terms: "Koşullar",
        footer: "Altbilgi",
        mailSubject: "E-posta konusu",
        mailBody: "E-posta metni",
        vars: "Değişkenler: {teklif_no}, {musteri}, {gecerlilik}, {toplam}",
        signatures: "Belgede imza alanları"
      },
      templateSaved: "Şablon kaydedildi"
    },
    expenses: {
      pageTitle: "Müşteri giderleri",
      pageSubtitle: "Müşteri adına yapılan harcamalar: fiş/dekontla girilir, firma sahibi onaylar; nakit ve şahsi kart giderleri personele geri ödenir.",
      new: "Gider ekle",
      newTitle: "Müşteri gideri",
      editTitle: "Gideri düzenle",
      detail: "Gider",
      formHint: "Açıklama ve en az bir fiş/dekont onaya göndermek için zorunludur. Onaylanan nakit ve şahsi kart giderleri size geri ödenir; şirket kartı gideri kartın harcaması olarak işlenir.",
      views: { mine: "Giderlerim", approval: "Onay bekleyenler", all: "Tümü", legacy: "Aktarılmamış önceki kayıtlar" },
      customer: "Müşteri",
      title: "Gider",
      titlePlaceholder: "Örn. Müşteriyle öğle yemeği",
      category: "Kategori",
      categories: { yemek: "Yemek", ulasim: "Ulaşım", konaklama: "Konaklama", hediye: "Hediye", temsil: "Temsil / ağırlama", diger: "Diğer" },
      amount: "Tutar",
      spentOn: "Harcama tarihi",
      paymentMethod: "Ödeme şekli",
      methods: { cash: "Nakit", personal_card: "Şahsi kart", company_card: "Şirket kartı", advance: "İş avansı" },
      methodHints: { cash: "Kendi nakdinizle; size geri ödenir", personal_card: "Kendi kartınızla; size geri ödenir", company_card: "Size zimmetli şirket kartıyla", advance: "Kasadan aldığınız avanstan düşülür" },
      advanceBalance: "Açık avansınız: {{amount}}",
      advanceExceeds: "Tutar avans bakiyenizi aşıyor; aşan {{amount}} size geri ödenir.",
      advanceNote: "Bu gider iş avansınızdan düşüldü (Finans → İş Avansları).",
      documentType: "Belge türü",
      documentTypes: { receipt: "Fiş / dekont", invoice: "Fatura" },
      vatRate: "KDV oranı",
      invoiceNo: "Fatura no",
      vat: "KDV",
      vatHint: "Tutar KDV dahildir: {{vat}} KDV 191 İndirilecek KDV'ye, {{net}} gidere yazılır.",
      vatNotDeductible: "Müşteriye verilen hediyenin KDV'si indirilmez; KDV gidere dahil kalır.",
      vatInExpense: "gidere dahil",
      legacyPosted: "Muhasebeye aktarıldı",
      legacyNotPosted: "Muhasebeye aktarılmadı",
      legacyExcluded: "Muhasebe dışı",
      noLegacy: "Muhasebeye aktarılmamış önceki kayıt yok",
      legacyPost: {
        open: "Muhasebeleştir",
        title: "Önceki kaydı muhasebeleştir",
        hint: "{{amount}} tutarındaki eski gider, seçtiğiniz ödeme şekliyle onaylanmış gider gibi işlenir.",
        excludeLabel: "Muhasebe dışı bırak",
        excludeHint: "Gider zaten elle işlendiyse ya da muhasebeye girmeyecekse; kayıt gerekçesiyle işaretlenir.",
        note: "Gerekçe",
        effect: "Nakit / şahsi kartta 760.01 / 335 fişi ve personel geri ödemesi açılır; iş avansında açık avanstan düşülür. Fiş harcama tarihine yazılır (dönem kapalıysa aktarılamaz).",
        post: "Muhasebeye aktar",
        exclude: "Muhasebe dışı bırak",
        postedToast: "Gider muhasebeye aktarıldı",
        excludedToast: "Gider muhasebe dışı işaretlendi"
      },
      noCards: "Size zimmetli şirket kartı yok",
      card: "Şirket kartı",
      pickCard: "Kart seçin",
      description: "Açıklama",
      descriptionHint: "Kim, neden, kaç kişi — firma sahibinin onay için bilmesi gerekenler.",
      receipts: "Fiş / dekont",
      receiptRequired: "Onaya göndermek için en az bir belge ekleyin.",
      noReceipts: "Belge yok.",
      dropTitle: "Belgeleri sürükleyip bırakın ya da seçin",
      dropHint: "PDF, PNG, JPEG, WEBP · dosya başına en fazla 10 MB · en fazla 10 belge",
      tooManyFiles: "En fazla {{max}} belge eklenebilir.",
      badType: "Yalnız PDF ya da görsel yüklenebilir.",
      uploading: "Yükleniyor",
      uploaded: "Yüklendi",
      uploadFailed: "Yüklenemedi",
      someFailed: "{{count}} belge yüklenemedi; tekrar deneyin.",
      saveDraft: "Taslak kaydet",
      saveSubmit: "Kaydet ve onaya gönder",
      saved: "Gider kaydedildi",
      submitted: "Gider onaya gönderildi",
      spender: "Personel",
      status: "Durum",
      statuses: { draft: "Taslak", pending: "Onay bekliyor", info_requested: "Açıklama istendi", approved: "Onaylandı", rejected: "Reddedildi", cancelled: "Geri çekildi" },
      legacy: "Önceki kayıt",
      submittedAt: "Gönderim",
      decidedBy: "Karar veren",
      reimbursementNote: "Bu gider size geri ödenecek; ödeme Finans → Personel Geri Ödemeleri'nden yapılır.",
      history: "Süreç",
      events: { created: "Oluşturuldu", edited: "Düzenlendi", file_added: "Belge eklendi", submitted: "Onaya gönderildi", info_requested: "Açıklama istendi", responded: "Yanıtlandı", approved: "Onaylandı", rejected: "Reddedildi", cancelled: "Geri çekildi", legacy_posted: "Muhasebeye aktarıldı", legacy_excluded: "Muhasebe dışı bırakıldı" },
      decisionNote: "Gerekçe / soru (ret ve açıklama isteğinde zorunlu)",
      responseNote: "Açıklamanız (zorunlu)",
      decisionHint: "Açıklama isteği ve ret, gerekçesiyle personele bildirim ve sizin posta kutunuzdan e-posta olarak gider.",
      submit: "Onaya gönder",
      respond: "Yanıtla ve yeniden gönder",
      cancel: "Geri çek",
      cancelTitle: "Gider geri çekilsin mi?",
      cancelBody: "Gider onay sürecinden çıkarılır; kayıt geçmişte kalır.",
      requestInfo: "Açıklama iste",
      reject: "Reddet",
      approve: "Onayla",
      done: { submit: "Onaya gönderildi", respond: "Yanıt gönderildi", cancel: "Geri çekildi", approve: "Onaylandı ve finansa aktarıldı", reject: "Reddedildi", request_info: "Açıklama istendi" },
      empty: "Gider yok",
      noPending: "Onay bekleyen gider yok",
      total: "Toplam"
    },
    minutesDoc: {
      title: "Tutanak belgesi",
      download: "İndir",
      send: "Gönder",
      versions: { internal: "İç sürüm (tüm notlar)", customer: "Müşteri sürümü (iç notlar hariç)" },
      systemChannel: "sistem postası (posta kutusu yok)",
      sendTitle: "Tutanağı e-postayla gönder",
      sendHint: "Şirket içi alıcılara iç sürüm, müşteriye müşteri sürümü (hazırlık notu, iç not, değerlendirme ve müşteri tepkisi çıkarılmış) ek olarak gider. Müşteriye giden e-posta sizin şirket posta kutunuzdan gönderilir.",
      internalSection: "Şirket içi (iç sürüm)",
      managers: "Hesap sorumlusu ve firma sahipleri",
      managersHint: "Müşterinin hesap sorumlusu ve tüm firma sahipleri.",
      privateHint: "Gizli toplantı: şirket içinde yalnız katılımcılara gönderilebilir.",
      customerSection: "Müşteri (müşteri sürümü)",
      customerHint: "E-posta adresi kayıtlı kişiler ve dış katılımcılar; ek adresleri virgülle yazabilirsiniz.",
      noCustomerEmails: "E-posta adresi kayıtlı kişi ya da dış katılımcı yok.",
      extra: "Diğer alıcılar",
      extraInvalid: "Geçersiz e-posta adresi var.",
      message: "Mesaj",
      messageHint: "Boş bırakılırsa standart bir giriş metni kullanılır; e-postada kararlar ve açık aksiyonlar da özetlenir.",
      format: "Ek biçimi",
      pickRecipients: "En az bir alıcı seçin.",
      sent: "Tutanak {{count}} alıcıya gönderildi",
      systemFallback: "Şirket posta kutunuz tanımlı olmadığı için iç alıcılara sistem postası (eksiz) gönderildi.",
      template: "Tutanak şablonu",
      templateHint: "PDF ve Word tutanağın başlığı, müşteri sürümü giriş metni, altbilgiler ve bölümleri.",
      tplTitle: "Belge başlığı",
      tplIntro: "Müşteri sürümü giriş metni",
      tplIntroHint: "Müşteri sürümünde bilgilerin altına eklenir (ör. teşekkür, gizlilik bildirimi).",
      tplInternalFooter: "İç sürüm altbilgisi",
      tplCustomerFooter: "Müşteri sürümü altbilgisi",
      sections: {
        showParticipants: "Katılımcılar",
        showAgenda: "Gündem ve kararlar",
        showActions: "Aksiyon tablosu",
        showSignatures: "İmza alanları",
        showInternalNotes: "İç notlar (yalnız iç sürüm)"
      },
      templateSaved: "Şablon kaydedildi"
    },
    record: {
      title: "Tutanak ve katılımcılar",
      empty: "Gündem, dış katılımcı ya da çevrimiçi bilgi girilmedi.",
      editTitle: "Tutanak, katılımcılar ve çevrimiçi bilgiler",
      editHint: "Gündem maddesi başına görüşülenleri ve alınan kararı yazın; aksiyonlar sorumlu ve tarihle notlar bölümünde tutulur.",
      agenda: "Gündem",
      agendaTitle: "Gündem maddesi",
      agendaNotes: "Görüşülenler",
      decision: "Karar",
      addAgenda: "Madde ekle",
      agendaInvalid: "Not ya da karar girilen maddeye başlık yazın.",
      guests: "Dış katılımcılar",
      guestsHint: "Müşteri kişi kartında olmayan katılımcılar (danışman, iş ortağı vb.).",
      guestName: "Ad soyad",
      guestEmail: "E-posta",
      guestCompany: "Kurum",
      guestRole: "Görev",
      addGuest: "Katılımcı ekle",
      guestInvalid: "Bilgi girilen katılımcıya ad yazın.",
      online: "Çevrimiçi toplantı",
      platform: "Platform",
      noPlatform: "Yüz yüze / belirtilmedi",
      platforms: { zoom: "Zoom", teams: "Microsoft Teams", meet: "Google Meet", webex: "Webex", other: "Diğer" },
      url: "Toplantı bağlantısı",
      urlInvalid: "Bağlantı http:// ya da https:// ile başlamalı.",
      code: "Toplantı kimliği",
      passcode: "Toplantı şifresi",
      passcodeHint: "Şifreli saklanır; yalnız toplantı sahibi, katılımcı personel ve yöneticiler açabilir.",
      passcodeKeep: "Değiştirmek için yazın; boş bırakırsanız mevcut şifre korunur.",
      clearPasscode: "Şifreyi kaldır",
      keepPasscode: "Kaldırmaktan vazgeç",
      revealPasscode: "Şifreyi göster",
      passcodeHidden: "Şifre tanımlı",
      join: "Toplantıya katıl",
      saved: "Tutanak kaydedildi"
    },
    files: {
      title: "Ekler ve kayıtlar",
      empty: "Ek ya da kayıt yok.",
      addAttachment: "Ek yükle",
      addRecording: "Kayıt yükle",
      uploadAttachment: "Toplantı eki yükle",
      uploadRecording: "Toplantı kaydı yükle",
      attachmentHint: "Belge, görsel, sunum (en fazla {{max}} MB). Dosya şifreli saklanır.",
      recordingHint: "Ses ya da görüntü kaydı (en fazla {{max}} MB). Müşterinin kayda onayı zorunludur; dosya parça parça şifrelenerek yüklenir, yalnız yetkililer panelde izleyebilir.",
      file: "Dosya",
      note: "Açıklama",
      tooLarge: "Dosya {{max}} MB sınırını aşıyor.",
      upload: "Yükle",
      uploaded: "Dosya yüklendi",
      cancelUpload: "Yüklemeyi iptal et",
      progress: "{{sent}} / {{total}} (%{{pct}})",
      incomplete: "Yükleme yarım kaldı ({{done}}/{{total}} parça)",
      consentTitle: "Müşteri onayı (zorunlu)",
      consentBy: "Onay veren",
      consentOther: "Kişi kartında yok (adını yazın)",
      consentName: "Onay verenin adı",
      consentMethod: "Onay yöntemi",
      consentMethods: { verbal: "Toplantı başında sözlü (kayıtta)", written: "Yazılı / imzalı", email: "E-posta ile", platform: "Platformun kayıt bildirimi kabul edildi" },
      consentAt: "Onay zamanı",
      consentNote: "Onayla ilgili not (isteğe bağlı)",
      consentConfirm: "Müşterinin bu toplantının kaydedilmesine onay verdiğini ve bilgilerin doğru olduğunu beyan ederim.",
      consentLine: "Onay: {{by}} · {{method}} · {{at}}",
      expires: "Saklama sonu {{date}}",
      play: "İzle",
      download: "İndir",
      views: "İzleme geçmişi",
      viewsTitle: "{{name}} — izleme geçmişi",
      noViews: "Henüz açılmadı.",
      actions: { stream: "İzledi", download: "İndirdi" },
      playerHint: "Her açılış izleme geçmişine yazılır.",
      deleteTitle: "{{name}} silinsin mi?",
      deleteHint: "Silme gerekçesi zorunludur; dosya geri alınamaz şekilde silinir, kaydı denetim geçmişinde kalır.",
      deleted: "Dosya silindi",
      settings: "Dosya ayarları",
      settingsHint: "Toplantı eki ve kayıtları için boyut sınırı (en fazla 2048 MB) ve saklama süreleri. Süre dolan dosyalar otomatik silinir; yeni süre yeni yüklemelere uygulanır.",
      maxFile: "Dosya başına üst sınır",
      maxFileHint: "1 – 2048 MB",
      recordingRetention: "Kayıt saklama süresi",
      attachmentRetention: "Ek saklama süresi",
      retentionHint: "0 = süresiz (yalnız yetkili elle silebilir)",
      days: "gün",
      settingsInvalid: "Üst sınır 1–2048 MB, süreler 0–3650 gün olmalı.",
      settingsSaved: "Ayarlar kaydedildi"
    },
    live: {
        requested: "Yeni müşteri erişim talebi",
        approved: "Müşteri erişim talebiniz onaylandı",
        rejected: "Müşteri erişim talebiniz reddedildi",
        revoked: "Müşteri erişiminiz geri alındı",
        open: "Aç"
      }
    },
    activity: "Aktivite",
    activityMenu: {
      file: "Dosya yükle",
      followup: "Takip Görevi",
      invoice: "Fatura kaydı ekle",
      meeting: "Görüşme kaydet",
      offer: "Teklif oluştur",
      receipt: "Dekont ekle / eşleştir",
      renewal: "Yenileme",
      request: "Talep aç",
      trial: "Deneme Lisansı",
      visit: "Ziyaret planla",
      work: "Demo / kurulum ekle"
    },
    add: "Müşteri Ekle",
    allProjects: "Tüm projeler",
    board: {
      emptyColumn: "Bu aşamada müşteri yok"
    },
    changeStage: "Aşamayı değiştir",
    channel: {
      email: "E-posta",
      online: "Online toplantı",
      phone: "Telefon",
      visit: "Fiziki ziyaret"
    },
    collection: {
      add: "Tahsilat Planı Ekle",
      createTitle: "Yeni tahsilat planı",
      descPlaceholder: "Örn. Kurulum sonrası kalan tutar",
      descRequired: "Açıklama en az 2 karakter olmalı",
      due: "Vade: {{date}}",
      dueDate: "Vade tarihi",
      empty: "Tahsilat planı yok",
      hint: "{{name}} için beklenen ödeme.",
      paidShort: "Tahsil edilen:",
      title: "Tahsilat Planları"
    },
    collectionsPage: {
      filter: {
        all: "Tümü",
        open: "Açık",
        overdue: "Gecikmiş",
        paid: "Kapanan"
      },
      open: "Açık tahsilat planı",
      overdue: "Gecikmiş tahsilat",
      subtitle: "Tüm müşterilerin tahsilat planları, faturaları ve dekont eşleştirmeleri.",
      title: "Tahsilatlar"
    },
    collectionStatus: {
      overdue: "Gecikmiş",
      paid: "Tahsil edildi",
      partial: "Kısmi",
      pending: "Bekliyor"
    },
    cols: {
      actions: "İşlemler",
      balance: "Bakiye",
      company: "Firma",
      contact: "İlgili kişi",
      lastMeeting: "Son görüşme",
      next: "Sonraki işlem",
      owner: "Sorumlu personel",
      stage: "Aşama"
    },
    customerCreated: "Müşteri eklendi",
    customerUpdated: "Müşteri güncellendi",
    del: {
      followup: "Takibi sil",
      followupBody: "“{{note}}” takibi silinir.",
      invoice: "Fatura kaydı silinsin mi?",
      invoiceBody: "{{number}} numaralı fatura kaydı silinecek. Tahsilat ve dekontlar etkilenmez.",
      meeting: "Görüşme silinsin mi?",
      meetingBody: "{{date}} tarihli görüşme; giderleri ve iç notlarıyla birlikte silinecek.",
      module: "Modül kaldırılsın mı?",
      moduleBody: "“{{name}}” müşterinin modül listesinden kaldırılacak.",
      offer: "Teklif silinsin mi?",
      offerBody: "{{number}} numaralı teklif silinecek. Onaylanmış teklifler silinemez.",
      order: "Siparişi sil",
      orderBody: "{{number}} silinir; teklif yeniden siparişe dönüştürülebilir.",
      receipt: "Dekont silinsin mi?",
      receiptBody: "{{amount}} tutarındaki dekont silinecek; ilgili tahsilatın kalan tutarı yeniden açılır.",
      renewal: "Yenilemeyi sil",
      renewalBody: "{{kind}} ({{date}}) kaydı silinir.",
      request: "Talep silinsin mi?",
      requestBody: "{{number}} numaralı talep silinecek.",
      work: "Kayıt silinsin mi?",
      workBody: "{{date}} tarihli {{kind}} kaydı silinecek."
    },
    deleteBody: "“{{name}}” ve tüm görüşme, teklif, talep ve dosya kayıtları silinecek. Finans kaydı olan müşteri silinemez.",
    deleted: "Müşteri silindi",
    deleteTitle: "Müşteri silinsin mi?",
    delivery: {
      installing: "Kurulum aşamasında",
      live: "Canlıda",
      none: "Başlamadı",
      planned: "Kurulum planlandı"
    },
    deliveryPage: {
      subtitle: "Tüm müşterilerin demo, kurulum ve eğitim çalışmaları.",
      title: "Demo ve Kurulum"
    },
    dropzone: {
      docHint: "PDF, DOC, DOCX, XLS, XLSX, JPG, PNG (en fazla 10 MB)",
      drop: "Dosyayı buraya sürükleyin veya",
      imgHint: "PDF, JPG, PNG (en fazla 10 MB)",
      pdfHint: "PDF (en fazla 10 MB)",
      pick: "dosya seçin",
      remove: "Dosyayı kaldır"
    },
    email: {
      body: "Mesaj",
      bodyRequired: "Mesaj boş olamaz",
      empty: "Henüz e-posta yok",
      hint: "Şirket mail hesabınızdan ve imzanızla gönderilir; müşteri geçmişine kaydedilir. Müşterinin yanıtları kişi ve şirket e-posta adresine göre otomatik olarak burada görünür.",
      listTitle: "E-postalar",
      send: "Gönder",
      sent: "E-posta gönderim kuyruğuna alındı",
      subject: "Konu",
      subjectRequired: "Konu en az 2 karakter olmalı",
      title: "E-posta Gönder",
      to: "Alıcı"
    },
    export: {
      button: "Dışa aktar",
      col: {
        adminUrl: "Yönetim paneli",
        appUrl: "Uygulama",
        balance: "Açık bakiye (₺)",
        city: "İl",
        contact: "Yetkili",
        contactTitle: "Yetkili unvanı",
        delivery: "Kurulum durumu",
        district: "İlçe",
        email: "E-posta",
        lastMeeting: "Son görüşme",
        legalName: "Ticari ünvan",
        name: "Firma",
        nextAction: "Sonraki adım",
        nextDate: "Sonraki adım tarihi",
        owner: "Sorumlu",
        phone: "Telefon",
        project: "Proje",
        region: "Bölge",
        sector: "Sektör",
        stage: "Aşama",
        website: "Web sitesi"
      },
      csv: "CSV (.csv)",
      label: "{{count}} müşteri (filtreye göre)",
      sheet: "Müşteriler",
      xlsx: "Excel (.xlsx)"
    },
    fields: {
      address: "Adres",
      amount: "Tutar",
      channel: "Kanal",
      city: "İl",
      contact: "İlgili kişi",
      contactTitle: "Unvanı",
      customer: "Müşteri",
      date: "Tarih",
      delivery: "Kurulum durumu",
      description: "Açıklama",
      district: "İlçe / semt",
      email: "E-posta",
      end: "Bitiş",
      legalName: "Ticari unvan",
      name: "Firma adı",
      nextAction: "Sonraki aksiyon",
      nextText: "Yapılacak iş",
      note: "Not",
      owner: "Sorumlu",
      phone: "Telefon",
      project: "Proje",
      region: "Bölge",
      result: "Sonuç",
      sector: "Sektör",
      staff: "Personel",
      stage: "Aşama",
      start: "Başlangıç",
      status: "Durum",
      summary: "Görüşme özeti",
      taxNo: "Vergi no",
      taxOffice: "Vergi dairesi",
      website: "Web sitesi"
    },
    fileCategory: {
      contract: "Sözleşme",
      invoice: "Fatura",
      other: "Diğer",
      receipt: "Dekont"
    },
    files: {
      category: "Dosya kategorisi",
      editTitle: "Dosyayı düzenle",
      empty: "Dosya yok",
      file: "Dosya",
      fileRequired: "Dosya seçin",
      hint: "Müşteri ya da projeyle ilgili bir dosyayı sisteme yükleyin.",
      meeting: "İlgili aktivite",
      meetingHint: "Dosyayı bir görüşmeye bağlayabilirsiniz.",
      saved: "Dosya kaydedildi",
      title: "Dosyalar",
      titleRequired: "Başlık en az 2 karakter olmalı",
      unlinked: "Bağı kaldırılanlar",
      unlinkedReason: "Bağ kaldırıldı: {{reason}}",
      upload: "Dosya Yükle",
      uploadTitle: "Dosya yükle",
      visibility: "Görünürlük"
    },
    followup: {
      add: "Takip Ekle",
      createTitle: "Yeni takip",
      dueOn: "Tarih",
      editTitle: "Takibi düzenle",
      empty: "Açık takip yok",
      hideDone: "Tamamlananları gizle",
      hint: "Kim, ne zaman, hangi kanaldan ne yapacak? Tamamlanınca işaretleyin.",
      note: "Yapılacak",
      notePlaceholder: "Örn. Teklif dönüşü için aranacak",
      noteRequired: "Yapılacak işi yazın",
      overdue: "gecikti",
      owner: "Sorumlu",
      showDone: "Tamamlananları göster ({{count}})",
      title: "Takipler"
    },
    followUps: {
      all: "Tüm takipleri gör",
      collection: "Gecikmiş tahsilat: {{code}}",
      empty: "Takip gerektiren kayıt yok.",
      late: "{{count}} gün geçti",
      title: "Takip Gerektirenler",
      upcoming: "Yaklaşıyor"
    },
    followupsPage: {
      allOwners: "Tüm sorumlular",
      filter: {
        all: "Tümü",
        done: "Tamamlanan",
        open: "Açık",
        overdue: "Geciken",
        today: "Bugün"
      },
      subtitle: "Satış ekibinin müşteri takip görevleri; tamamladıkça işaretleyin.",
      title: "Takipler"
    },
    form: {
      amountInvalid: "Geçerli bir tutar girin",
      contactRequired: "İlgili kişi en az 2 karakter olmalı",
      createTitle: "Yeni müşteri",
      dateRequired: "Tarih seçin",
      editTitle: "Müşteriyi düzenle",
      emailInvalid: "Geçerli bir e-posta girin",
      hint: "Firma, iletişim ve satış bilgileri.",
      nameRequired: "Firma adı en az 2 karakter olmalı",
      nextRequired: "Sonraki aksiyon için tarih ve açıklama girin",
      ownerRequired: "Sorumlu seçin",
      projectRequired: "Proje seçin",
      sectionCompany: "Firma bilgileri",
      sectionContact: "İletişim ve konum",
      sectionLinks: "Web ve canlı bağlantılar",
      sectionSales: "Satış durumu",
      noSector: "Sektör yok",
      selectCity: "İl seçin",
      searchCity: "İl ara…",
      selectDistrict: "İlçe seçin",
      searchDistrict: "İlçe ara…",
      selectRegion: "Bölge seçin",
      noRegion: "Bölge yok",
      regionHint: "Bölge bazlı yetkiler bu alana göre çalışır.",
      sectorPlaceholder: "Sektör seçin",
      sectorRequired: "Ürün için bir sektör seçin",
      staffRequired: "Personel seçin",
      summaryRequired: "Özet en az 3 karakter olmalı",
      taxNoInvalid: "10 haneli VKN ya da 11 haneli TCKN girin",
      timeRequired: "Saat seçin",
      urlInvalid: "Geçerli bir adres girin (örn. www.ornek.com)"
    },
    funnelTitle: "Satış Hunisi ({{project}})",
    invoice: {
      add: "Fatura Kaydı Ekle",
      collection: "İlgili tahsilat",
      currency: "Para birimi",
      date: "Fatura tarihi",
      empty: "Fatura kaydı yok",
      file: "Fatura PDF dosyası",
      fileRequired: "Fatura PDF dosyasını ekleyin",
      hint: "Mevcut bir faturayı sisteme kaydedin. Bu işlem fatura kesme işlemi değildir.",
      listTitle: "Faturalar",
      notIssue: "Mevcut faturayı kaydedersiniz; yasal fatura kesimi Finansal Yönetim → GİB e-Belgeler ekranından yapılır.",
      number: "Fatura numarası",
      numberRequired: "Fatura numarası girin",
      saved: "Fatura kaydedildi",
      title: "Fatura kaydı ekle"
    },
    kpi: {
      active: "Aktif müşteri",
      demo: "Demo sürecinde",
      pending: "Bekleyen tahsilat"
    },
    lastMeetingShort: "Son görüşme {{date}}",
    license: {
      monthly: "Aylık",
      one_time: "Tek seferlik",
      yearly: "Yıllık"
    },
    licenseTerm: {
      monthly: "Aylık",
      perpetual: "Süresiz",
      yearly: "Yıllık"
    },
    links: {
      add: "{{name}} adresi ekle",
      admin: "Yönetim paneli",
      adminHint: "Müşterinin işletme yönetim paneli",
      app: "Uygulama (site)",
      appHint: "Müşterinin kullandığı canlı uygulama adresi",
      copied: "Adres kopyalandı",
      copy: "{{name}} adresini kopyala",
      copyFailed: "Adres kopyalanamadı",
      none: "Tanımlı değil",
      open: "{{name}} adresini yeni sekmede aç",
      subtitle: "Projenin canlı ortam adresleri",
      title: "Canlı Bağlantılar",
      website: "Web sitesi"
    },
    list: {
      empty: "Henüz müşteri yok",
      next: "Sonraki sayfa",
      noMatch: "Filtrelere uyan müşteri yok",
      page: "{{page}} / {{pages}}",
      pageSize: "Sayfa boyutu",
      perPage: "{{count}} / sayfa",
      prev: "Önceki sayfa",
      range: "{{total}} kayıttan {{from}}–{{to}} arası",
      search: "Firma veya ilgili kişi ara…",
      subtitle: "Müşteri ve potansiyel müşterilerin aşama, görüşme ve bakiye durumu.",
      title: "Müşteriler",
      view: {
        board: "Pano",
        list: "Liste"
      },
      viewLabel: "Görünüm"
    },
    live: {
      autoSummary: "Yüz yüze toplantı (toplantı modunda başlatıldı).",
      carryOver: "Önceki toplantıdan açık kalanlar",
      carryOverHint: "{{date}} toplantısında tamamlanmamış maddeler; burada işaretleyebilirsiniz.",
      elapsed: "{{min}} dk",
      eyebrow: "Toplantı Modu",
      finish: "Toplantıyı Bitir",
      finished: "Toplantı tamamlandı; bitiş saati kaydedildi",
      noOpenOffers: "Bekleyen teklif yok.",
      notFound: "Toplantı bulunamadı",
      open: "Toplantı Modunda Aç",
      openOffers: "Açık teklifler",
      start: "Toplantı Başlat"
    },
    meeting: {
      visibility: "Not görünürlüğü",
      visibilityHint: "Kimlerin tutanak, karar, ek ve kayıtları görebileceği.",
      visibilities: {
        restricted: "Katılımcılar ve yetkililer",
        private: "Gizli (yalnız katılımcılar)",
        account: "Müşteriyi görebilen herkes"
      },
      restrictedLocked: "Bu toplantının notları yalnız katılımcılar, hesap sorumlusu ve yetkililer içindir.",
      privateLocked: "Gizli toplantı: notları yalnız katılımcılar ve gizli toplantı yetkilileri görebilir.",
      viewLog: "Görüntüleme geçmişi",
      viewLogHint: "Toplantı notunu kimin ne zaman açtığı (aynı kişi için 10 dakikada bir kayıt).",
      noViews: "Henüz kimse açmadı.",
      customerAttendees: "Müşteri tarafı katılımcılar",
      customerResponse: "Müşterinin cevabı",
      customerResponsePlaceholder: "Müşteri ne dedi? İtirazlar, istekler, bütçe, zamanlama…",
      decisions: "Alınan kararlar",
      decisionsPlaceholder: "Bu görüşmede ne kararlaştırıldı?",
      noContacts: "Bu müşteride kayıtlı kişi yok",
      otherStaff: "Diğer katılımcılar",
      participants: "Katılan personel",
      participantsHint: "İlk seçilen sorumlu olarak görünür; birden çok kişi seçebilirsiniz.",
      addNote: "Not Ekle",
      created: "Görüşme kaydedildi",
      createTitle: "Görüşme kaydet",
      detail: "Görüşme Detayı",
      editTitle: "Görüşmeyi düzenle",
      empty: "Görüşme kaydı yok",
      expenseInvalid: "Gider için açıklama ve tutar girin",
      expenses: "Ziyaret Giderleri ve Hediyeler",
      expenseTitle: "Gider / hediye",
      hasNext: "Sonraki aksiyon planla",
      hint: "Görüşme bilgileri müşteri geçmişine ve takip listesine yansır.",
      history: "Geçmiş ve Denetim",
      listTitle: "Görüşme ve Ziyaret Kayıtları",
      new: "Görüşme Kaydet",
      noExpenses: "Gider eklenmedi.",
      notePlaceholder: "Ekip için iç not yazın…",
      notes: "İç Notlar (Ekip)",
      plan: "Ziyaret Planla",
      planned: "Ziyaret planlandı",
      plannedSummary: "Planlanan ziyaret.",
      planTitle: "Ziyaret planla",
      receiptFile: "Fiş dosya adı (isteğe bağlı)",
      sameStaff: "Görüşmeyi yapan personel",
      sectionMeeting: "Görüşme",
      sectionNext: "Sonraki aksiyon",
      selectHint: "Ayrıntıları görmek için listeden bir görüşme seçin.",
      updated: "Görüşme güncellendi"
    },
    meetingHistory: {
      created: "Görüşme kaydı oluşturuldu.",
      expense: "Gider eklendi.",
      finished: "Toplantı bitirildi.",
      note: "İç not eklendi.",
      started: "Toplantı modunda başlatıldı.",
      updated: "Görüşme güncellendi."
    },
    meetingsPage: {
      scope: {
        all: "Tümü",
        overdue: "Gecikmiş aksiyonlar",
        upcoming: "Yaklaşan aksiyonlar"
      },
      search: "Müşteri ya da özet ara…",
      subtitle: "Tüm müşterilerle yapılan görüşmeler ve planlanan aksiyonlar.",
      title: "Görüşmeler"
    },
    minutes: {
      add: "Not ekle",
      colNote: "Not",
      colPriority: "Öncelik",
      colStatus: "Durum",
      copied: "{{count}} not panoya kopyalandı",
      copy: "Kopyala",
      docSummary: "{{done}}/{{total}} madde tamamlandı",
      editHint: "Düzenlemek için çift tıklayın",
      editItem: "Notu düzenle",
      empty: "Henüz not yok. Toplantıda konuşulanları madde madde ekleyin.",
      export: "Dışa aktar",
      exportAs: "Dosya olarak indir",
      exportCsv: "Excel / CSV (.csv)",
      exportDocx: "Word (.docx)",
      exportMd: "Markdown (.md)",
      exportTxt: "Metin (.txt)",
      placeholder: "Not ekle ve Enter'a bas…",
      priorityLabel: "Öncelik: {{priority}} (değiştir)",
      removeItem: "Notu sil",
      statusDone: "Tamamlandı",
      statusOpen: "Açık",
      title: "Toplantı Notları"
    },
    module: {
      add: "Modül Ekle",
      createTitle: "Modül ekle",
      editTitle: "Modülü düzenle",
      empty: "Modül eklenmedi",
      hint: "Müşterinin kullandığı, denediği ya da planlanan modül.",
      license: "Lisans tipi",
      choose: "Katalogdan modül seçin",
      fromCatalog: "Müşterinin ürününde sunulan modüller listelenir; fiyat varsayılanı projedeki fiyattır.",
      moduleRequired: "Bir modül seçin",
      name: "Modül",
      noneOffered: "Bu müşterinin ürününde sunulan modül yok",
      price: "Fiyat",
      since: "{{date}} itibarıyla",
      start: "Başlangıç tarihi"
    },
    moduleStatus: {
      active: "Aktif",
      cancelled: "İptal",
      planned: "Planlandı",
      trial: "Deneme"
    },
    moreActions: "Diğer işlemler",
    notFound: "Müşteri bulunamadı",
    offer: {
      discountLimitHint: "Bu müşteride en fazla %{{max}} iskonto verebilirsiniz; fiyat düşürme ve kalem iskontoları da bu orana dahildir.",
      acceptedNote: "Müşteri teklifi kabul etti",
      acceptHint: "Onaylanan teklif müşteriyi “Müşteri” aşamasına taşır.",
      action: {
        accepted: "Kabul Edildi",
        rejected: "Reddedildi",
        sent: "Gönderildi olarak işaretle"
      },
      add: "Teklif Oluştur",
      addItem: "Kalem Ekle",
      confirm: {
        accepted: "{{number}} kabul edildi olarak işaretlensin mi?",
        acceptedBody: "Kabul edilen teklif sözleşme tutarına eklenir, müşteri “Müşteri” aşamasına taşınır ve teklif artık silinemez.",
        rejected: "{{number}} reddedildi olarak işaretlensin mi?",
        rejectedBody: "Teklif kapatılır; gerekirse yeni bir teklif oluşturabilirsiniz.",
        sent: "{{number}} gönderildi olarak işaretlensin mi?",
        sentBody: "Teklif müşteriye iletilmiş sayılır ve yanıt beklenir."
      },
      created: "Teklif oluşturuldu",
      createTitle: "Yeni teklif",
      date: "Teklif tarihi",
      discount: "İndirim (%)",
      discountInvalid: "0–100 arası bir oran girin",
      discountShort: "%{{pct}} indirim",
      editTitle: "{{number}} düzenle",
      empty: "Teklif yok",
      expired: "Süresi doldu",
      filter: {
        accepted: "Kabul edilen",
        all: "Tümü",
        open: "Açık",
        rejected: "Reddedilen"
      },
      hint: "Kalemler ve indirim; toplamlar kayıtta sistem tarafından hesaplanır.",
      itemCount: "{{count}} kalem",
      itemName: "Kalem / modül",
      itemPlaceholder: "Örn. Temel Yönetim lisansı",
      itemRequired: "Kalem adı girin",
      items: "Teklif kalemleri",
      itemsRequired: "En az bir kalem ekleyin",
      kpi: {
        accepted: "Kabul edilen teklifler",
        open: "Bekleyen teklifler",
        openCount: "{{count}} açık teklif",
        rate: "Kabul oranı",
        rateHint: "Sonuçlanan teklifler içinde"
      },
      note: "Not",
      qty: "Adet",
      qtyInvalid: "1–999 arası adet girin",
      removeItem: "Kalemi kaldır",
      sectionGeneral: "Genel",
      serverCalc: "Ara toplam, indirim ve genel toplam kaydedilince hesaplanır.",
      statusChanged: {
        accepted: "Teklif kabul edildi",
        rejected: "Teklif reddedildi",
        sent: "Teklif gönderildi olarak işaretlendi"
      },
      subtotal: "Ara toplam",
      title: "Teklifler",
      total: "Genel toplam",
      unitPrice: "Birim fiyat",
      updated: "Teklif güncellendi",
      validInvalid: "Geçerlilik tarihi teklif tarihinden önce olamaz",
      validShort: "Geçerlilik: {{date}}",
      validUntil: "Geçerlilik tarihi"
    },
    offersPage: {
      empty: "Bu filtrede teklif yok",
      expired: "Süresi dolan",
      expiredHint: "Yanıt gelmeden geçerliliği biten",
      filter: { approval: "Onay bekleyen",
        accepted: "Kabul edilen",
        all: "Tümü",
        expired: "Süresi dolan",
        open: "Bekleyen",
        rejected: "Reddedilen"
      },
      listTitle: "Teklif listesi",
      search: "Müşteri veya teklif no ara",
      subtitle: "Tüm müşterilere verilen teklifler; bekleyenleri ve süresi dolanları buradan takip edin.",
      title: "Teklifler"
    },
    offerStatus: {
      accepted: "Onaylandı",
      draft: "Taslak",
      rejected: "Reddedildi",
      sent: "Gönderildi"
    },
    openDetail: "Müşteriyi aç",
    optional: "Seçiniz (isteğe bağlı)",
    order: {
      approve: "Onayla",
      approved: "{{number}} onaylandı; yenilemeler oluşturuldu",
      approvedBy: "{{by}} onayladı · {{at}}",
      approveHint: "Lisans kapsamını girin. Bitiş tarihleri için yenileme kayıtları otomatik açılır.",
      approveTitle: "{{number}} siparişini onayla",
      branches: "{{count}} şube",
      branchInvalid: "1–999 arası şube sayısı girin",
      branchLimit: "Şube limiti",
      convert: "Siparişe Dönüştür",
      convertBody: "Teklifin kalemleri ve tutarı siparişe sabitlenir; sipariş lisans onayına düşer.",
      convertTitle: "{{number}} siparişe dönüştürülsün mü?",
      created: "Sipariş oluşturuldu; onay bekliyor",
      datePast: "Geçmiş bir tarih seçilemez",
      empty: "Sipariş yok",
      emptyHint: "Teklifler sekmesinde kabul edilen bir teklifi “Siparişe Dönüştür” ile siparişe çevirin.",
      fromOffer: "Kaynak teklif",
      fromOfferShort: "Teklif {{number}}",
      maintenanceUntil: "Bakım bitişi",
      noEnd: "Süresiz",
      optional: "İsteğe bağlı",
      perpetualHint: "Süresiz lisansta bitiş tarihi ve lisans yenilemesi olmaz.",
      reject: "Reddet",
      rejected: "{{number}} reddedildi",
      rejectedBy: "{{by}} reddetti · {{at}}",
      rejectHint: "Ret gerekçesi siparişte saklanır ve ekip tarafından görülür.",
      rejectNote: "Ret gerekçesi",
      rejectNoteRequired: "Gerekçeyi kısaca yazın",
      rejectTitle: "{{number}} siparişini reddet",
      sectionLicense: "Lisans kapsamı",
      sectionOrder: "Sipariş",
      supportUntil: "Destek bitişi",
      tabHint: "Kabul edilen teklifler siparişe dönüştürülür; onayda lisans kapsamı girilir.",
      term: "Lisans süresi",
      title: "Siparişler",
      total: "Sipariş tutarı",
      validRequired: "Lisans bitiş tarihini seçin",
      validUntil: "Lisans bitişi",
      view: "Siparişi gör",
      waiting: "Lisans onayı bekleniyor"
    },
    ordersPage: {
      empty: "Bu filtrede sipariş yok",
      pendingHint: "Lisans kapsamı girilip onaylanmayı bekleyen",
      subtitle: "Kabul edilen tekliflerden oluşan siparişler ve lisans onayları.",
      title: "Siparişler"
    },
    orderStatus: {
      approved: "Onaylandı",
      pending: "Onay bekliyor",
      rejected: "Reddedildi"
    },
    overview: {
      call: "Ara",
      company: "Firma Bilgileri",
      contact: "İletişim Bilgileri",
      history: "Müşteri Geçmişi",
      historyFilter: "Geçmiş filtresi",
      location: "Konum",
      nextSteps: "Sonraki Adımlar",
      noHistory: "Henüz kayıt yok.",
      noNext: "Planlanmış adım yok.",
      openRequests: "Açık Talepler",
      paymentDate: "Ödeme tarihi",
      paymentText: "Kalan {{amount}} için tahsilat planlandı.",
      recentMeetings: "Son Görüşmeler",
      subtitle: "Satış hunisi, takip gerektiren müşteriler ve son hareketler.",
      team: "Sorumlu Ekip",
      title: "Müşteri Yönetimi"
    },
    pickCustomer: "Müşteri seçin",
    priority: {
      high: "Yüksek",
      low: "Düşük",
      medium: "Orta"
    },
    project: {
      moduleCount: "{{count}} modül",
      modules: "Projedeki Modüller",
      open: "Projeyi aç"
    },
    range: {
      "30": "Son 30 gün",
      "7": "Son 7 gün",
      "90": "Son 90 gün",
      all: "Tüm tarihler"
    },
    receipt: {
      add: "Dekont Ekle",
      collection: "İlgili tahsilat",
      collectionRequired: "Tahsilat seçin",
      date: "Dekont tarihi",
      empty: "Dekont yok",
      file: "Dekont dosyası",
      fileRequired: "Dekont dosyasını ekleyin",
      hint: "Ödeme dekontunu yükleyin ve ilgili tahsilatla eşleştirin.",
      invoice: "Fatura",
      listTitle: "Dekontlar",
      match: "Eşleştir",
      matchAmount: "Eşleştirilecek tutar",
      reference: "Referans / açıklama",
      referenceHint: "Banka referans no veya açıklama bilgisi girin.",
      remaining: "Kalan tutar",
      saved: "Dekont eşleştirildi",
      summary: "Eşleştirme Özeti",
      title: "Dekont ekle / eşleştir"
    },
    recency: {
      "30": "Son 30 gün",
      "7": "Son 7 gün",
      all: "Tümü",
      never: "Hiç görüşülmedi",
      older: "30 günden eski"
    },
    renewal: {
      add: "Yenileme Ekle",
      amount: "Yenileme tutarı",
      amountHint: "Henüz belli değilse 0 bırakın",
      createTitle: "Yeni yenileme",
      daysLeft: "{{count}} gün kaldı",
      dueOn: "Bitiş tarihi",
      dueShort: "Bitiş: {{date}}",
      editTitle: "Yenilemeyi düzenle",
      empty: "Yenileme kaydı yok",
      hint: "Lisans, bakım veya destek süresinin bittiği tarih ve yenileme tutarı.",
      kind: "Tür",
      noAmount: "Tutar belirlenmedi",
      overdueDays: "{{count}} gün geçti",
      title: "Yenilemeler",
      today: "Bugün bitiyor"
    },
    renewalKind: {
      license: "Lisans yenileme",
      maintenance: "Bakım yenileme",
      support: "Destek yenileme"
    },
    renewalsPage: {
      filter: {
        all: "Tümü",
        open: "Açık",
        overdue: "Süresi geçen",
        renewed: "Yenilenen",
        soon: "30 gün içinde"
      },
      overdue: "Süresi geçen",
      overdueHint: "Bitiş tarihi geçmiş, yenilenmemiş",
      soon: "30 gün içinde",
      soonHint: "Yakında bitecek; müşteriyle görüşün",
      subtitle: "Lisans, bakım ve destek sürelerinin yenileme takibi.",
      title: "Yenilemeler"
    },
    renewalStatus: {
      cancelled: "İptal",
      contacted: "Görüşüldü",
      renewed: "Yenilendi",
      upcoming: "Yaklaşıyor"
    },
    request: {
      add: "Talep Aç",
      assignee: "Atanan",
      createTitle: "Yeni talep",
      editTitle: "{{number}} düzenle",
      empty: "Talep yok",
      general: "Genel",
      hint: "Müşteri isteği, hata bildirimi ya da destek talebi.",
      module: "Modül",
      noMessages: "Henüz yazışma yok",
      noOpen: "Açık talep yok.",
      openThread: "Yazışmayı aç ({{count}} mesaj)",
      priority: "Öncelik",
      replyPlaceholder: "Yanıt yazın… (Ctrl/⌘ + Enter ile gönder)",
      send: "Gönder",
      title: "Talepler ve Destek",
      titleRequired: "Başlık en az 3 karakter olmalı"
    },
    requestStatus: {
      in_progress: "İşlemde",
      open: "Açık",
      resolved: "Çözüldü"
    },
    result: {
      call_again: "Yeniden aranacak",
      not_reached: "Ulaşılamadı",
      reached: "Ulaşıldı"
    },
    seeAll: "Tümünü gör",
    stage: {
      customer: "Müşteri",
      demo: "Demo",
      lead: "Potansiyel",
      lost: "Kaybedildi",
      proposal: "Teklif"
    },
    stageBody: "{{name}} “{{stage}}” aşamasına taşınacak.",
    stageChanged: "Aşama güncellendi",
    stageTitle: "Aşama değiştirilsin mi?",
    summary: {
      collected: "Tahsil edilen",
      contract: "Sözleşme tutarı",
      openRequests: "Açık talep",
      openRequestsHint: "Taleplere git",
      remaining: "Kalan tutar"
    },
    supportPage: {
      active: "Açık ve işlemdekiler",
      highPriority: "Yüksek öncelikli",
      subtitle: "Tüm müşterilerin istekleri ve destek talepleri.",
      title: "Destek"
    },
    tabs: {
      notes: "Notlar ve Ön Analiz",
      delivery: "Demo ve Kurulum",
      emails: "E-postalar",
      files: "Dosyalar",
      finance: "Finans",
      meetings: "Görüşmeler",
      offers: "Teklifler",
      orders: "Sipariş & Lisans",
      overview: "Genel Bakış",
      project: "Proje ve Modüller",
      requests: "Talepler ve Destek"
    },
    gifts: {
      add: "Hediye ekle",
      date: "Tarih",
      deleteTitle: "Hediye kaydı silinsin mi?",
      empty: "Kayıtlı hediye yok",
      item: "Hediye",
      note: "Not (vesile, kime verildi)",
      saved: "Hediye kaydedildi",
      title: "Hediyeler",
      value: "Tutar"
    },
    category: {
      changeHint: "İsterseniz bu kararın nedenini yazın; müşterinin geçmişinde görünür.",
      changeTitle: "Kategori değiştirilsin mi?",
      changed: "Kategori güncellendi",
      label: "Kategori",
      none: "Kategorisiz",
      notePlaceholder: "Örn. bütçesi yok, 6 ay sonra tekrar aranacak"
    },
    notes: {
      addAnalysis: "Ön analiz ekle",
      addNote: "Not ekle",
      body: "Not",
      byline: "{{name}} · {{at}}",
      deleteBody: "Not kaldırılacak. Kayıt denetim izinde kalır.",
      deleteTitle: "Not silinsin mi?",
      empty: "Henüz not yok",
      emptyHint: "Görüşme izlenimleri, müşterinin cevapları ve satış öncesi ön analiz burada tutulur.",
      filter: { all: "Tümü", analysis: "Ön analizler", note: "Notlar" },
      filterLabel: "Not türü",
      kind: { analysis: "Ön analiz", note: "Not" },
      kindLabel: "Tür",
      needs: "Eksikler / ihtiyaçlar",
      needsPlaceholder: "Müşterinin bugün neleri eksik, nerede zorlanıyor?",
      pin: "Üste sabitle",
      pinned: "Sabitlenmiş",
      potential: { high: "Yüksek potansiyel", low: "Düşük potansiyel", medium: "Orta potansiyel", unknown: "Belirsiz" },
      potentialLabel: "Potansiyel",
      research: "Araştırma notları",
      saved: "Not kaydedildi",
      solution: "Önerilecek çözüm",
      solutionPlaceholder: "Hangi modül / paket / yaklaşımla çözülebilir?",
      title: "Notlar ve Ön Analiz",
      titleLabel: "Başlık",
      visibility: { all: "Herkes", private: "Yalnız ben", team: "Müşteri ekibi" },
      visibilityLabel: "Kimler görsün"
    },
    teamRole: {
      installation: "Kurulum",
      owner: "Sorumlu",
      support: "Destek"
    },
    timeline: {
      email: "E-posta: {{title}}",
      offer: "Teklif {{title}}",
      receipt: "Tahsilat · {{title}}",
      request: "Talep {{title}}"
    },
    timelineKind: {
      email: "E-postalar",
      meeting: "Görüşmeler",
      offer: "Teklifler",
      receipt: "Tahsilatlar",
      request: "Talepler",
      work: "Demo / kurulum"
    },
    trial: {
      add: "Deneme Başlat",
      cancel: "İptal",
      cancelBody: "Deneme lisansı hemen kapanır; kayıt geçmişte kalır.",
      cancelled: "Deneme iptal edildi",
      cancelTitle: "Denemeyi iptal et",
      convert: "Lisansa Çevir",
      converted: "Deneme siparişe bağlandı",
      convertHint: "Deneme müşterinin siparişine bağlanır; gerçek lisans siparişin onayıyla açılır.",
      convertTitle: "Denemeyi lisansa çevir",
      createTitle: "Deneme lisansı başlat",
      dayCount: "{{count}} gün",
      days: "Deneme süresi",
      daysLeft: "{{count}} gün kaldı",
      empty: "Deneme lisansı yok",
      endedAgo: "{{count}} gün önce bitti",
      endingSoon: "3 gün içinde bitecek",
      endingSoonHint: "Müşteriyle karar görüşmesi yapın",
      endsToday: "Bugün bitiyor",
      expiredHint: "Uzatın, lisansa çevirin ya da iptal edin",
      extend: "Uzat",
      extendDays: "Ek süre",
      extended: "Deneme {{count}} gün uzatıldı",
      extendHint: "Mevcut bitiş: {{date}}. Süresi dolmuşsa uzatma bugünden sayılır.",
      extendTitle: "Deneme süresini uzat",
      extensionCount: "{{count}} kez uzatıldı",
      filter: {
        all: "Tümü",
        cancelled: "İptal",
        converted: "Lisansa çevrilen",
        open: "Açık"
      },
      hint: "Seçilen modüller belirtilen gün boyunca ücretsiz açılır. Müşteri başına aynı anda tek deneme açılabilir.",
      lastExtension: "Son uzatma: +{{days}} gün — {{reason}}",
      linkedOrder: "Sipariş {{number}}",
      modules: "Denenecek modüller",
      modulesRequired: "En az bir modül seçin",
      noOrders: "Bu müşterinin siparişi yok. Önce kabul edilen teklifi siparişe dönüştürün.",
      order: "Bağlanacak sipariş",
      orderRequired: "Bir sipariş seçin",
      pickOrder: "Sipariş seçin",
      reason: "Uzatma gerekçesi",
      reasonRequired: "Gerekçeyi kısaca yazın",
      start: "Başlat",
      started: "Deneme lisansı başlatıldı",
      title: "Deneme Lisansları",
      usage: "Kullanılan süre"
    },
    trialStatus: {
      active: "Aktif",
      cancelled: "İptal edildi",
      converted: "Lisansa çevrildi",
      expired: "Süresi doldu"
    },
    unassigned: "Atanmadı",
    unlink: {
      customer: "Müşteri: {{name}}",
      done: "Belge bağı kaldırıldı",
      hint: "Seçili belgenin müşteri ya da projeyle olan ilişkisini kaldırın.",
      linkedTo: "Bu belge aşağıdaki kayıtlara bağlı:",
      note: "Açıklama",
      notePlaceholder: "Örn. Yanlış müşteriye bağlanmış.",
      noteRequired: "“Diğer” için açıklama girin",
      project: "Proje: {{name}}",
      reason: "Kaldırma nedeni",
      short: "Bağı kaldır",
      submit: "Bağı Kaldır",
      title: "Belge bağını kaldır",
      warning: "Bu işlem yalnız belgenin müşteri/proje kaydıyla ilişkisini kaldırır. Belge sistemden silinmez; diğer kayıtlara bağlıysa erişilebilir kalır."
    },
    unlinkReason: {
      duplicate: "Mükerrer yükleme",
      other: "Diğer",
      wrong_customer: "Hatalı müşteriyle ilişkilendirme",
      wrong_project: "Hatalı projeyle ilişkilendirme"
    },
    visibility: {
      all: "Tüm ekip",
      team: "Sadece bu müşteri/proje ekibi"
    },
    work: {
      add: "Demo / Kurulum Ekle",
      createTitle: "Yeni demo / kurulum",
      editTitle: "Kaydı düzenle",
      empty: "Kayıt yok",
      hint: "Demo, kurulum ya da eğitim çalışması.",
      kind: "Tür",
      title: "Demo, Kurulum ve Eğitim"
    },
    workKind: {
      demo: "Demo",
      installation: "Kurulum",
      training: "Eğitim"
    },
    workStatus: {
      cancelled: "İptal",
      done: "Tamamlandı",
      in_progress: "Devam ediyor",
      planned: "Planlandı"
    }
  },
  dashboard: {
    activeDemos: "Aktif demo",
    daysLeft: "{{count}} gün kaldı",
    demoConversion: "Demo dönüşümü",
    dueToday: "Bugün vadeli",
    endingDemos: "Bitişi yaklaşan demolar",
    followups: "Takiplerim",
    greeting: "Merhaba {{name}}",
    installHealth: "Kurulum sağlığı",
    lastDay: "Son gün",
    missingInBinary: "İmajda eksik paket",
    myTasks: "Açık görevlerim",
    noDemos: "Bitişi yaklaşan demo yok",
    noFollowups: "Bekleyen takip yok",
    overdueFollowups: "Geciken takip",
    overdueTasks: "Geciken görev",
    silent: "24 saattir sessiz",
    staleLicenses: "Lisansı eski",
    subtitle: "Bugünün öncelikleri ve genel durum",
    customize: "Ana sayfamı düzenle",
    emptyLayout: "Ana sayfanızda henüz widget yok",
    emptyLayoutHint: "Düzenleme ekranından size açık modülleri ekleyip istediğiniz gibi yerleştirebilirsiniz.",
    addWidgets: "Widget ekle",
    personalOnly: "Sadece bana özel",
    widgets: {
      kpiOpenTasks: { title: "Açık görevlerim", description: "Sorumlu olduğunuz açık görev sayısı" },
      kpiOverdueTasks: { title: "Geciken görev", description: "Süresi geçmiş görevleriniz" },
      kpiOverdueFollowups: { title: "Geciken takip", description: "Zamanı geçmiş müşteri takipleri" },
      kpiActiveDemos: { title: "Aktif demo", description: "Devam eden demolar ve dönüşüm oranı" },
      myTasks: {
        title: "Görevlerim",
        description: "Sorumlu olduğunuz görevler",
        empty: "Bekleyen görev yok",
        toggle: "\"{{title}}\" görevini işaretle",
        highPriority: "Yüksek öncelik"
      },
      payments: { title: "Yaklaşan Ödemeler", description: "Tahsilat ve ödeme takvimi", empty: "Yaklaşan ödeme yok", in: "Tahsilat", out: "Ödeme" },
      notes: {
        title: "Kişisel Notlar",
        description: "Sadece size özel notlar",
        empty: "Henüz not eklemediniz",
        placeholder: "Yeni not yazın…",
        add: "Not ekle",
        delete: "\"{{text}}\" notunu sil",
        deleteTitle: "Not silinsin mi?",
        deleteBody: "\"{{text}}\" notu kalıcı olarak silinecek. Bu işlem geri alınamaz."
      },
      calendar: { title: "Takvimim", description: "Etkinlikler ve toplantılar", empty: "Bu ay etkinlik yok", online: "Online", onsite: "Yüz yüze" },
      projects: {
        title: "Proje Durumu",
        description: "Projelerinizin güncel durumu",
        empty: "Takip edilen proje yok",
        due: "Teslim: {{date}}",
        status: { active: "Devam ediyor", planning: "Planlama", waiting: "Beklemede", done: "Tamamlandı" }
      },
      meetings: { title: "Müşteri Görüşmeleri", description: "Yaklaşan ve son görüşmeler", empty: "Planlanmış görüşme yok" },
      followups: { title: "Takiplerim", description: "Açık müşteri takipleriniz" },
      endingDemos: { title: "Bitişi yaklaşan demolar", description: "Süresi dolmak üzere olan demolar" },
      installHealth: { title: "Kurulum sağlığı", description: "Lisans ve bağlantı uyarıları" },
      financeSummary: {
        title: "Finans Özeti",
        description: "Gelir, gider ve nakit özetleri",
        empty: "Finans verisi yok",
        income: "Gelir",
        expense: "Gider",
        net: "Net",
        cash: "Nakit",
        incomeK: "Gelir (bin ₺)",
        expenseK: "Gider (bin ₺)"
      }
    },
    edit: {
      roleDefault: "Rol varsayılanı yap",
      roleDefaultHint: "Bu düzeni seçilen rolün varsayılan anasayfası yapar; kendi düzenini kaydetmemiş kullanıcılar bununla başlar. Kişinin yetkisi olmayan widget'lar ona gösterilmez.",
      roleDefaultPick: "Rol seçin",
      roleDefaultSaved: "Rolün varsayılan anasayfası kaydedildi",
      title: "Ana Sayfamı Düzenle",
      subtitle: "Size en uygun çalışma alanını oluşturun. Sürükle-bırak ile modülleri ekleyin, boyutlandırın ve yerleşimini düzenleyin.",
      breadcrumb: "Sayfa yolu",
      info: "Yerleşim değişikliği erişim yetkilerini değiştirmez. Sadece size açık modüller gösterilir ve kişisel ayarlarınız kaydedilir.",
      cancel: "İptal",
      preview: "Önizleme",
      exitPreview: "Düzenlemeye dön",
      previewTitle: "Önizleme",
      saved: "Ana sayfa yerleşiminiz kaydedildi",
      discard: "Değişiklikleri at",
      discardTitle: "Değişiklikler atılsın mı?",
      discardBody: "Kaydedilmemiş yerleşim değişiklikleriniz silinecek ve ana sayfa son kaydedilen hâliyle kalacak.",
      library: "Widget Kütüphanesi",
      searchWidgets: "Modül ara…",
      availableModules: "Size açık modüller",
      noWidgetMatch: "Aramaya uyan modül yok",
      libraryHint: "Kartları yerleşime sürükleyin ya da + ile ekleyin. Eklenen widget'lar yerleşimde sürüklenerek yer değiştirebilir.",
      restricted: "Yetkili",
      addWidget: "{{title}} ekle",
      alreadyAdded: "{{title}} yerleşimde",
      dragFromLibrary: "{{title}} widget'ını yerleşime sürükle",
      canvas: "Mevcut Yerleşim",
      draftSaved: "Taslak kaydedildi {{time}}",
      suggested: "Önerilen düzen",
      suggestedTitle: "Önerilen düzen uygulansın mı?",
      suggestedBody: "Mevcut taslak yerleşiminiz önerilen varsayılan düzenle değiştirilecek. Kaydetmeden çıkarsanız ana sayfanız değişmez.",
      apply: "Uygula",
      device: "Önizleme cihazı",
      devices: { desktop: "Masaüstü", tablet: "Tablet", mobile: "Mobil" },
      emptyCanvas: "Yerleşim boş",
      emptyCanvasHint: "Soldaki kütüphaneden widget'ları buraya sürükleyin.",
      widgetHandle: "{{title}} — seçmek için tıklayın, taşımak için sürükleyin",
      resize: "Boyutlandır",
      removeWidget: "{{title}} widget'ını kaldır",
      remove: "Widget'ı kaldır",
      removeTitle: "Widget kaldırılsın mı?",
      removeBody: "\"{{title}}\" yerleşimden kaldırılacak. Kütüphaneden yeniden ekleyebilirsiniz; değişiklik kaydedene kadar ana sayfaya yansımaz.",
      properties: "Widget Özellikleri",
      noSelection: "Bir widget seçin",
      noSelectionHint: "Boyut, görünüm ve renk ayarlarını düzenlemek için yerleşimdeki bir widget'a tıklayın.",
      size: "Boyut",
      width: "Genişlik (sütun)",
      height: "Yükseklik (satır)",
      view: "Görünüm",
      viewCard: "Kart",
      viewList: "Liste",
      tone: "Renk teması",
      tones: { primary: "Mavi", success: "Yeşil", violet: "Mor", orange: "Turuncu", danger: "Kırmızı", neutral: "Gri" },
      density: "Yoğunluk",
      comfortable: "Rahat",
      compact: "Kompakt",
      resetWidget: "Varsayılana döndür"
    }
  },
  demos: {
    columns: {
      account: "Hesap",
      ends: "Bitiş",
      status: "Durum"
    },
    extend: "Uzat",
    cancel: "İptal et",
    cancelDone: "Demo iptal edildi",
    convert: "Satışa dönüştür",
    convertConfirm: "Dönüştür",
    convertDone: "Demo satışa dönüştürüldü",
    convertHint: "İlgili sipariş kimliğini girerek demoyu satışa çevirin.",
    orderId: "Sipariş kimliği",
    fields: {
      accountId: "Hesap ID",
      days: "Gün"
    },
    form: {
      accountPlaceholder: "accountPlaceholder",
      accountRequired: "accountRequired",
      days: "days",
      extendHint: "extendHint",
      hint: "hint",
      modules: "modules",
      modulesPlaceholder: "modulesPlaceholder",
      notes: "notes",
      reason: "reason",
      reasonRequired: "reasonRequired"
    },
    new: "Yeni demo",
    statusActive: "Aktif",
    statusExpired: "Süresi dolmuş",
    subtitle: "Süreli demo kurulumları",
    title: "Demolar"
  },
  entitlements: {
    addTrial: "Deneme kalemi ekle",
    branchHint: "0 = sınırsız",
    branchLimit: "Şube limiti",
    editTerm: "Süre düzenle",
    empty: "Hak kaydı yok",
    increaseBranches: "Şube artır",
    itemCode: "Kod",
    itemKind: "Tür",
    licenseTerm: "Lisans süresi",
    makePerpetual: "Kalıcıya çevir",
    perpetual: "Kalıcı",
    reason: "Gerekçe",
    setBranches: "Şube limiti",
    unlimited: "Sınırsız",
    validUntil: "Geçerlilik bitişi"
  },
  errors: {
    VAULT_LOCKED: "Vault kilitli; PIN ile açın.",
    PIN_NOT_SET: "Vault PIN tanımlı değil; profilinizden PIN belirleyin.",
    INVALID_VERSION: "Sürüm 1.2.3 biçiminde olmalı; notlar en çok 8000 karakter.",
    RELEASE_NOT_PUBLISHABLE: "Yalnız imajı digest'le kaydedilmiş ve imzası doğrulanmış imaj işi yayımlanabilir.",
    RELEASE_ALREADY_PUBLISHED: "Bu sürüm zaten yayımlanmış.",
    MIN_PANEL_UNAVAILABLE: "Bu sunucu sürümüyle uyumlu ve en az bu sürümde yayımlanmış masaüstü panel yok. Önce paneli yayımlayın.",
    INVALID_PANEL_VERSION: "Panel sürümü ve en düşük sunucu sürümü 1.2.3 biçiminde olmalı; notlar en çok 8000 karakter.",
    PANEL_RELEASE_PUBLISHED: "Yayımlanmış panel sürümü değiştirilemez.",
    PANEL_RELEASE_NO_PACKAGE: "Paketi yüklenmemiş panel sürümü yayımlanamaz.",
    INVALID_SSH: "SSH kullanıcısı, port, sunucu anahtarı parmak izi (SHA256:…) ve özel anahtarı kontrol edin.",
    NO_SERVER: "Kuruluma müşteri sunucusu bağlanmamış.",
    SSH_NOT_CONFIGURED: "Sunucunun SSH erişimi tanımlı değil.",
    PUSH_OPEN: "Bu kurulum için açık bir SSH talebi var.",
    PUSH_NOT_PENDING: "Talep artık onay beklemiyor.",
    SELF_APPROVAL: "Kendi talebinizi onaylayamazsınız; ikinci bir yetkili onaylamalı.",
    TIME_RANGE_INVALID: "Bitiş saati başlangıçtan önce olamaz.",
    RECEIPT_CUSTOMER_MISMATCH: "Dekont, başka müşterinin tahsilatıyla eşleştirilemez.",
    OFFER_EMPTY: "Teklifte en az bir kalem olmalı.",
    MEETING_NOT_HELD: "Ulaşılamayan görüşmeye toplantı notu eklenemez.",
    MINUTE_EMPTY: "Not en az 2 karakter olmalı.",
    OFFER_ACCEPTED: "Kabul edilmiş teklif silinemez ve durumu değiştirilemez.",
    VALIDATION: "Girilen bilgiler geçersiz; alanları kontrol edin.",
    TRIAL_NO_MODULES: "Denenecek en az bir modül seçin.",
    TRIAL_ACTIVE_EXISTS: "Bu müşterinin zaten açık bir deneme lisansı var.",
    TRIAL_CLOSED: "Bu deneme kapanmış; işlem yapılamaz.",
    TRIAL_REASON_REQUIRED: "Uzatma gerekçesi yazın.",
    TRIAL_EXTEND_LIMIT: "Deneme en fazla 3 kez uzatılabilir.",
    TRIAL_ORDER_MISMATCH: "Seçilen sipariş bu müşteriye ait değil ya da reddedilmiş.",
    MESSAGE_EMPTY: "Mesaj en az 2 karakter olmalı.",
    OFFER_HAS_ORDER: "Bu teklif siparişe dönüştürülmüş; önce siparişi kaldırın.",
    OFFER_NOT_ACCEPTED: "Yalnız kabul edilmiş teklif siparişe dönüştürülebilir.",
    ORDER_DECIDED: "Bu sipariş için karar zaten verilmiş.",
    ORDER_APPROVED: "Onaylanmış sipariş silinemez.",
    LICENSE_DATE_REQUIRED: "Lisans bitiş tarihi gerekli.",
    LICENSE_DATE_PAST: "Lisans tarihleri geçmiş olamaz.",
    REJECT_NOTE_REQUIRED: "Ret gerekçesi yazın.",
    FOLLOWUP_NOTE_REQUIRED: "Takipte yapılacak işi yazın.",
    INVOICE_NUMBER_TAKEN: "Bu fatura numarası zaten kayıtlı.",
    EMAIL_INVALID: "Geçerli bir e-posta adresi girin.",
    CUSTOMER_NAME_TAKEN: "Bu adla bir müşteri zaten var.",
    CUSTOMER_HAS_FINANCE: "Finans kaydı (fatura ya da dekont) olan müşteri silinemez.",
    WALLET_IN_USE: "Kaydı olan cüzdan silinemez.",
    IBAN_INVALID: "Geçerli bir TR IBAN girin (TR + 24 rakam, kontrol hanesi doğru olmalı).",
    CARD_LAST4_INVALID: "Kart numarasının son 4 hanesini girin.",
    CARD_EXPIRY_INVALID: "Son kullanma tarihi AA/YY biçiminde olmalı.",
    TRANSFER_SAME_ACCOUNT: "Çıkış ve giriş hesabı aynı olamaz.",
    TRANSFER_NOT_ALLOWED: "Bu aktarım yapılamaz: POS'a ve POS'lar arası aktarım yok, POS'tan yalnız kasa/bankaya aktarılır; kredi kartından aktarım nakit avans olarak kaydedilir.",
    COMMISSION_INVALID: "Komisyon oranı geçersiz ya da eksik.",
    POS_INSUFFICIENT: "Aktarılacak tutar POS bakiyesini aşıyor.",
    TRANSACTION_HAS_PAYMENTS: "Ödemesi olan kayıt silinemez; önce ödeme hareketlerini silin.",
    TOTAL_BELOW_PAID: "Yeni toplam, yapılmış ödemelerin altında kalamaz.",
    PAYMENT_EXCEEDS_REMAINING: "Ödeme tutarı kalan tutarı aşamaz.",
    PARTY_NAME_TAKEN: "Bu ünvanla bir cari zaten var.",
    INVALID_AMOUNT: "Tutar sıfırdan büyük olmalı.",
    INSUFFICIENT_BALANCE: "Kasa bakiyesi yetersiz.",
    EDOC_ONLY_INCOME: "e-Belge yalnız gelir kayıtlarından oluşturulabilir.",
    EDOC_INVALID_TRANSITION: "Belge bu durumdan istenen duruma geçirilemez.",
    EDOC_EXISTS: "Bu kayıt için zaten aktif bir e-belge var.",
    CATEGORY_NAME_TAKEN: "Bu adla bir kategori zaten var.",
    CATEGORY_IN_USE: "Bu kategori {{count}} kayıtta kullanılıyor; önce kayıtları başka kategoriye taşıyın ya da pasife alın.",
    ACCOUNT_NAME_TAKEN: "Bu adla bir hesap zaten var.",
    ACCOUNT_HAS_MOVEMENTS: "Hareketi olan hesap silinemez; pasife alabilirsiniz.",
    FORBIDDEN: "Bu işlem için yetkiniz yok.",
    MUST_CHANGE_PASSWORD: "Devam etmek için şifrenizi değiştirin.",
    INVALID_JSON: "Gönderilen veri okunamadı.",
    INVALID_REQUEST: "Gönderilen değer kabul edilmedi.",
    ALREADY_EXISTS: "Bu kayıt zaten var.",
    RESOURCE_ALREADY_EXISTS: "Bu kayıt zaten var.",
    CONFLICT: "Bu kayıt zaten var.",
    DUPLICATE: "Bu kayıt zaten var.",
    INTERNAL_ERROR: "Beklenmeyen bir hata oluştu.",
    generic: "Beklenmeyen bir hata oluştu.",
    NETWORK_ERROR: "Sunucuya ulaşılamıyor. Bağlantınızı kontrol edin.",
    UNAUTHORIZED: "Oturumunuz geçersiz. Lütfen yeniden giriş yapın.",
    SESSION_EXPIRED: "Hareketsizlik nedeniyle oturumunuz kapandı.",
    PERMISSIONS_CHANGED: "Yetkileriniz güncellendi; oturum yenileniyor.",
    NOT_FOUND: "Kayıt bulunamadı.",
    INVALID_PAYLOAD: "Gönderilen bilgiler geçersiz.",
    VALIDATION_ERROR: "Lütfen alanları kontrol edin.",
    CSRF_ORIGIN_REJECTED: "Bu adresten yapılan isteğe izin verilmiyor (Origin). Yöneticinize başvurun.",
    CSRF_INVALID: "Güvenlik belirteci geçersiz; sayfayı yenileyin.",
    RATE_LIMITED: "Çok fazla deneme. Biraz bekleyip tekrar deneyin.",
    RATE_LIMIT_EXCEEDED: "Çok fazla deneme. Biraz bekleyip tekrar deneyin.",
    IP_BLOCKED: "Bu ağdan erişim geçici olarak engellendi.",
    AUTH_FAILED: "Giriş bilgileri ya da doğrulama kodu hatalı.",
    RESOURCE_NOT_FOUND: "Kayıt bulunamadı.",
    SERVICE_UNAVAILABLE: "Hizmet geçici olarak kullanılamıyor.",
    DEPARTMENT_CODE_TAKEN: "Bu kod başka bir departmanda kullanılıyor.",
    DEPARTMENT_HAS_CHILDREN: "Alt departmanları olan bir departman silinemez. Önce alt departmanları taşıyın.",
    DEPARTMENT_IN_USE: "Departmanda personel bulunduğu için silinemez. Önce personeli başka bir departmana taşıyın.",
    DEPARTMENT_ROLE_SCOPED: "Bu departman bir rolün kapsamında kullanılıyor; önce rol kapsamını güncelleyin.",
    MODULE_ALREADY_LINKED: "Bu modül zaten projede var.",
    INSTALLATION_EXISTS: "Bu yazıcı bu bilgisayara zaten kurulu; mevcut kaydı düzenleyin.",
    PRINTER_IP_INVALID: "Geçerli bir IPv4 adresi girin (ör. 192.168.1.50).",
    PRINTER_NAME_TAKEN: "Bu adla bir yazıcı zaten var.",
    PRINTER_RETIRED: "Kullanım dışı yazıcıya kurulum bilgisi eklenemez.",
    SECTOR_IN_USE: "Bu sektörde CRM müşterileri var; önce müşterilerin sektörünü değiştirin.",
    SECTOR_NAME_TAKEN: "Bu adla bir sektör zaten var.",
    CUSTOMER_MODULE_EXISTS: "Bu modül müşteride zaten kayıtlı.",
    MODULE_NOT_IN_PRODUCT: "Bu modül müşterinin ürününde sunulmuyor; önce Modül ve Fiyatlar'dan ürüne ekleyin.",
    MODULE_CODE_TAKEN: "Bu kod başka bir modülde kullanılıyor.",
    MODULE_INACTIVE: "Pasif modül projeye eklenemez.",
    MODULE_IN_USE: "Modül projelerde kullanıldığı için silinemez. Önce şu projelerden çıkarın:",
    MODULE_DEPENDENCY_CYCLE: "Bu bağımlılık döngü oluşturuyor; bir modül kendisine dolaylı olarak bağlı olamaz.",
    MODULE_HAS_DEPENDENTS: "Başka modüller bu modüle bağlı olduğu için çıkarılamaz. Önce şunları kaldırın:",
    MODULE_NAME_TAKEN: "Katalogda aynı adla bir modül zaten var.",
    PROJECT_KEY_TAKEN: "Bu görev öneki başka bir projede kullanılıyor.",
    PROJECT_MEMBER_EXISTS: "Bu personel zaten proje ekibinde.",
    PROJECT_NAME_TAKEN: "Bu adla bir proje zaten var.",
    RELEASE_VERSION_TAKEN: "Bu sürüm numarası zaten kayıtlı.",
    FEATURE_NAME_TAKEN: "Bu grupta aynı adla bir özellik zaten var.",
    FILE_TOO_LARGE: "Dosya 25 MB sınırını aşıyor.",
    ROLE_NAME_TAKEN: "Bu adla bir rol zaten var.",
    TASK_DEPENDENCY_CYCLE: "Bu bağımlılık döngü oluşturuyor; görev dolaylı olarak kendisine bağlı olamaz.",
    TASK_PARENT_INVALID: "Görev kendisinin üst görevi olamaz."
  },
  finance: {
    obligations: {
      past: {
        open: "Geçmiş ödeme ekle",
        title: "Geçmiş ödeme ekle",
        hint: "Sistem öncesinde yapılmış tek seferlik bir ödemeyi ya da tahsilatı girin (geçici vergi, SGK primi, kira, fatura…). Gider/gelir kaydı ve kasa/banka hareketi ödeme tarihiyle işlenir. Kaydettikten sonra form açık kalır.",
        titlePh: "Örn. Mart 2024 SGK primi",
        titleRequired: "Başlık gerekli",
        category: "Kategori",
        categoryHint: "Boş bırakırsanız türe göre varsayılan kategori seçilir.",
        autoCategory: "Türe göre otomatik",
        period: "Ait olduğu dönem",
        periodHint: "Örn. Nisan'da ödenen Mart SGK primi için Mart seçin. Boşsa ödeme ayı.",
        paidOnPast: "Bugün ya da geçmiş bir tarih seçin",
        saved: "{{title}} kaydedildi"
      },
      payPast: {
        open: "Geçmişi ödendi işaretle",
        title: "{{title}}: geçmiş kalemleri ödendi işaretle",
        hint: "Seçtiğiniz tarihe kadar vadesi gelmiş ve bekleyen tüm kalemler, her biri kendi vade tarihinde ve kendi tutarıyla ödenmiş olarak işlenir. Tutarı farklı olan kalemleri önce tek tek ödeyin.",
        until: "Bu tarihe kadarki kalemler",
        submit: "Ödendi işaretle",
        done: "{{count}} kalem ödendi olarak işlendi"
      },
      title: "Ödeme Planı",
      subtitle: "Kira, SGK, vergi, sunucu, muhasebe gibi düzenli ödemeler ve beklenen gelirlerin vade takvimi",
      new: "Yeni Tanım",
      info: "Vadesi yaklaşan ve geciken kalemler için firma sahiplerine ve ödeme planı hatırlatma yetkisi olan personele bildirim ve e-posta gönderilir. Ödendi olarak işaretlenen kalem için gelir/gider kaydı ve kasa/banka hareketi otomatik oluşur. Sistem öncesi dönemler için tanımı geçmiş bir başlangıç tarihiyle açıp \"Geçmişi ödendi işaretle\" ile toplu işleyebilir, düzensiz geçmiş ödemeleri \"Geçmiş ödeme ekle\" ile girebilirsiniz.",
      tabs: { schedule: "Vade Takvimi", definitions: "Tanımlar" },
      kpi: {
        overdue: "Gecikmiş ödemeler",
        items: "{{count}} kalem",
        monthOut: "Bu ay kalan ödeme",
        monthPaid: "Bu ay ödenen: {{amount}}",
        next30Out: "30 gün içinde ödenecek",
        next7: "7 gün içinde {{count}} kalem",
        next30In: "30 gün içinde beklenen gelir"
      },
      filter: { open: "Açık", paid: "Ödenen", skipped: "Atlanan", all: "Tümü" },
      direction: { out: "Ödeme (gider)", in: "Tahsilat (gelir)" },
      kinds: {
        rent: "Kira",
        sgk: "SGK",
        tax: "Vergi",
        salary: "Maaş",
        utility: "Fatura",
        subscription: "Abonelik / Sunucu",
        service: "Hizmet / Danışmanlık",
        loan: "Kredi",
        insurance: "Sigorta",
        other: "Diğer"
      },
      recurrence: { monthly: "Her ay", quarterly: "3 ayda bir", yearly: "Yılda bir", none: "Tek seferlik" },
      every: { monthly: "Her ayın {{day}}. günü", quarterly: "3 ayda bir, ayın {{day}}. günü", yearly: "Yılda bir, ayın {{day}}. günü" },
      once: "Tek sefer · {{date}}",
      offset: { "0": "Vade ayı", "1": "Bir önceki ay", "2": "İki ay önce", "3": "Üç ay önce" },
      status: { paid: "Ödendi", collected: "Tahsil edildi", skipped: "Atlandı" },
      actions: { pay: "Öde", collect: "Tahsil Et", skip: "Bu dönemi atla", unskip: "Atlamayı geri al", unpay: "Ödemeyi geri al" },
      confirm: {
        unpayTitle: "Ödeme geri alınsın mı?",
        unpayBody: "{{title}} ({{period}}) için oluşturulan gelir/gider kaydı ve kasa/banka hareketi ters kayıtla iptal edilecek; kalem yeniden açık duruma dönecek.",
        deleteTitle: "Tanım silinsin mi?",
        deleteBody: "{{title}} tanımı ve açık vadeleri silinecek. Ödenmiş kalemi olan tanımlar silinmez, pasife alınır."
      },
      remindDue: "Vade günü",
      remindBefore: "{{count}} gün önce",
      overdueGroup: "Gecikmiş",
      groupOut: "Ödeme: {{amount}}",
      groupIn: "Tahsilat: {{amount}}",
      periodLabel: "Dönem {{period}}",
      due: "Vade",
      paidOn: "ödeme {{date}}",
      today: "Bugün son gün",
      locked: "Bordrodan",
      fromPayroll: "Bordrodan otomatik",
      payrollAmount: "Tutar bordrodan",
      inactive: "Pasif",
      nextDue: "ilk açık vade {{date}}",
      emptySchedule: "Bu filtrede vade kalemi yok",
      emptyDefinitions: "Henüz ödeme planı tanımı yok",
      created: "Tanım oluşturuldu, vade takvimi hazırlandı",
      updated: "Tanım güncellendi",
      deleted: "Tanım silindi",
      deactivated: "Ödenmiş kalemleri olduğu için tanım pasife alındı",
      rateSaved: "Yeni tutar kaydedildi; açık vadeler güncellendi",
      skipped: "Kalem atlandı",
      unskipped: "Kalem yeniden açıldı",
      unpaid: "Ödeme geri alındı",
      pay: {
        titleOut: "Ödemeyi kaydet",
        titleIn: "Tahsilatı kaydet",
        hint: "Tutar KDV dahildir. Gelir/gider kaydı ve kasa/banka hareketi birlikte oluşturulur.",
        item: "Kalem",
        amountHint: "Gerçekleşen tutar farklıysa düzeltin.",
        docNo: "Belge / dekont no"
      },
      form: {
        newTitle: "Yeni ödeme planı tanımı",
        editTitle: "Ödeme planı tanımını düzenle",
        hint: "Tekrarlanan ödeme ya da gelir tanımlayın; vade takvimi 12 ay ileriye otomatik oluşturulur.",
        systemHint: "Bu tanım bordrodan otomatik oluşur; tutarlar dönem kapanışında hesaplanır. Yalnız hesap, cari ve hatırlatmalar düzenlenebilir.",
        sectionWhat: "Ne ödeniyor?",
        sectionWhen: "Ne zaman?",
        sectionAmount: "Tutar ve vergi",
        sectionRates: "Tutar geçmişi",
        title: "Başlık",
        titlePlaceholder: "Örn. Ofis kirası, AWS sunucu, Muhasebe ücreti",
        titleRequired: "Başlık girin",
        direction: "Yön",
        kind: "Tür",
        category: "Kategori",
        categoryHint: "Boş bırakılırsa türe göre otomatik seçilir",
        auto: "Otomatik",
        party: "Cari",
        optional: "İsteğe bağlı",
        note: "Not",
        account: "Varsayılan ödeme hesabı",
        accountHint: "Ödeme ekranında önceden seçili gelir",
        recurrence: "Tekrar",
        dueDay: "Son ödeme günü",
        dueDayHint: "Ay sonunu aşan gün ayın son gününe çekilir",
        startDate: "Başlangıç tarihi",
        dueDate: "Vade tarihi",
        endDate: "Bitiş tarihi",
        endDateHint: "Sözleşme bitişi; boşsa süresiz",
        periodOffset: "Ödenen dönem",
        periodOffsetHint: "Örn. SGK primi bir önceki ayın primidir",
        remind: "Hatırlatmalar",
        remindHint: "Gecikmede ilk hafta her gün, sonra haftada bir hatırlatılır.",
        amount: "Tutar (KDV dahil)",
        amountHint: "Sonraki artışlar tanımı düzenlerken tutar geçmişine eklenir",
        active: "Aktif",
        activeHint: "Pasif tanım için yeni vade oluşturulmaz ve hatırlatma gönderilmez",
        validFrom: "Geçerlilik başlangıcı",
        newAmount: "Yeni tutar",
        rateNotePlaceholder: "Örn. Yıllık TÜFE artışı",
        addRate: "Tutar ekle"
      }
    },
    fx: {
      title: "Kurlar ve Değerleme",
      subtitle: "TCMB günlük kurları, gram altın ve ay sonu kur değerlemesi; döviz/altın hesaplarının TL karşılığı alış kuruyla hesaplanır.",
      latest: "Güncel kurlar",
      empty: "Henüz kur verisi yok",
      emptyHint: "Kurlar her saat otomatik çekilir; hemen almak için \"Kurları güncelle\"yi kullanın.",
      refresh: "Kurları güncelle",
      refreshed: "Kurlar güncellendi",
      refreshPartial: "Bazı kaynaklara ulaşılamadı",
      manual: "Elle kur gir",
      manualTitle: "Elle kur girişi",
      manualHint: "Kaynağa ulaşılamadığında ya da bankanın kuru esas alınacaksa; aynı gün TCMB kurunun önüne geçer.",
      manualSaved: "Kur kaydedildi",
      sellingHint: "Boşsa alış kuru kullanılır",
      currency: "Para birimi",
      currencyHint: "Kasa, banka ve vadeli hesaplar döviz ya da gram altın olabilir; POS ve kredi kartı yalnız TL.",
      currencyLocked: "Hesap birimi açıldıktan sonra değiştirilemez.",
      buying: "Alış",
      selling: "Satış",
      date: "Tarih",
      source: "Kaynak",
      sources: { tcmb: "TCMB", truncgil: "Piyasa (altın)", manual: "Elle" },
      sourceNote: "Döviz kurları TCMB günlük bülteninden (resmi), gram altın ücretsiz bir piyasa kaynağından alınır. Değerlemede alış kuru kullanılır; elle girilen kur aynı gün önceliklidir.",
      currencies: { TRY: "Türk lirası (TRY)", USD: "ABD doları (USD)", EUR: "Euro (EUR)", GBP: "İngiliz sterlini (GBP)", CHF: "İsviçre frangı (CHF)", XAU: "Gram altın (XAU)" },
      tryEquivalent: "≈ {{amount}} · kur {{rate}} ({{date}})",
      noRate: "Kur verisi yok — TL karşılığı hesaplanamadı",
      toAmount: "Hedef tutar ({{currency}})",
      toAmountHint: "Farklı birimli hesaplar arasında hedef hesaba geçen tutar",
      toAmountRequired: "Hedef tutarı girin",
      impliedRate: "Uygulanan kur: {{rate}}",
      bankRate: "Banka kuru ({{currency}})",
      bankRateHint: "Boşsa TCMB alış kuru ({{rate}}) kullanılır",
      rateInvalid: "Kur sayı olmalı",
      revaluation: "Ay sonu kur değerlemesi",
      revaluationHint: "Döviz/altın hesaplarının defter değeri ile dönem sonu alış kuruyla değeri arasındaki fark 646 Kambiyo Kârları ya da 656 Kambiyo Zararları'na işlenir. Hesap ve dönem başına bir kez yapılır.",
      runRevaluation: "Değerlemeyi çalıştır",
      revalued: "{{count}} hesap değerlendi",
      noRevaluation: "Bu dönem değerleme yok",
      account: "Hesap",
      balance: "Bakiye",
      rate: "Kur",
      book: "Defter değeri",
      market: "Kurla değeri",
      diff: "Fark"
    },
    deposits: {
      title: "Vadeli Hesaplar",
      subtitle: "Vadesiz hesaptan anapara aktarılarak açılır; vade sonunda brüt faiz 642, stopaj 193'e işlenir, anapara + net faiz geri döner ya da vade yenilenir.",
      open: "Vadeli Hesap Aç",
      openTitle: "Vadeli hesap aç",
      openHint: "Faiz = anapara × yıllık oran × gün / gün esası; stopaj vade ve birime göre tablodan seçilir.",
      opened: "Vadeli hesap açıldı",
      listTitle: "Vadeli hesaplar",
      empty: "Vadeli hesap yok",
      account: "Hesap",
      principal: "Anapara",
      rate: "Oran",
      annualRate: "Yıllık faiz %",
      dayBasis: "Gün esası",
      term: "Vade",
      start: "Başlangıç",
      maturity: "Vade sonu",
      days: "Gün",
      daysLeft: "{{count}} gün kaldı ({{total}} gün)",
      due: "Vadesi geldi",
      closedOn: "Kapanış {{date}}",
      net: "Net faiz",
      gross: "Brüt faiz",
      tax: "Stopaj",
      maturityAmount: "Vade sonu tutarı",
      withholding: "Stopaj oranı %",
      withholdingHint: "Boşsa tablodan: %{{rate}}",
      withholdingShort: "stopaj %{{rate}} · {{amount}}",
      status: "Durum",
      statuses: { open: "Açık", matured: "Vadesi doldu", broken: "Bozuldu" },
      source: "Anaparanın çekileceği hesap",
      sourceHint: "Vadesiz banka hesabı; seçilmezse bankadaki mevcut vadeli hesap kaydedilir (anapara açılış bakiyesi olur).",
      existing: "Mevcut vadeli hesabı kaydet",
      name: "Hesap adı",
      nameHint: "Boşsa birim ve vade tarihinden oluşturulur",
      mature: "Vadeyi işle",
      break: "Boz",
      matureTitle: "{{name}} — vade sonu",
      matureHint: "Hesaplanan brüt faiz {{gross}}, stopaj {{tax}}. Bankanın tutarı farklıysa düzeltin.",
      breakTitle: "{{name}} — vadeyi boz",
      breakHint: "Vadeden önce bozmada banka genelde faiz ödemez; ödediyse brüt faizi girin.",
      closeDate: "İşlem tarihi",
      grossHint: "Boşsa hesaplanan tutar",
      returnToSource: "Anapara + net faizi kaynak hesaba aktar",
      renew: "Vadeyi yenile (anapara + net faiz yeni dönemin anaparası)",
      renewHint: "Boşsa aynı vade süresiyle",
      closed: "Vadeli hesap işlendi",
      withholdingTitle: "Mevduat stopaj oranları",
      withholdingNote: "Varsayılanlar 10041 sayılı Cumhurbaşkanı Kararı'na göre (TL oranları 11444 sayılı kararla 31.12.2026'ya kadar). Oranlar değişince yeni geçerlilik tarihiyle ekleyin; hesap açıldığı gün geçerli oran uygulanır.",
      addRate: "Oran ekle",
      addRateHint: "Yeni oran, geçerlilik tarihinden sonra açılan/yenilenen hesaplara uygulanır.",
      rateSaved: "Oran eklendi",
      group: "Grup",
      groups: { TRY: "TL mevduat", FX: "Döviz mevduatı", XAU: "Kıymetli maden" },
      band: "Vade",
      bandHint: "Ay olarak üst sınır; boş = daha uzun vadeler",
      upTo: "{{count}} aya kadar",
      longer: "Daha uzun / tümü",
      validFrom: "Geçerlilik",
      note: "Not"
    },
    bankReport: {
      title: "Banka Raporu",
      subtitle: "Bankaya göre giriş/çıkış, bankaya ödenen faiz ve masraflar, banka hesaplarından geçen gelir/giderler ve kalan kredi borcu.",
      range: "{{from}} – {{to}} arası",
      bank: "Banka",
      allBanks: "Tüm bankalar",
      inflow: "Giriş",
      outflow: "Çıkış",
      transferIn: "Gelen aktarım",
      transferOut: "Giden aktarım",
      transfers: "Hesaplar arası aktarımlar",
      costTotal: "Bankaya ödenen maliyet",
      costHint: "Komisyon, kart, kredi ve nakit avans faiz/vergi/masrafları",
      debt: "Kalan banka borcu",
      debtHint: "Kredi {{loan}} · nakit avans {{advance}}",
      loanDebt: "Kalan kredi borcu",
      advanceDebt: "Kalan nakit avans",
      byBank: "Bankalara göre",
      details: "Ayrıntılar",
      incomeByCategory: "Gelirler (kategori)",
      expenseByCategory: "Giderler (kategori)",
      empty: "Bu aralıkta bankalı hareket yok",
      emptyHint: "Banka hesaplarına banka seçildiğinde hareketleri burada görünür.",
      costs: { commission: "POS komisyonu", card: "Kart faiz/masraf", loan: "Kredi faiz/masraf", cashAdvance: "Nakit avans faizi", other: "Diğer banka gideri" }
    },
    banks: {
      title: "Bankalar",
      subtitle: "Hesap, kart, kredi ve nakit avans banka seçimleri bu listeden yapılır; logolar listelerde görünür.",
      listTitle: "Banka listesi",
      add: "Banka Ekle",
      empty: "Kayıtlı banka yok",
      inactive: "Pasif",
      select: "Banka seçin",
      none: "Banka yok",
      fromIbanHint: "IBAN girildiğinde banka kodundan otomatik seçilir.",
      uploadLogo: "Logo yükle",
      changeLogo: "Logoyu değiştir",
      removeLogo: "Logoyu kaldır",
      logoSaved: "Logo kaydedildi",
      logoRemoved: "Logo kaldırıldı",
      logoTooBig: "Logo 256 KB'ı geçemez (PNG, JPG ya da WEBP)",
      form: {
        createTitle: "Yeni banka",
        editTitle: "Bankayı düzenle",
        name: "Banka adı",
        nameRequired: "Banka adı en az 2 karakter olmalı",
        shortName: "Kısa ad",
        eft: "EFT kodu",
        eftHint: "IBAN'ın 5-9. haneleri (ör. 00064)",
        eftInvalid: "EFT kodu 4-5 haneli sayı olmalı",
        swiftInvalid: "SWIFT 8 ya da 11 karakter olmalı",
        active: "Seçim listelerinde göster",
        activeHint: "Pasif banka yeni seçimlerde görünmez; mevcut kayıtlar etkilenmez.",
        saved: "Banka kaydedildi"
      }
    },
    reminders: {
      button: "Hatırlatmalar",
      titleCompany: "Şirket ödeme hatırlatmaları",
      titlePersonal: "Ödeme hatırlatmalarım",
      hintCompany: "Kart ekstresi, kredi ve nakit avans son ödeme günleri için ödeme yetkisi olanlara (firma sahibi her zaman) uygulama içi bildirim ve e-posta gider.",
      hintPersonal: "Kendi kartlarınız, kredileriniz ve nakit avanslarınız için hatırlatma; yalnız size gider.",
      enabled: "Hatırlatmaları gönder",
      before: "Son ödemeden önce",
      overdue: "Gecikmede",
      dueDay: "Son gün",
      daysLeft: "{{count}} gün kala",
      daysLate: "{{count}}. gün",
      email: "E-posta da gönder",
      emailHintCompany: "Hatırlatma alan kullanıcıların hesap e-postalarına toplu özet gider.",
      emailHintPersonal: "Uygulama içi bildirime ek olarak e-posta gönderilir.",
      emailTo: "E-posta adresi",
      emailToHint: "Boş bırakırsanız hesap adresiniz ({{email}}) kullanılır; kişisel adresinizi de yazabilirsiniz.",
      emailInvalid: "Geçerli bir e-posta adresi yazın",
      test: "Deneme gönder",
      testSent: "Deneme e-postası {{email}} adresine gönderildi",
      saveFirst: "Önce değişiklikleri kaydedin",
      saved: "Hatırlatma ayarları kaydedildi"
    },
    paymentRequests: {
      title: "Ödeme Onayları",
      subtitle: "Personelin onaya gönderdiği ödemeler: eşik altını firma sahibi ya da bir ortak, eşik ve üstünü firma sahibi ile tüm ortaklar onaylar.",
      listTitle: "Ödeme talepleri",
      empty: "Ödeme talebi yok",
      sent: "Ödeme onaya gönderildi",
      sentHint: "Firma sahibi / ortaklar onaylayınca ödeme işlenecek; sonucu bildirim olarak alacaksınız.",
      approvers: "Onaycılar",
      requestedBy: "{{name}} · {{at}}",
      decidedBy: "Karar: {{name}} · {{at}}",
      decisionNote: "Not",
      approve: "Onayla",
      approveTitle: "Ödeme onaylansın mı?",
      approveBody: "{{summary}} · {{amount}}. Diğer onaycıların onayından sonra ödeme işlenecek.",
      approveBodyLast: "{{summary}} · {{amount}}. Onayınızla ödeme hemen işlenecek.",
      approved: "Onayınız kaydedildi",
      executed: "Ödeme onaylandı ve işlendi",
      reject: "Reddet",
      rejectTitle: "Ödeme talebini reddet",
      rejectPlaceholder: "Ret gerekçesi",
      rejectNoteRequired: "Ret gerekçesi yazın",
      rejected: "Talep reddedildi",
      withdraw: "Geri çek",
      withdrawTitle: "Talep geri çekilsin mi?",
      withdrawn: "Talep geri çekildi",
      thresholdTitle: "Onay eşiği",
      thresholdHint: "Eşiğin altındaki ödemeyi firma sahibi ya da ortaklardan biri; eşik ve üstünü firma sahibi ile tüm ortaklar onaylar. Değişiklik yalnız yeni talepleri etkiler.",
      threshold: "Eşik (₺)",
      thresholdSaved: "Eşik güncellendi",
      noApprovers: "Onay yetkisi olan firma sahibi ya da ortak yok; talepler onaysız işlenir. Ortakları İK'da \"firma ortağı\" olarak işaretleyip rollerine onay yetkisi verin.",
      filter: { pending: "Bekleyen", approved: "Onaylanan", rejected: "Reddedilen", all: "Tümü" },
      kind: { cash_out: "Kasa/banka çıkışı", ledger_payment: "Gider ödemesi", obligation_pay: "Ödeme planı" },
      level: { single: "Tek onay", all: "Tüm onaycılar" },
      status: { pending: "Onay bekliyor", approved: "İşlendi", rejected: "Reddedildi", cancelled: "Geri çekildi", failed: "İşlenemedi" },
      live: {
        requested: "Onayınızı bekleyen ödeme talebi",
        decided: { approved: "Ödeme talebiniz onaylandı", rejected: "Ödeme talebiniz reddedildi", failed: "Ödeme talebiniz işlenemedi", updated: "Ödeme talebiniz güncellendi" },
        open: "Aç"
      }
    },
    bankStatements: {
      title: "Banka ekstreleri",
      accountTitle: "{{name}} — banka ekstreleri",
      upload: "Ekstre yükle",
      empty: "Yüklenmiş banka ekstresi yok",
      noAccess: "Banka ekstrelerini görüntüleme yetkiniz yok.",
      hintPersonal: "Dosyalar şifreli saklanır; yalnız siz görebilirsiniz.",
      hintCompany: "Dosyalar şifreli saklanır; yalnız yetkililer görür, her açılış kayıt altına alınır.",
      statementOn: "Kesim {{date}}",
      dueOn: "Son ödeme {{date}}",
      download: "Dosyayı indir",
      bank: "Banka",
      system: "Sistem",
      diff: "Fark",
      total: "Dönem borcu",
      min: "Asgari",
      match: "Sistemle uyumlu",
      mismatch: "Sistemle fark var",
      noSystem: "Sistemde karşılığı yok",
      uploaded: "Ekstre yüklendi",
      deleted: "Ekstre silindi",
      deleteTitle: "Ekstre silinsin mi?",
      deleteBody: "{{name}} dosyası kalıcı olarak silinir.",
      form: {
        title: "Banka ekstresi yükle",
        hint: "Bankanın gönderdiği ekstreyi ekleyin; dönem borcu ve asgari tutarı girerseniz sistemin hesabıyla karşılaştırılır.",
        file: "Dosya",
        fileHint: "PDF, JPG, PNG, WEBP, CSV ya da XLSX; en fazla 15 MB.",
        fileRequired: "Dosya seçin",
        tooBig: "Dosya 15 MB'ı geçemez",
        period: "Dönem",
        periodRequired: "Dönem seçin",
        statementDate: "Hesap kesim tarihi",
        dueDate: "Son ödeme tarihi",
        bankTotal: "Bankanın dönem borcu",
        bankMin: "Bankanın asgari ödemesi",
        compareHint: "Kredide o ayın taksit tutarı",
        note: "Not"
      }
    },
    reimbursements: {
      title: "Personel geri ödemeleri",
      subtitle: "Onaylanan nakit ve şahsi kart müşteri giderleri (335 Personele Borçlar). Ödeme seçilen kasa ya da bankadan çıkar ve borcu kapatır.",
      open: "Ödenecek",
      paid: "Ödendi",
      empty: "Kayıt yok",
      date: "Tarih",
      staff: "Personel",
      description: "Açıklama",
      status: "Durum",
      amount: "Tutar",
      pay: "Öde",
      payTitle: "{{name}} geri ödemesi",
      payHint: "{{amount}} seçilen hesaptan ödenir.",
      account: "Ödeme hesabı",
      paidToast: "Geri ödeme yapıldı"
    },
    budgets: {
      title: "Bütçe",
      subtitle: "Yıllık bütçe sürümleri: taslak düzenlenir, onaylanan sürüm değişmez; revizyon gerekçeyle yeni sürüm açar. Kâr/zarar raporunda onaylı sürümle karşılaştırılır.",
      year: "Yıl",
      new: "Yeni bütçe",
      newHint: "Önceki yılın gerçekleşeninden ya da onaylı bütçesinden yüzde artışla doldurulabilir; sonra satırları düzenleyin.",
      create: "Oluştur",
      created: "Bütçe taslağı oluşturuldu",
      titleField: "Başlık",
      source: "Başlangıç",
      sources: { actual: "Önceki yıl gerçekleşeni", budget: "Önceki yıl onaylı bütçesi", empty: "Boş" },
      sourceYear: "Kaynak yıl",
      pct: "Artış (%)",
      byProject: "Proje kırılımıyla",
      byDepartment: "Departman kırılımıyla",
      empty: "{{year}} için bütçe yok",
      status: { draft: "Taslak", approved: "Onaylı", superseded: "Revize edildi" },
      kinds: { income: "Gelir", expense: "Gider" },
      expenseTotal: "Gider bütçesi: {{amount}}",
      incomeTotal: "Gelir bütçesi: {{amount}}",
      netTotal: "Net: {{amount}}",
      account: "Hesap",
      project: "Proje",
      allProjects: "Tüm projeler",
      addRow: "Satır ekle",
      spread: "Eşit dağıt",
      spreadTitle: "Yıllık tutarı aylara eşit dağıt",
      spreadHint: "Yıllık tutarı yazın; 12 aya bölünür (kuruş farkı aralığa eklenir).",
      saved: "Kaydedildi",
      saveFirst: "Önce değişiklikleri kaydedin",
      excel: "Excel",
      import: "Excel'den yükle",
      imported: "Bütçe Excel'den yüklendi",
      approve: "Onayla",
      approveTitle: "v{{version}} onaylansın mı?",
      approveBody: "Onaylanan sürüm değiştirilemez; yılın önceki onaylı sürümü \"revize edildi\" olur.",
      approved: "Bütçe onaylandı",
      approvedBy: "{{name}} onayladı, {{at}}",
      revise: "Revize et",
      reviseTitle: "Revizyon gerekçesi",
      reviseHint: "Onaylı sürümün kopyası yeni taslak olur; gerekçe sürüm geçmişinde görünür.",
      revised: "v{{version}} revizyon taslağı açıldı",
      reason: "Revizyon gerekçesi: {{reason}}",
      history: "Sürüm geçmişi ({{count}})",
      events: { created: "Oluşturuldu", edited: "Düzenlendi", imported: "Excel'den yüklendi", approved: "Onaylandı", revision: "Revizyon açıldı", revision_opened: "Bu sürümden revizyon açıldı" },
      settings: "Sapma eşiği",
      settingsHint: "Cari ayda bir gider hesabının gerçekleşeni onaylı bütçeyi bu yüzdeden fazla aşınca onay yetkililerine bir kez bildirim gider.",
      variancePct: "Eşik (%)",
      notify: "Aşım bildirimi gönder",
      compare: "Bütçe ile karşılaştır",
      budget: "Bütçe",
      variance: "Fark",
      kpi: "Bütçe: {{amount}}"
    },
    departments: {
      title: "Departman ataması",
      subtitle: "Gider kayıtları ve kasa çıkışları departmana göre izlenir; kayıt departmanı yevmiyeye yansır, kâr/zarar departmana göre süzülür.",
      field: "Departman",
      fieldHint: "Boş bırakılırsa kategorinin varsayılan departmanı uygulanır.",
      categoryDefault: "Kategori varsayılanı",
      all: "Tüm departmanlar",
      none: "Departmansız",
      breakdown: "Departman kırılımı",
      tabs: { assign: "Toplu atama", categories: "Kategori varsayılanları" },
      kinds: { ledger: "Gider kayıtları", cash: "Kasa çıkışları" },
      from: "Başlangıç",
      to: "Bitiş",
      assign: "Ata ({{count}})",
      assigned: "{{count}} kayda departman atandı",
      selected: "{{count}} kayıt seçildi · {{amount}}",
      selectAll: "Tümünü seç",
      noneLeft: "Departmansız kayıt yok",
      categoryHint: "Departman seçilmeden girilen gider kayıtları ve kasa çıkışları kategorinin varsayılan departmanını alır.",
      noDefault: "Varsayılan yok",
      categorySaved: "Kategori varsayılanı kaydedildi"
    },
    staffAdvances: {
      title: "Personel iş avansları",
      subtitle: "Kasadan/bankadan verilen iş avansı (195 İş Avansları). \"İş avansından\" ödenen müşteri giderleri onayda avanstan düşülür; artan avans iade alınır.",
      give: "Avans ver",
      giveShort: "Avans ver",
      returnShort: "İade al",
      giveTitle: "İş avansı ver {{name}}",
      giveHint: "Seçilen kasa ya da bankadan çıkış yapılır.",
      returnTitle: "{{name}} avans iadesi",
      returnHint: "Açık bakiye {{amount}}; iade seçilen kasa ya da bankaya giriş olur.",
      fromAccount: "Ödeme hesabı",
      toAccount: "İade hesabı",
      staff: "Personel",
      given: "Verilen",
      spent: "Gidere mahsup",
      returned: "İade",
      balance: "Açık bakiye",
      openTotal: "Toplam açık avans",
      amount: "Tutar",
      date: "Tarih",
      description: "Açıklama",
      kind: "Hareket",
      kinds: { give: "Avans", expense: "Gider mahsubu", return: "İade" },
      moves: "Hareketler",
      movesTitle: "{{name}} avans hareketleri",
      balanceIs: "Açık bakiye: {{amount}}",
      overReturn: "İade açık bakiyeyi aşamaz.",
      empty: "Verilmiş iş avansı yok",
      givenToast: "Avans verildi",
      returnedToast: "İade alındı"
    },
    pnl: {
      title: "Kâr / Zarar",
      subtitle: "Aylık gelir, gider, sabit/değişken maliyet, personel maliyeti ve net kâr; proje, cari ve banka filtresiyle.",
      basis: { accrual: "Tahakkuk bazında", cash: "Nakit bazında" },
      basisHint: {
        accrual: "Yevmiyedeki gelir ve gider hesaplarından (fatura dönemine göre). Ödeme planından doğan giderler sabit gider sayılır.",
        cash: "Fiilen tahsil edilen ve ödenen tutarlardan (ödeme gününe göre); hesaplar arası aktarımlar dahil değildir. Banka filtresi yalnız bu görünümde."
      },
      all: "Tümü",
      allProjects: "Tüm projeler",
      allParties: "Tüm cariler",
      project: "Proje",
      party: "Cari",
      line: "Kalem",
      total: "Toplam",
      income: "Gelirler",
      expense: "Giderler",
      incomeTotal: "Toplam gelir",
      expenseTotal: "Toplam gider",
      net: "Net kâr / zarar",
      margin: "Kâr marjı %{{pct}}",
      marginRow: "Kâr marjı",
      fixedVariable: "Sabit gider",
      variableFooter: "Değişken {{amount}}",
      personnelFooter: "Personel {{amount}}",
      vsPrevious: "önceki dönem ({{from}} – {{to}})",
      chart: "Aylık gelir ve gider",
      table: "Aylık döküm",
      empty: "Bu aralıkta gelir ya da gider yok",
      fixed: "Sabit",
      personnel: "Personel",
      masked: "Gizli",
      maskedHint: "Personel maliyeti ayrıntısı için yetki gerekir; tutar toplamlara dahildir.",
      uncategorized: "Kategorisiz"
    },
    openings: {
      title: "Açılış fişleri",
      hint: "Hesap açılış bakiyeleri seçilen tarih ve karşı hesapla yevmiyeye yazılır; mizanda kasa/banka bakiyeleri buradan başlar. Döviz/altın hesaplarında o günün TCMB alış kuru kullanılır. Açılış bakiyesi değişirse eski fiş ters kayıtla kapanıp yenisi yazılır.",
      empty: "Açılış bakiyesi olan hesap yok",
      account: "Hesap",
      opening: "Açılış bakiyesi",
      status: "Durum",
      date: "Fiş tarihi",
      counter: "Karşı hesap",
      amountTry: "TL karşılığı",
      rate: "Kur {{rate}}",
      notPosted: "Yazılmadı",
      stale: "Güncel değil",
      ok: "Yazıldı",
      post: "Yevmiyeye yaz",
      repost: "Yeniden yaz",
      postAll: "Bekleyenleri yaz ({{count}})",
      confirmOne: "{{name}} açılış fişi yazılsın mı?",
      confirmAll: "{{count}} hesabın açılış fişi yazılsın mı?",
      confirmBody: "Fiş tarihi {{date}}, karşı hesap {{counter}}. Dönem kilitliyse yazılamaz.",
      posted: "Açılış fişi yazıldı",
      counters: { "500": "500 Sermaye", "570": "570 Geçmiş Yıllar Kârları", "580": "580 Geçmiş Yıllar Zararları", "331": "331 Ortaklara Borçlar" }
    },
    kmh: {
      title: "KMH (ek hesap)",
      hint: "Limit nakit avansla ortaktır. Faiz her gün gün sonu eksi bakiye üzerinden işler (aylık oran × gün / 30); ay başında önceki ayın faizi + BSMV + KKDF hesaptan otomatik düşülür (780.04). Limiti aşan çıkışlar reddedilir.",
      limit: "Limit",
      cashAdvance: "Nakit avans",
      used: "KMH kullanımı",
      available: "Kullanılabilir",
      details: "Döküm",
      running: "{{from}} – {{to}} işleyen faiz {{interest}} (vergilerle {{total}}, aylık %{{rate}}); dönem sonunda hesaptan düşülür.",
      runningLines: "İşleyen dönem",
      accrual: "{{from}} – {{to}} tahakkuku: {{total}}",
      taxes: "Aylık %{{rate}} · BSMV {{bsmv}} · KKDF {{kkdf}}",
      line: "{{from}} – {{to}}: {{days}} gün × {{used}}",
      noUsage: "Bu dönemde eksi bakiye yok.",
      noAccruals: "Henüz tahakkuk yok.",
      accrue: "Faizi şimdi tahakkuk ettir",
      accrueTitle: "KMH faizi tahakkuk ettirilsin mi?",
      accrueBody: "{{from}} – {{to}} faizi, BSMV ve KKDF hesaptan düşülür ve 780.04'e işlenir. Bu dönem otomatik olarak tekrar işlenmez.",
      accrued: "KMH faizi tahakkuk ettirildi"
    },
    cashAdvances: {
      title: "Nakit Avans",
      myTitle: "Nakit avanslarım",
      subtitle: "Banka hesaplarının nakit avans limitleri, taksitli ve taksitsiz kullanımlar, faiz ve son ödeme tarihleri.",
      add: "Nakit Avans Kullan",
      empty: "Kayıtlı nakit avans yok",
      companyHint: "Nakit avans limiti tanımlı banka hesabından kullanılır (300 Banka Kredileri); faiz, vergi ve masraflar 780.04 gideri olarak işlenir.",
      personalHint: "Yalnız size görünür; muhasebeye yazılmaz. Taksitsiz avansta faiz kullanım gününden ödeme gününe gün sayısıyla işler.",
      limits: "Nakit avans limitleri",
      noLimitAccounts: "Nakit avans limiti tanımlı banka hesabı yok; Kartlar sayfasından banka hesabını düzenleyip limit girin.",
      available: "Kalan {{amount}}",
      usage: "{{used}} / {{limit}} kullanıldı",
      kmhUsage: "KMH (eksi bakiye) {{amount}}",
      accountLimit: "Nakit avans limiti",
      accountLimitHint: "Nakit avans ve KMH (ek hesap) için ortak limit: hesap, açık nakit avans düşüldükten sonra kalan tutar kadar eksiye inebilir. Boş ya da 0 ise ikisi de kullanılamaz.",
      bullet: "Taksitsiz",
      dueOn: "Son ödeme {{date}}",
      earlyNotice: "Son ödeme tarihinden önce kapatıyorsunuz: faiz kullanım gününden bugüne gün sayısıyla yeniden hesaplanır.",
      repayment: { installment: "Taksitli nakit avans", bullet: "Taksitsiz nakit avans (tek ödeme)" },
      schedule: "Ödeme planı",
      payTitle: "Nakit avans ödemesi ({{no}}/{{total}})",
      paid: "Nakit avans ödemesi kaydedildi",
      deleteTitle: "Nakit avans silinsin mi?",
      deleteBody: "Nakit avans ve ödeme planı silinir.",
      deleteBodyCompany: "Nakit avans ve ödeme planı silinir; kullanım ve masraf hareketleri ters kayıtla kapanır.",
      deleted: "Nakit avans silindi",
      payHintCompany: "Ödenecek {{amount}}, vade {{date}}. Anapara 300'e, faiz ve vergiler 780.04'e seçilen hesaptan işlenir.",
      form: {
        title: "Nakit avans kullanımı",
        sectionLoan: "Nakit avans",
        name: "Açıklama",
        namePlaceholder: "Örn. Maaş ödemesi için KMH",
        nameRequired: "Açıklama en az 2 karakter olmalı",
        principal: "Kullanılan tutar",
        monthlyRate: "Aylık nakit avans faizi %",
        zeroRateHint: "Boş bırakılırsa kredi ayarlarındaki nakit avans faizi kullanılır",
        disbursedOn: "Kullanım tarihi",
        account: "Banka hesabı",
        accountHint: "Nakit avans limiti tanımlı banka hesabı",
        accountRequired: "Banka hesabı seçin",
        repayment: "Geri ödeme",
        dueDate: "Son ödeme tarihi",
        dueAfterUse: "Son ödeme tarihi kullanım tarihinden sonra olmalı",
        overLimit: "Kalan nakit avans limitini ({{amount}}) aşıyor",
        defaultFee: "Nakit avans ücreti",
        saved: "Nakit avans kaydedildi"
      }
    },
    loans: {
      title: "Krediler",
      subtitle: "Şirket kredilerinin ödeme planı, kalan borcu ve taksit ödemeleri.",
      myTitle: "Kredilerim",
      add: "Kredi Ekle",
      empty: "Kayıtlı kredi yok",
      companyHint: "Kullandırım seçilen kasa/bankaya girer (300 Banka Kredileri); masraf, faiz ve vergiler 780.03 gideri olarak işlenir.",
      personalHint: "Yalnız size görünür; muhasebeye yazılmaz, ödeme planını ve gecikmeleri takip etmeniz içindir.",
      closed: "Kapandı",
      active: "Aktif",
      overdue: "{{count}} gecikmiş taksit",
      overdueOne: "Gecikmiş",
      rateShort: "aylık %{{rate}}",
      progress: "{{paid}}/{{total}} taksit",
      progressLabel: "Ödenen",
      next: "Sonraki taksit {{date}} · {{amount}}",
      remainingPrincipal: "Kalan anapara",
      remainingTotal: "Kalan toplam borç",
      schedule: "Ödeme planı",
      installment: "Taksit",
      principal: "Anapara",
      interest: "Faiz",
      balance: "Kalan anapara",
      dueDate: "Vade",
      totalInterest: "Toplam faiz",
      totalTax: "Toplam BSMV + KKDF",
      totalPayment: "Toplam geri ödeme",
      netDisbursement: "Hesaba geçecek",
      feesSeparate: "Ayrıca ödenecek masraf",
      fees: "Masraflar",
      statusLabel: "Durum",
      pay: "Öde",
      paid: "Taksit ödendi",
      paidOn: "Ödendi {{date}}",
      lateIncluded: "Gecikme faizi ve vergileri: {{amount}}",
      payTitle: "{{no}}/{{total}}. taksidi öde",
      payHint: "Taksit {{amount}}, vade {{date}}.",
      payHintCompany: "Taksit {{amount}}, vade {{date}}. Anapara 300'e, faiz ve vergiler 780.03'e seçilen hesaptan işlenir.",
      payDate: "Ödeme tarihi",
      payAccount: "Ödeme hesabı",
      lateNotice: "Vadesi geçmiş: gecikme faizi (aylık %{{rate}}) ve BSMV/KKDF gün sayısına göre eklenir.",
      lateManual: "Bankanın tahsil ettiği gecikme tutarını elle gireceğim",
      lateInterest: "Gecikme faizi",
      lateTax: "Gecikme BSMV + KKDF",
      unpay: "Ödemeyi geri al",
      unpayTitle: "Taksit ödemesi geri alınsın mı?",
      unpayBody: "Şirket kredisinde ödeme hareketleri ters kayıtla kapanır ve hesap bakiyesi geri döner.",
      unpaid: "Ödeme geri alındı",
      edit: "Taksidi düzelt",
      editTitle: "{{no}}. taksidi düzelt",
      editHint: "Bankanın planı küçük farklar taşıyabilir; tutarları banka planına göre girin. Sonraki kalan anaparalar yeniden hesaplanır.",
      edited: "Taksit güncellendi",
      deleteTitle: "Kredi silinsin mi?",
      deleteBody: "Kredi ve ödeme planı silinir.",
      deleteBodyCompany: "Kredi ve ödeme planı silinir; kullandırım ve masraf hareketleri ters kayıtla kapanır.",
      deleted: "Kredi silindi",
      form: {
        title: "Yeni kredi",
        sectionLoan: "Kredi",
        sectionTaxes: "Vergiler ve gecikme",
        sectionFees: "Masraflar",
        name: "Kredi adı",
        namePlaceholder: "Örn. Ticari taksitli kredi",
        nameRequired: "Kredi adı en az 2 karakter olmalı",
        principal: "Kredi tutarı",
        monthlyRate: "Aylık faiz %",
        zeroRateHint: "Faizsiz kredide 0 bırakın",
        count: "Taksit sayısı",
        countInvalid: "Taksit sayısı 1-360 olmalı",
        disbursedOn: "Kullandırım tarihi",
        firstDue: "İlk taksit tarihi",
        firstDueRequired: "İlk taksit tarihi gerekli",
        account: "Kullandırım hesabı",
        accountHint: "Kredinin yattığı kasa/banka hesabı",
        accountRequired: "Kasa/banka hesabı seçin",
        taxesHint: "Boş bırakılırsa kredi ayarlarındaki oranlar kullanılır (bireysel BSMV %15 + KKDF %15; ticari kredide genelde BSMV %5, KKDF yok).",
        lateRate: "Gecikme faizi (aylık %)",
        feeName: "Masraf adı",
        defaultFee: "Dosya masrafı",
        deducted: "Kullandırımdan düşülür",
        addFee: "Masraf ekle",
        feeInvalid: "Her masrafın adı ve tutarı olmalı",
        preview: "Ödeme planı",
        previewHint: "Tutar, faiz, taksit sayısı ve ilk taksit tarihini girince plan hesaplanır.",
        saved: "Kredi kaydedildi"
      }
    },
    credit: {
      title: "Kart ekstreleri",
      myCards: "Kredi kartlarım",
      empty: "Kredi kartı yok; önce kart hesabı ekleyin",
      emptyPersonal: "Henüz kart eklemediniz",
      addCard: "Kart ekle",
      inactive: "Pasif",
      limit: "Limit",
      days: "Kesim {{statement}} · son ödeme {{due}}",
      notReady: "Ekstre için hesap kartında kesim ve son ödeme günü tanımlayın.",
      nextStatement: "Sonraki kesim: {{date}}",
      totalDue: "Dönem borcu",
      minDue: "Asgari ödeme",
      dueDate: "Son ödeme",
      paidSince: "Ödenen: {{amount}}",
      noStatement: "Henüz ekstre kesilmedi",
      statements: "Ekstreler",
      txns: "Hareketler",
      noTxns: "Kayıtlı hareket yok",
      companyTxnsHint: "Peşin harcama ve ödemeler kart hesabının hareketlerinden gelir; burada taksitli harcama, ücret ve iade görünür.",
      addTxn: "Hareket ekle",
      addInstallment: "Taksitli harcama",
      profile: "Oranlar",
      settings: "Oran ayarları",
      issueDue: "Vadesi gelen ekstreleri kes",
      issued: "{{count}} ekstre kesildi",
      period: "Dönem: {{from}} – {{to}}",
      installmentOf: "{{n}}/{{of}} taksit",
      ratesUsed: "Uygulanan aylık oranlar: akdi %{{purchase}}, gecikme %{{late}}, nakit avans %{{cash}}",
      statementsTitle: "{{card}} · ekstreler",
      statementsHint: "Ekstre kesildiği anki oranlarla saklanır; ödemeler bir sonraki kesime kadar bu ekstreye sayılır.",
      voidTitle: "Hareket iptal edilsin mi?",
      voidBody: "Hareket ekstreden çıkar; şirket kartında gider kaydı da ters kayıtla kapanır.",
      voided: "Hareket iptal edildi",
      status: {
        paid: "Ödendi",
        min_paid: "Asgari ödendi",
        due: "Ödenecek",
        overdue: "Gecikmede"
      },
      kind: {
        purchase: "Harcama",
        cash_advance: "Nakit avans",
        fee: "Ücret / masraf",
        refund: "İade",
        payment: "Ödeme"
      },
      f: {
        previous: "Önceki dönem borcu",
        payments: "Ödemeler",
        purchases: "Harcamalar ve taksitler",
        cashAdvances: "Nakit avans",
        fees: "Ücretler",
        refunds: "İadeler",
        contractInterest: "Akdi faiz",
        lateInterest: "Gecikme faizi",
        cashAdvanceInterest: "Nakit avans faizi",
        bsmv: "BSMV (%{{rate}})",
        kkdf: "KKDF (%{{rate}})",
        future: "Gelecek dönem taksitleri",
        overLimit: "Limit aşımı"
      },
      rates: {
        purchase: "Akdi faiz (aylık %)",
        cashAdvance: "Nakit avans faizi (aylık %)",
        late: "Gecikme faizi (aylık %)"
      },
      scope: {
        company: "Ticari (şirket kartları)",
        personal: "Bireysel (kişisel kartlar)"
      },
      txn: {
        title: "{{card}} · hareket",
        companyHint: "Taksitli harcama, ücret ya da iade girin; gider kaydı karta işlenir, taksitler dönemlere bölünür. Peşin harcamayı kart hesabından \"Kartla harcama\" ile girin.",
        personalHint: "Harcama (taksitli olabilir), nakit avans, ücret, iade ya da karta yaptığınız ödemeyi girin.",
        kind: "Hareket türü",
        installments: "Taksit",
        single: "Peşin",
        nInstallments: "{{count}} taksit",
        perInstallment: "Taksit başına ~{{amount}}",
        description: "Açıklama",
        categoryRequired: "Gider kategorisi seçin",
        saved: "Hareket kaydedildi"
      },
      form: {
        createTitle: "Kart ekle",
        editTitle: "Kartı düzenle",
        profileTitle: "Karta özel oranlar",
        personalHint: "Kartınızı yalnız siz görürsünüz. Ekstre kesim gününde otomatik çıkar, son ödeme öncesi hatırlatılır.",
        companyHint: "Limit ve kesim/son ödeme günleri kart hesabından düzenlenir. Boş bırakılan oranlarda ticari varsayılanlar kullanılır.",
        sectionCard: "Kart",
        sectionRates: "Faiz oranları",
        ratesHint: "Bankanızın bu kart için uyguladığı aylık oranlar; boş bırakırsanız varsayılan oranlar kullanılır.",
        defaultRate: "Varsayılan",
        name: "Kart adı",
        statementDay: "Hesap kesim günü",
        dueDay: "Son ödeme günü",
        nameRequired: "Kart adını girin",
        limitRequired: "Limiti girin",
        daysInvalid: "Günler 1 ile 31 arasında olmalı",
        saved: "Kart kaydedildi"
      },
      settingsTitle: "Kart ve kredi oranları",
      settingsHint: "TCMB azami faiz ve vergi oranları değiştikçe geçerlilik tarihiyle yeni sürüm ekleyin; ekstre ve KMH tahakkukları o günkü sürümle hesaplanır, kesilmiş ekstreler değişmez.",
      settingsValidHint: "Bu tarihten itibaren kesilen ekstrelerde geçerli; ileri tarih girilebilir.",
      settingsCurrent: "Bugün geçerli sürüm {{from}} tarihli (kayıt {{date}})",
      settingsFields: {
        validFrom: "Geçerlilik başlangıcı",
        note: "Açıklama (ör. TCMB kararı)",
        purchaseRate: "Akdi faiz (aylık %)",
        lateRate: "Gecikme faizi (aylık %)",
        cashAdvanceRate: "Nakit avans faizi (aylık %)",
        cashAdvanceLateRate: "Nakit avans gecikme faizi (aylık %, boşsa genel gecikme)",
        kmhRate: "KMH faizi (aylık %, boşsa nakit avans faizi)",
        bsmvRate: "BSMV (%)",
        kkdfRate: "KKDF (%)",
        minThreshold: "Asgari ödeme limit eşiği (₺)",
        minLowRate: "Eşik ve altı asgari ödeme (%)",
        minHighRate: "Eşik üstü asgari ödeme (%)"
      },
      settingsInvalid: "Tüm alanlara 4,25 gibi sayı girin",
      settingsSaved: "Oranlar kaydedildi",
      settingsUpdated: "Son güncelleme: {{date}}",
      tiers: {
        title: "Dönem borcuna göre dilimli oranlar",
        hint: "TCMB bireysel kartlarda oranı dönem borcuna göre belirler. Dilim tanımlıysa akdi/gecikme faizi önceki dönem borcunun düştüğü dilimden alınır; boşsa yukarıdaki tek oran kullanılır.",
        add: "Dilim ekle",
        upTo: "Dönem borcu üst sınırı (₺)",
        above: "Üstü (sınırsız)",
        purchase: "Akdi %",
        late: "Gecikme %",
        none: "Dilim yok; tek oran uygulanır."
      },
      history: {
        title: "Oran sürümleri",
        purchase: "Akdi / gecikme",
        cash: "Nakit avans · KMH",
        min: "Asgari ödeme eşiği",
        note: "Açıklama",
        active: "geçerli",
        pending: "bekliyor"
      },
      preview: "Güncel dönem",
      previewHint: "Henüz kesilmemiş dönemin bugüne kadarki hareketler ve işlemiş faizle ön izlemesidir; kesim gününde tutarlar değişebilir.",
      interestLines: "Faiz dökümü",
      interestKind: { contract: "Akdi faiz", late: "Gecikme faizi", cash_advance: "Nakit avans faizi" },
      interestFormula: "{{base}} × %{{rate}} × {{days}} gün / 30 ({{from}} – {{to}})"
    },
    accounts: {
      showVoided: "İptalleri göster",
      voided: "İptal edildi",
      details: "Ayrıntılar",
      trail: {
        createdBy: "Oluşturan",
        createdAt: "Oluşturma",
        voidRequestedBy: "İptal talebi",
        voidReason: "İptal gerekçesi",
        voidedBy: "İptal eden / onaylayan",
        voidedAt: "İptal tarihi",
        voidNote: "Onay notu",
        voidEffect: "İptal edilen hareket bakiyeye ve dönem toplamlarına dahil edilmez; muhasebe kaydı ters kayıtla kapatılmıştır."
      },
      accountNo: "Hesap no",
      activeLabel: "Aktif (ödeme ve para aktarımlarında seçilebilir)",
      add: "Hesap Ekle",
      allAccounts: "Tüm hesaplar",
      availableLimit: "Kullanılabilir limit",
      balance: "Bakiye",
      bank: "Banka",
      branch: "Şube",
      cardBrand: "Kart markası",
      cardDebt: "Kart borcu",
      cardExpiry: "Son kullanma (AA/YY)",
      cardHolder: "Kart sahibi",
      cardLast4: "Kart no (son 4 hane)",
      cardLimit: "Kart limiti",
      closing: "Dönem sonu",
      created: "Hesap eklendi",
      cycle: "Kesim / son ödeme",
      cycleValue: "Her ayın {{statement}}. / {{due}}. günü",
      deleteBody: "“{{name}}” silinecek. Hareketi olan hesaplar silinemez; pasife alabilirsiniz.",
      deleted: "Hesap silindi",
      deleteTitle: "Hesap silinsin mi?",
      dueDay: "Son ödeme günü",
      empty: "Henüz kasa ya da POS yok",
      emptyHint: "Nakit kasanızı ve sanal POS'larınızı ekleyerek başlayın.",
      filter: "Hesap filtresi",
      form: {
        accountRequired: "Hesap seçin",
        branchPlaceholder: "Örn. Kızılay Ticari (0912)",
        cardSafety: "Güvenlik gereği tam kart numarası ve CVV saklanmaz.",
        clearIban: "Kayıtlı IBAN'ı sil",
        createTitle: "Yeni kasa / POS",
        dayInvalid: "1–28 arası bir gün girin",
        editTitle: "Hesabı düzenle",
        expiryPlaceholder: "AA/YY",
        hint: "Nakit kasa ya da sanal POS. Bakiye hareketlerden hesaplanır.",
        ibanHint: "TR ile başlayan 26 karakter; kontrol hanesi doğrulanır.",
        ibanKeep: "Kayıtlı: {{masked}} — değiştirmek için yeni IBAN girin, boş bırakırsanız korunur.",
        last4Hint: "Güvenlik için yalnız IBAN ya da kart numarasının son 4 hanesi saklanır.",
        last4Invalid: "4 rakam girin",
        nameRequired: "Hesap adı en az 2 karakter olmalı",
        sectionBank: "Banka bilgileri",
        sectionCard: "Kart bilgileri",
        sectionGeneral: "Genel bilgiler",
        sectionType: "Hesap türü",
        typeHint: {
          bank: "Vadesiz / ticari hesap",
          cash: "Nakit para",
          credit_card: "Şirket kartı",
          pos: "Kartlı tahsilat"
        },
        typePrompt: "Devam etmek için hesap türünü seçin; ilgili alanlar seçiminize göre açılır.",
        typeRequired: "Hesap türünü seçin"
      },
      from: "Çıkış hesabı",
      iban: "IBAN",
      last4: "Son 4 hane",
      merchantId: "Üye işyeri no",
      movements: "Hesap Hareketleri",
      name: "Hesap adı",
      noMovements: "Hareket yok",
      opening: "Açılış bakiyesi",
      settlementIban: "Hesaba geçiş IBAN'ı",
      pos: {
        section: "POS tahsilatı",
        mode: "Kasa/bankaya aktarım",
        modes: {
          manual: "Manuel (aktarımda oran girilir)",
          auto: "Otomatik (valör gününde)"
        },
        modeHint: {
          manual: "POS'tan kasa/bankaya aktarımı siz yaparsınız; o anki komisyon oranını aktarımda girersiniz.",
          auto: "Tahsilatlar valör günü dolunca komisyon düşülerek hedef hesaba kendiliğinden aktarılır."
        },
        days: "Valör (gün)",
        daysHint: "1 = ertesi gün. 0 aynı gün aktarır.",
        daysInvalid: "0 ile 60 arasında bir gün girin",
        daysRequired: "Valör gününü girin",
        rate: "Komisyon oranı (%)",
        rateNow: "Uygulanacak komisyon oranı (%)",
        rateNowHint: "Bu aktarımda bankanın kestiği oran; komisyon gider olarak işlenir.",
        rateInvalid: "Oranı 1,79 gibi yüzde olarak girin",
        rateRequired: "Komisyon oranını girin (kesinti yoksa 0)",
        target: "Aktarılacak hesap",
        targetRequired: "Kasa ya da banka hesabı seçin",
        commission: "Komisyon gideri",
        net: "Hesaba geçecek net tutar",
        expenseHint: "Komisyon \"Banka ve POS Komisyonları\" gideri olarak POS'tan düşülür."
      },
      showMovements: "Bu dönemin hareketleri ({{count}})",
      source: {
        entry: "Kasa girişi / çıkışı",
        payment: "Tahsilat / ödeme",
        payment_expense: "Fatura ödemesi",
        payment_income: "Fatura tahsilatı",
        transfer: "Hesaplar arası aktarım"
      },
      statementDay: "Hesap kesim günü",
      subtitle: "Nakit kasa ve sanal POS hesaplarınızın bakiyeleri ve hareketleri. Kredi kartları ve banka hesapları Kartlar sayfasındadır.",
      summary: {
        closing: "Dönem sonu bakiye",
        inflow: "Toplam giriş",
        opening: "Dönem başı bakiye",
        outflow: "Toplam çıkış"
      },
      title: "Kasa ve POS",
      to: "Giriş hesabı",
      total: "Toplam nakit varlık",
      totalHint: "Kasa ve sanal POS hesaplarının bakiye toplamı. Banka hesapları ve kredi kartları Kartlar sayfasında izlenir.",
      transfer: "Para Aktar",
      transferDeleteBody: "{{amount}} tutarındaki para aktarımı silinecek; iki hesabın bakiyesi de güncellenir.",
      transferDeleteTitle: "Para aktarımı silinsin mi?",
      transferHint: "Hesaplar arasında para aktarımı; gelir ya da gider sayılmaz.",
      transferred: "Para aktarımı kaydedildi",
      transferShort: "Aktar",
      type: "Hesap türü",
      updated: "Hesap güncellendi"
    },
    cards: {
      add: "Kart Ekle",
      allCards: "Tüm kartlar ve hesaplar",
      available: "Kullanılabilir kart limiti",
      bankTotal: "Banka hesapları bakiyesi",
      createTitle: "Yeni kart / banka hesabı",
      editTitle: "Kartı düzenle",
      empty: "Henüz kart ya da banka hesabı yok",
      emptyHint: "Kredi kartlarınızı ve banka hesaplarınızı ekleyin; bakiye, borç ve harcamaları buradan izleyin.",
      formHint: "Önce kredi kartı mı banka hesabı mı ekleyeceğinizi seçin. Kartlarda yalnız son 4 hane saklanır.",
      movements: "Kart ve Hesap Hareketleri",
      payDebt: "Kart Borcu Öde",
      payDebtShort: "Borç öde",
      spend: "Harcama Ekle",
      spendShort: "Harcama",
      spendTitle: "Kart harcaması",
      subtitle: "Kredi kartlarınız ve banka hesaplarınız: bakiyeler, limitler, borçlar ve harcamalar.",
      title: "Kartlar",
      totalDebt: "Toplam kredi kartı borcu",
      totalHint: "Kart borcunu ödemek için \"Kart Borcu Öde\" ile banka hesabından karta aktarım yapın."
    },
    accountType: {
      bank: "Banka hesabı",
      cash: "Kasa",
      credit_card: "Kredi kartı",
      pos: "Sanal POS",
      deposit: "Vadeli hesap"
    },
    actions: "İşlemler",
    allPeriods: "Tüm dönemler",
    amount: "Tutar",
    cardBrand: {
      amex: "American Express",
      mastercard: "Mastercard",
      troy: "Troy",
      visa: "Visa"
    },
    cash: {
      chartTitle: "Nakit akışı (son 6 ay, {{period}})",
      closing: "Dönem sonu bakiye",
      current: "Güncel nakit",
      currentHint: "Tüm hesapların bakiyesi",
      due: "Vade: {{date}}",
      expectedIn: "Beklenen tahsilat",
      expectedInHint: "Açık alacakların toplamı",
      expectedOut: "Beklenen ödeme",
      expectedOutHint: "Açık borçların toplamı",
      inflow: "Giriş",
      net: "Net",
      noUpcoming: "Açık tahsilat ya da ödeme yok.",
      outflow: "Çıkış",
      overdue: "Vadesi geçti: {{date}}",
      projected: "Öngörülen bakiye",
      projectedHint: "Tüm açık kalemler kapanınca",
      subtitle: "Gerçekleşen giriş/çıkışlar, dönem sonu bakiyeleri ve yaklaşan tahsilat/ödemeler.",
      tableTitle: "Aylık nakit akışı",
      title: "Nakit Akışı",
      upcoming: "Yaklaşan Tahsilat ve Ödemeler"
    },
    categories: {
      activeLabel: "Aktif (yeni kayıtlarda seçilebilir)",
      color: "Renk",
      colorN: "Renk {{n}}",
      created: "Kategori eklendi",
      createTitle: "Yeni kategori",
      deleteBody: "“{{name}}” kategorisi silinecek.",
      deleted: "Kategori silindi",
      deleteTitle: "Kategori silinsin mi?",
      editTitle: "Kategoriyi düzenle",
      expense: "Gider Kategorileri",
      hint: "Gider kategorilerinde KDV durumu, vergi ön izlemesinde indirilecek KDV hesabını etkiler.",
      income: "Gelir Kategorileri",
      name: "Kategori adı",
      nameRequired: "Kategori adı en az 2 karakter olmalı",
      subtitle: "Gelir ve gider kayıtlarını sınıflandıran kategoriler ve KDV durumları.",
      title: "Kategoriler",
      updated: "Kategori güncellendi",
      usage: "{{count}} kayıt",
      vatStatus: "KDV durumu"
    },
    category: "Kategori",
    channel: {
      card: "Kredi kartı",
      cash: "Nakit",
      pos: "POS",
      transfer: "Havale / EFT"
    },
    customer: "Müşteri",
    customers: "müşteri",
    edoc: {
      actions: {
        cancel: "İptal Et",
        query: "Durumu Sorgula",
        redraft: "Taslağa Al",
        send: "GİB'e Gönder"
      },
      confirm: {
        cancelBody: "{{number}} numaralı belge ({{party}}) iptal edilecek. İptal edilen belge geri alınamaz.",
        cancelTitle: "Belge iptal edilsin mi?",
        redraftBody: "Reddedilen {{number}} belgesi düzeltilmek üzere taslağa alınacak.",
        redraftTitle: "Taslağa alınsın mı?",
        sendBody: "{{number}} numaralı belge {{party}} adına GİB'e gönderilecek.",
        sendTitle: "Belge gönderilsin mi?"
      },
      create: "e-Belge Oluştur",
      created: "Taslak e-belge oluşturuldu",
      createHint: "Gelir kaydından taslak belge oluşturulur; tutar ve alıcı kayıttan alınır.",
      createTitle: "e-Belge oluştur",
      done: {
        cancel: "Belge iptal edildi",
        query: "GİB durumu güncellendi",
        redraft: "Belge taslağa alındı",
        send: "Belge gönderildi"
      },
      empty: "Bu filtrede e-belge yok",
      incoming: "Gelen",
      info: "Belge gönderimi ve durum sorgulama özel entegratör üzerinden yapılır. Bu ekran şu an örnek veriyle çalışır; GİB'e gerçek gönderim yapılmaz.",
      list: "e-Fatura ve e-Arşiv Belgeleri",
      new: "Yeni e-Belge",
      outgoing: "Giden",
      sourceTx: "Gelir kaydı",
      status: {
        accepted: "Kabul edildi",
        cancelled: "İptal",
        draft: "Taslak",
        rejected: "Reddedildi",
        sent: "Gönderildi"
      },
      subtitle: "GİB e-Fatura ve e-Arşiv belgelerinin oluşturulması, gönderimi ve durum takibi.",
      title: "GİB e-Belgeler",
      type: "Belge türü",
      typeHint: {
        e_archive: "e-Fatura mükellefi olmayan alıcılar için",
        e_invoice: "Alıcı e-Fatura mükellefi ise"
      },
      types: {
        e_archive: "e-Arşiv",
        e_invoice: "e-Fatura"
      }
    },
    entry: {
      addIn: "Kasaya Giriş",
      addOut: "Kasadan Çıkış",
      categoryHint: "Kategori seçilirse nakit akışı ve genel bakış raporlarına gelir/gider olarak yansır.",
      date: "İşlem tarihi",
      deleteBody: "“{{name}}” ({{amount}}) hareketi silinecek; hesap bakiyesi güncellenir.",
      deleteTitle: "Kasa hareketi silinsin mi?",
      descriptionRequired: "Açıklama en az 2 karakter olmalı",
      direction: "İşlem yönü",
      filter: {
        all: "Tümü",
        in: "Girişler",
        out: "Çıkışlar"
      },
      hint: "Faturaya bağlı olmayan para girişi ya da çıkışı: peşin satış, küçük harcama, sermaye girişi vb. Fatura ödemeleri “Gelir ve Giderler” ekranından kaydedilir.",
      in: "Giriş",
      inShort: "Giriş",
      noCategoryIn: "Kategorisiz (ör. sermaye girişi)",
      noCategoryOut: "Kategorisiz (ör. ortak para çekimi)",
      out: "Çıkış",
      outShort: "Çıkış",
      placeholderIn: "Örn. peşin eğitim ücreti",
      placeholderOut: "Örn. kargo ve kurye ödemesi",
      reference: "Makbuz / fiş no",
      savedIn: "Kasaya giriş kaydedildi",
      savedOut: "Kasadan çıkış kaydedildi",
      titleIn: "Kasaya para girişi",
      titleOut: "Kasadan para çıkışı"
    },
    estimated: "Tahmini",
    exportCsv: "Rapor İndir (CSV)",
    form: {
      amountInvalid: "Geçerli bir tutar girin",
      dateRequired: "Tarih seçin",
      dueBeforeDate: "Vade, belge tarihinden önce olamaz"
    },
    iban: {
      copied: "IBAN panoya kopyalandı",
      copy: "IBAN'ı kopyala",
      hide: "IBAN'ı gizle",
      show: "IBAN'ı göster",
      showHint: "Tam IBAN gösterilir; bu işlem denetim kaydına yazılır."
    },
    kind: {
      expense: "Gider",
      income: "Gelir"
    },
    noComparison: "Önceki ay verisi yok",
    noData: "Bu dönem için veri yok",
    overview: {
      accrual: "Kârlılık (tahakkuk bazlı)",
      accrual_expense: "Tahakkuk bazlı gider",
      accrual_income: "Tahakkuk bazlı gelir",
      accrual_result: "Tahakkuk bazlı sonuç",
      accrualHint: "Tahsilat ve ödeme durumundan bağımsız olarak dönem içinde kesilen belgelerin KDV hariç tutarlarıyla hesaplanır.",
      categories: "Gider Kategorileri",
      collected: "Tahsil edilen gelir",
      detail: {
        amount: "Tutar",
        category: "Kategori",
        count: "Belge sayısı",
        counts: "{{count}} belge · {{missing}} eksik",
        documented: "Belgelenen",
        missing: "Eksik belge tutarı",
        missingCount: "Eksik belge",
        review: "Mali müşavir incelemesi"
      },
      detailTitle: "Gider kategorileri detayı ({{period}})",
      expenseSeries: "Gider (ödenen)",
      incomeSeries: "Gelir (tahsil edilen)",
      missingDocs: "Eksik belge sayısı",
      missingDocsHint: "Vergi beyanı için tamamlanması gereken belgeler",
      monthly: "Gelir ve Gider (aylık)",
      netCash: "Nakit farkı",
      paidOut: "Ödenen gider",
      partiesDocs: "{{parties}} {{party}} · {{docs}} belge",
      payable: "Toplam borç",
      receivable: "Toplam alacak",
      subtitle: "Finansal durum, vergi yükümlülükleri ve önemli metrikler tek ekranda.",
      tax_corporate: "Kurumlar / Gelir Vergisi",
      tax_corporateHint: "Dönem kârı üzerinden",
      tax_vat: "KDV ({{period}})",
      tax_vatHint: "Hesaplanan − indirilecek (devreden düşülür)",
      tax_withholding: "Stopaj ({{period}})",
      tax_withholdingHint: "Muhtasar; kira vb. kesintiler",
      taxHint: "Bu tutarlar sistemde tanımlı vergi parametrelerine göre hesaplanan tahmini değerlerdir; beyanname değildir.",
      taxTitle: "Vergi Yükümlülükleri (tahmini)",
      title: "Şirket Finansına Genel Bakış",
      totalExpense: "Toplam gider"
    },
    parties: {
      add: "Cari Ekle",
      bank: "Banka",
      contact: "İletişim",
      created: "Cari eklendi",
      createTitle: "Yeni cari",
      editTitle: "Cariyi düzenle",
      email: "E-posta",
      emailInvalid: "Geçerli bir e-posta girin",
      empty: "Cari bulunamadı",
      filter: {
        all: "Tümü",
        customer: "Müşteriler",
        supplier: "Tedarikçiler"
      },
      hint: "Tedarikçi ya da müşteri bilgileri; ödeme yaparken banka ve IBAN bilgisi buradan gelir.",
      kind: {
        customer: "Müşteri",
        supplier: "Tedarikçi"
      },
      lastOpen: "En eski açık kalem",
      list: "Cari listesi",
      name: "Ünvan",
      nameRequired: "Ünvan en az 2 karakter olmalı",
      noOpen: "Açık kalem yok",
      open: "Açık kalem",
      openValue: "{{count}} açık kayıt",
      phone: "Telefon",
      search: "Ünvan ya da VKN ara…",
      sectionBank: "Banka bilgileri",
      sectionGeneral: "Genel bilgiler",
      subtitle: "Tedarikçi ve müşterilerin vergi, banka ve iletişim bilgileri.",
      taxNo: "VKN / TCKN",
      taxNoInvalid: "10 haneli VKN ya da 11 haneli TCKN girin",
      taxOffice: "Vergi dairesi",
      title: "Cariler",
      updated: "Cari güncellendi"
    },
    passive: "Pasif",
    pay: {
      account: "Hesap / kasa",
      add: "Ödeme Kaydet",
      addIn: "Tahsilat ekle",
      addOut: "Ödeme ekle",
      channel: "Ödeme kanalı",
      collected: "Tahsilat kaydedildi",
      date: "Ödeme tarihi",
      deleteBody: "{{amount}} tutarındaki hareket silinecek; ilgili kaydın kalan tutarı yeniden açılır.",
      deleted: "Ödeme kaydı silindi",
      deleteTitle: "Ödeme kaydı silinsin mi?",
      empty: "Henüz ödeme hareketi yok",
      form: {
        accountRequired: "Hesap seçin",
        amountIn: "Tahsil edilen tutar",
        amountOut: "Ödenen tutar",
        hint: "Tahsilat ya da ödemeyi ilgili fatura/borçla eşleştirin; dekontu ekleyin.",
        noBank: "Banka bilgisi girilmemiş",
        partial: "Kısmi ödeme yapıyorum",
        partialHint: "İşaretlemezseniz kalan tutarın tamamı kapatılır.",
        payee: "Alıcı (ödeme yapılan)",
        payer: "Gönderen (tahsilat yapılan)",
        pickFile: "Dosya Seç",
        receipt: "Dekont / makbuz",
        receiptHint: "PDF ya da görsel (en fazla 10 MB)",
        sectionDetails: "Ödeme bilgileri",
        sectionMatch: "Eşleştirme",
        title: "Ödeme kaydet ve dekont eşleştir",
        tx: "İlgili fatura / borç",
        txRequired: "Kayıt seçin"
      },
      movements: "Ödeme Hareketleri",
      note: "Açıklama",
      paid: "Ödeme kaydedildi",
      receiptMissing: "Dekont yok",
      receiptOk: "Dekont var",
      reference: "Referans no"
    },
    payStatus: {
      expense: {
        paid: "Ödendi",
        partial: "Kısmen ödendi",
        unpaid: "Ödenmedi"
      },
      income: {
        paid: "Tahsil edildi",
        partial: "Kısmen tahsil",
        unpaid: "Tahsil edilmedi"
      }
    },
    period: "Dönem",
    books: {
      account: "Hesap",
      balance: "Bakiye",
      balanced: "Denk",
      code: "Kod",
      credit: "Alacak",
      debit: "Borç",
      empty: "Bu dönemde mizan hareketi yok",
      journalTitle: "Yevmiye",
      noJournals: "Bu dönemde yevmiye kaydı yok",
      subtitle: "Dönem mizanı ve yevmiye kayıtları; iptaller ters kayıt olarak görünür.",
      title: "Yevmiye ve Mizan",
      trialTitle: "Mizan",
      unbalanced: "Denk değil",
      reversedBy: "Ters kaydı: #{{no}}",
      groups: { opening: "Devir", period: "Dönem", total: "Toplam", balance: "Bakiye" },
      cols: {
        openingDebit: "Devir borç",
        openingCredit: "Devir alacak",
        periodDebit: "Dönem borç",
        periodCredit: "Dönem alacak",
        totalDebit: "Toplam borç",
        totalCredit: "Toplam alacak",
        balanceDebit: "Borç bakiye",
        balanceCredit: "Alacak bakiye"
      },
      source: {
        ledger_accrual: "Gelir/gider",
        ledger_payment: "Tahsilat/ödeme",
        transfer: "Aktarım",
        cash_in: "Kasa girişi",
        cash_out: "Kasa çıkışı",
        reversal: "Ters kayıt",
        manual: "Elle fiş",
        opening: "Açılış",
        payroll: "Bordro",
        other: "Diğer"
      }
    },
    reports: {
      accrual: "Tahakkuk (gelir-gider)",
      allPeriods: "Tüm dönemler",
      byCategory: "Kategorilere göre gider",
      cash: "Kasa/banka toplamı",
      cashFlowTitle: "Nakit Akışı",
      cashSection: "Nakit ve cari",
      collected: "Tahsilat",
      corporate: "Tahmini kurumlar vergisi",
      count: "{{count}} kayıt",
      cols: {
        category: "Kategori", closing: "Kapanış", date: "Tarih", description: "Açıklama", doc: "Belge no", inflow: "Giriş",
        kind: "Tür", missingDoc: "Belgesiz", month: "Ay", net: "Net", outflow: "Çıkış", party: "Cari", remaining: "Kalan",
        total: "Toplam", vat: "KDV", withholding: "Stopaj"
      },
      csv: "CSV indir",
      excel: "Excel (.xlsx, grafikli)",
      corporatePdf: "Kurumsal PDF",
      preparing: "Hazırlanıyor…",
      expenseTotal: "Gider toplamı",
      export: "Dışa aktar",
      incomeTotal: "Gelir toplamı",
      managementButton: "Yönetim özeti",
      managementNote: "Tutarlar sistem kayıtlarından alınmıştır; resmi beyan yerine geçmez.",
      managementTitle: "Aylık Yönetim Özeti",
      missingDocs: "Belgesi eksik kayıt",
      netCash: "Net nakit",
      paidOut: "Ödeme",
      payable: "Borç (ödenecek)",
      payroll: "Personel maliyeti",
      payrollGross: "Brüt bordro",
      payrollNet: "Net ödenen",
      payrollNone: "Bu dönem için kapanmış bordro yok",
      pdf: "Yazdır / PDF",
      popupBlocked: "Yazdırma penceresi açılamadı; tarayıcının açılır pencere iznini kontrol edin.",
      projectedClosing: "Öngörülen kapanış",
      projection: "Öngörü",
      receivable: "Alacak (tahsil edilecek)",
      result: "Dönem sonucu",
      tax: "Vergi yükü",
      totals: "Toplamlar",
      transactionsTitle: "Gelir ve Giderler",
      vatPayable: "Ödenecek KDV",
      withholding: "Stopaj"
    },
    voids: {
      approve: "Onayla ve iptal et",
      approveBody: "“{{summary}}” ({{amount}}) için ters kayıt atılacak ve kayıt iptal edilecek. Bu işlem geri alınamaz.",
      approveTitle: "İptal talebi onaylansın mı?",
      approved: "İptal onaylandı; ters kayıt atıldı",
      cancelled: "Talep geri çekildi",
      decidedBy: "Karar: {{name}}, {{at}}",
      decisionNote: "Karar notu",
      empty: "İptal talebi yok",
      escalatedBecause: "Firma sahibine gitme nedeni",
      escalation: {
        amount_threshold: "tutar eşiği aşıldı",
        closed_period: "kayıt kapatılmış döneme ait",
        settled_record: "tamamen ödenmiş kaydın ödemesi geri açılıyor"
      },
      filter: {
        all: "Tümü",
        approved: "Onaylanan",
        pending: "Bekleyen",
        rejected: "Reddedilen"
      },
      level: {
        approver: "Finans onayı",
        owner: "Firma sahibi onayı"
      },
      listTitle: "Talepler",
      live: {
        decided: {
          approved: "İptal talebiniz onaylandı",
          failed: "İptal talebiniz onaylandı ancak uygulanamadı",
          rejected: "İptal talebiniz reddedildi",
          updated: "İptal talebiniz güncellendi"
        },
        open: "Görüntüle",
        requested: "Onayınızı bekleyen yeni iptal talebi",
        requestedOwner: "Firma sahibi onayı bekleyen yeni iptal talebi"
      },
      ownerOnly: "Firma sahibi onayı bekliyor",
      reason: "Gerekçe",
      reasonPlaceholder: "Örn. mükerrer kayıt, yanlış cari, iade edilen fatura…",
      reasonTooShort: "İptal gerekçesi en az 5 karakter olmalı",
      reject: "Reddet",
      rejectNoteRequired: "Red gerekçesi zorunlu",
      rejectPlaceholder: "Red gerekçesini yazın",
      rejectTitle: "İptal talebi reddedilsin mi?",
      rejected: "Talep reddedildi; kayıt değişmedi",
      requestConfirm: "İptal talebi gönder",
      requestHint: "Kayıt hemen silinmez; onaylandığında ters kayıtla iptal edilir.",
      requestTitle: "İptal talebi",
      requested: {
        approver: "İptal talebi finans onayına gönderildi",
        owner: "İptal talebi firma sahibinin onayına gönderildi"
      },
      requestedBy: "Talep: {{name}}, {{at}} · Dönem {{period}}",
      status: {
        approved: "Onaylandı",
        cancelled: "Geri çekildi",
        failed: "Uygulanamadı",
        pending: "Bekliyor",
        rejected: "Reddedildi"
      },
      subtitleApprover: "Gelir/gider, ödeme ve kasa iptalleri onayınızla uygulanır. Eşik üstü ve kapalı döneme ait talepler firma sahibine gider.",
      subtitleOwn: "Açtığınız iptal talepleri ve sonuçları.",
      target: {
        cash_entry: "Kasa hareketi",
        ledger: "Gelir/gider",
        obligation_item: "Ödeme planı ödemesi",
        payment: "Ödeme",
        transfer: "Transfer"
      },
      threshold: "Eşik tutarı (KDV dahil, ₺)",
      thresholdHint: "Bu tutar ve üzerindeki iptal talepleri doğrudan firma sahibinin onayına gider. Kapatılmış döneme ait kayıtlar ve tamamen ödenmiş kayıtların ödemeleri tutardan bağımsız olarak firma sahibine gider.",
      thresholdSaved: "Eşik güncellendi",
      thresholdTitle: "Firma sahibi onay eşiği",
      title: "İptal Onayları",
      withdraw: "Geri çek"
    },
    personal: {
      addEntry: "Harcama / Gelir Ekle",
      addNote: "Not Ekle",
      addWallet: "Cüzdan Ekle",
      byCategory: "Kategorilere göre harcama",
      category: {
        bills: "Faturalar",
        bonus: "Prim / ikramiye",
        clothing: "Giyim",
        education: "Eğitim",
        entertainment: "Eğlence",
        health: "Sağlık",
        investment: "Yatırım geliri",
        market: "Market",
        other_expense: "Diğer gider",
        other_income: "Diğer gelir",
        rent: "Kira",
        salary: "Maaş",
        side: "Ek gelir",
        transport: "Ulaşım"
      },
      deleteEntryBody: "{{amount}} tutarındaki kayıt silinecek.",
      deleteEntryTitle: "Kayıt silinsin mi?",
      deleteNoteBody: "“{{name}}” notu silinecek.",
      deleteNoteTitle: "Not silinsin mi?",
      deleteWalletBody: "“{{name}}” silinecek. Maaş/firma ödemesi kaydı olan cüzdanlar silinemez.",
      deleteWalletTitle: "Cüzdan silinsin mi?",
      entryCreated: "Kayıt eklendi",
      entryUpdated: "Kayıt güncellendi",
      expense: "Harcama",
      filter: {
        all: "Tümü",
        expense: "Harcamalar",
        income: "Gelirler"
      },
      form: {
        addTag: "Etiket ekle",
        attachment: "Dosya ekle",
        attachmentHint: "Fiş, fatura, dekont (PDF ya da görsel, en fazla 10 MB)",
        body: "Not",
        bodyPlaceholder: "Notunuzu buraya yazın…",
        createEntry: "Kişisel harcama / gelir ekle",
        createNote: "Kişisel not ekle",
        createWallet: "Yeni cüzdan",
        editEntry: "Kaydı düzenle",
        editNote: "Notu düzenle",
        editWallet: "Cüzdanı düzenle",
        pinned: "Önemli (üste sabitle)",
        remindAt: "Hatırlatıcı",
        removeTag: "{{tag}} etiketini kaldır",
        saveNote: "Notu Kaydet",
        tagPlaceholder: "Etiket yazıp Enter'a basın",
        tags: "Etiketler",
        title: "Başlık",
        titlePlaceholder: "Not başlığı yazın…",
        titleRequired: "Başlık en az 2 karakter olmalı",
        walletRequired: "Cüzdan seçin"
      },
      income: "Gelir",
      kind: {
        expense: "Harcama",
        income: "Gelir"
      },
      lockedHint: "Maaş ve firma ödemeleri sistem tarafından eklenir; değiştirilemez ve silinemez.",
      manageWallets: "Cüzdanları yönet",
      net: "Net (gelir − harcama)",
      netHint: "Ödenmiş kayıtlara göre",
      noEntries: "Kayıt yok",
      noNotes: "Not yok",
      noteCreated: "Not kaydedildi",
      noteUpdated: "Not güncellendi",
      pending: "Bekleyen ödemeler",
      pendingHint: "{{count}} kayıt ödenmeyi bekliyor",
      pinnedNotes: "Sabitlenen notlar",
      privateHint: "Bu alandaki kayıtlar yalnız size özeldir; şirket verileriyle paylaşılmaz ve başka kullanıcılar göremez.",
      privateTitle: "Kişisel alan.",
      recent: "Bu ayın kayıtları",
      recurrence: "Tekrarlama",
      recurrenceOpt: {
        monthly: "Aylık",
        once: "Tek seferlik",
        yearly: "Yıllık"
      },
      salary: {
        hint: "Firmanın ödediği maaş, prim, avans ve yan haklar seçtiğiniz cüzdana gelir olarak eklenir. Bu kayıtlar sistem kaydıdır; değiştirilemez ve silinemez.",
        noEmployee: "Hesabınız bir personel kaydına bağlı olmadığı için maaş aktarımı kullanılamaz.",
        saved: "Maaş aktarım tercihi kaydedildi",
        syncFrom: "Bu tarihten itibaren ödenenler",
        title: "Maaş ve firma ödemeleri",
        toggle: "Maaşımı ve firma ödemelerimi otomatik ekle",
        wallet: "Gelirin ekleneceği cüzdan"
      },
      seeAll: "Tümü",
      status: {
        expense: {
          paid: "Ödendi",
          pending: "Ödenecek"
        },
        income: {
          paid: "Tahsil edildi",
          pending: "Beklenen"
        }
      },
      statusIn: "Tahsil durumu",
      systemRecord: "Sistem kaydı",
      statusOut: "Ödeme durumu",
      subtitle: "Kendi harcama ve gelirleriniz, cüzdanlarınız ve notlarınız.",
      tabs: {
        entries: "Harcama ve Gelirler",
        notes: "Notlar",
        summary: "Özet",
        wallets: "Cüzdanlar",
        cards: "Kartlarım",
        loans: "Kredilerim",
        advances: "Nakit Avanslarım"
      },
      title: "Kişisel Finans",
      toggleStatus: "Durumu değiştir",
      wallet: "Hesap / cüzdan",
      walletsTotal: "Cüzdanlardaki toplam",
      walletType: {
        bank: "Banka hesabı",
        cash: "Nakit",
        credit_card: "Kredi kartı"
      }
    },
    review: {
      approved: "Onaylandı",
      mixed: "Kısmi",
      pending: "Beklemede",
      reviewing: "İnceleniyor"
    },
    rowActions: "{{name}} için işlemler",
    supplier: "Tedarikçi",
    suppliers: "tedarikçi",
    tax: {
      bannerBody: "Bazı veriler eksik ya da doğrulanmayı bekliyor. Gerçek beyan ve mali tablolar için mali müşavir kontrolü gerekir.",
      bannerTitle: "Tahmindir · Mali müşavir onayı bekliyor",
      base: "Matrah",
      calendar: {
        daysLeft: "{{count}} gün kaldı",
        done: "Tamamlandı",
        late: "{{count}} gün gecikti",
        empty: "Önümüzdeki 60 günde açık vergi/SGK vadesi yok",
        openPlan: "Ödeme planı",
        title: "Yaklaşan Beyan ve Ödeme Takvimi"
      },
      corporateBase: "Tahmini matrah",
      counterparty: "Cari",
      docStatus: "Belge durumu",
      download: "Rapor İndir",
      downloadLabel: "{{period}} raporları",
      downloads: {
        docs: "Belge kontrolü listesi (CSV)",
        vat: "KDV işlem listesi (CSV)",
        withholding: "Stopaj kesintileri (CSV)"
      },
      fiscalYear: "Mali yıl",
      fiscalYearClosed: "Kapanmış dönem",
      fiscalYearRange: "1 Ocak – 31 Aralık {{year}}",
      incomeEstimate: "Tahmini gelir vergisi",
      incomeHint: "Yılbaşından bu aya kadar KDV hariç gelir − gider farkına muhasebecinin tanımladığı gelir vergisi dilimleri uygulanır. Geçici vergi mahsupları ve indirimler ayrıca değerlendirilir.",
      incomeTitle: "Gelir Vergisi ön izlemesi",
      noPaymentCarried: "Devreden KDV nedeniyle bu dönem tahmini ödeme yok",
      profile: "Mükellef profili",
      profiles: {
        as: "Kurumlar Vergisi Mükellefi (A.Ş.)",
        freelance: "Serbest Meslek Kazancı",
        ltd: "Kurumlar Vergisi Mükellefi (Ltd. Şti.)",
        sole: "Bilanço Esaslı Şahıs İşletmesi"
      },
      regime: "Vergi türü",
      regimeHint: "Mükellef profiline göre belirlenir; kurumlar vergisi sermaye şirketleri, gelir vergisi şahıs işletmeleri içindir.",
      regimes: {
        corporate: "Kurumlar Vergisi",
        income: "Sadece Gelir Vergisi"
      },
      related: "İlgili kayıtlar",
      seeDetails: "Detayları gör",
      corporateEstimate: "Tahmini vergi",
      corporateHint: "Yılbaşından bu aya kadar yevmiyedeki gelir hesapları − gider hesapları farkı üzerinden, tanımlı oranla hesaplanır; mevduat faizi matraha dahildir, peşin kesilen stopaj (193) tahmini vergiden düşülür. Kanunen kabul edilmeyen giderler ve istisnalar mali müşavir tarafından ayrıca değerlendirilir.",
      interestIncome: "Faiz geliri (642)",
      grossTax: "Hesaplanan vergi (%{{rate}})",
      prepaidTax: "Mahsup edilecek stopaj (193)",
      corporateTitle: "Kurumlar Vergisi ön izlemesi",
      docCheckTitle: "Belge kontrolü",
      goToRecords: "Kayıtlara git",
      missingAmount: "Eksik belge tutarı",
      missingDocs: "Eksik belge",
      note: "Not",
      noWithholding: "Bu dönemde stopajlı gider yok.",
      params: {
        corporate: "Kurumlar vergisi oranı",
        byAccountant: "muhasebeci tanımlar",
        default: "varsayılan",
        defined: "Tanımlı ({{count}})",
        exemptions: "Özel indirim ve istisnalar",
        incomeBrackets: "Gelir vergisi dilimleri",
        incomeOnly: "sadece gelir vergisi için",
        notApplicable: "Uygulanmaz",
        depreciation: "Varsayılan amortisman süresi",
        editTitle: "Vergi parametreleri",
        hint: "Oranlar mali müşavir tarafından firmaya özel tanımlanır; burada yasal oran önerilmez.",
        invalid: "Oranlar 0–100 arasında sayı olmalı",
        title: "Vergi Parametreleri",
        updated: "Son güncelleme: {{date}}",
        vatHint: "Virgülle ayırın, örn. 1, 10, 20",
        vatRates: "KDV oranları",
        withholding: "Stopaj oranı",
        years: "{{count}} yıl"
      },
      reconciliation: "KDV mutabakatı",
      reconciliationHint: "Belgesi tam olan kayıt oranı",
      review: {
        approved: "Kontrol edildi",
        pending: "Beklemede",
        problem: "Sorunlu (eksik belge)"
      },
      reviewTitle: "KDV inceleme durumu",
      share: "Muhasebeciye Paylaş",
      shareCopied: "Özet panoya kopyalandı; e-posta ya da mesajla paylaşabilirsiniz.",
      shareText: "{{period}} KDV ön izlemesi — Hesaplanan: {{output}}, İndirilecek: {{input}}, Tahmini ödenecek: {{payable}}. Eksik belge: {{missing}}.",
      showMissing: "Eksik verileri görüntüle ({{count}})",
      subtitle: "Seçilen döneme ait kayıtlardan hazırlanan tahmini vergi ve muhasebe görünümü.",
      tabs: {
        corporate: "Kurumlar Vergisi",
        docs: "Belge Kontrolü",
        income: "Gelir Vergisi",
        vat: "KDV",
        withholding: "Stopaj"
      },
      title: "Vergi ve Muhasebe Ön İzleme",
      unreviewed: "İncelenmemiş kayıt",
      vatCarried: "Devreden KDV",
      vatCarriedHint: "Sonraki döneme aktarılan",
      vatInput: "İndirilecek KDV",
      vatMonthly: "KDV aylık görünüm (tahmini)",
      vatOutput: "Hesaplanan KDV",
      vatPayable: "Tahmini ödenecek KDV",
      vatRowsHint: "Muhasebe kayıtlarına göre KDV açısından değerlendirilen gider kalemleri.",
      vatRowsTitle: "KDV'ye tabi işlemler ve gider uygunluğu",
      vatStatusCol: "KDV durumu",
      withholdingTitle: "Stopaj (muhtasar) kesintileri",
      ytdExpense: "Yıl başından gider",
      ytdIncome: "Yıl başından gelir"
    },
    taxNo: "VKN {{no}}",
    tx: {
      accountantNote: "Mali müşavir notu",
      add: "Kayıt Ekle",
      count: "{{count}} / {{total}} kayıt",
      created: "Kayıt eklendi",
      date: "Belge tarihi",
      deleteBody: "“{{name}}” ({{party}}) kaydı silinecek. Ödemesi olan kayıtlar silinemez.",
      deleted: "Kayıt silindi",
      deleteTitle: "Kayıt silinsin mi?",
      description: "Açıklama",
      docNo: "Belge / fatura no",
      dueDate: "Vade tarihi",
      empty: "Henüz gelir/gider kaydı yok",
      filter: {
        all: "Tümü ({{count}})",
        expense: "Gider ({{count}})",
        income: "Gelir ({{count}})"
      },
      form: {
        categoryRequired: "Kategori seçin",
        createTitle: "Gelir / gider ve fatura kaydı",
        descriptionRequired: "Açıklama en az 2 karakter olmalı",
        docNoPlaceholder: "Fatura no",
        editTitle: "Kaydı düzenle",
        hasDocumentHint: "İşaretli değilse kayıt “eksik belge” olarak vergi ön izlemesine yansır.",
        hint: "Şirket gideri, fatura ya da gelir kaydı. Yasal fatura kesimi GİB e-Belgeler ekranından yapılır.",
        kind: "Tür",
        newCustomer: "Yeni müşteri",
        newParty: "Yeni",
        newSupplier: "Yeni tedarikçi",
        partyName: "Ünvan",
        partyRequired: "Cari seçin",
        sectionAccounting: "Muhasebe",
        sectionAmount: "Tutar ve vergi",
        sectionParty: "Cari ve belge",
        serverCalc: "KDV, stopaj ve toplam tutar kayıt sırasında sistem tarafından hesaplanır.",
        withholdingIncome: "Gelir kayıtlarında stopaj uygulanmaz."
      },
      hasDocument: "Fatura / belge mevcut",
      missingDoc: "Belgesi eksik",
      missingDocShort: "Eksik belge",
      net: "Tutar (KDV hariç)",
      noMatch: "Filtrelere uyan kayıt yok",
      party: "Cari / açıklama",
      records: "Gelir ve Gider Kayıtları",
      remaining: "Kalan",
      remainingShort: "Kalan:",
      review: "Mali müşavir incelemesi",
      search: "Cari, açıklama ya da belge no ara…",
      status: "Durum",
      statusFilter: {
        all: "Tüm durumlar",
        missing: "Eksik belgeli",
        open: "Açık (ödenmemiş)",
        paid: "Kapanmış"
      },
      subtitle: "Faturalar, giderler, gelirler ve bunlara bağlı tahsilat/ödemeler.",
      title: "Gelir ve Giderler",
      total: "Toplam",
      totalInfo: "Toplam: {{total}}",
      updated: "Kayıt güncellendi",
      vat: "KDV",
      vatRate: "KDV oranı",
      withholding: "Stopaj",
      withholdingRate: "Stopaj oranı"
    },
    vatStatus: {
      depreciation: "Amortisman",
      eligible: "Uygun",
      ineligible: "Uygun değil",
      partial: "Kısmen uygun"
    },
    vatStatusHint: {
      depreciation: "Demirbaş; KDV indirilir, gider amortismanla dönemlere yayılır",
      eligible: "KDV indirilebilir",
      ineligible: "KDV'siz işlem ya da indirilemez",
      partial: "Sınırlı indirim (temsil, ağırlama vb.)"
    },
    vsPrevMonth: "Geçen aya göre"
  },
  followups: {
    channels: {
      diger: "Diğer",
      eposta: "E-posta",
      mesaj: "Mesaj",
      telefon: "Telefon",
      ziyaret: "Ziyaret"
    },
    columns: {
      account: "Hesap",
      channel: "Kanal",
      due: "Vade",
      note: "Not"
    },
    complete: "Tamamla",
    empty: "empty",
    form: {
      accountId: "accountId",
      accountRequired: "accountRequired",
      channel: "channel",
      dueAt: "dueAt",
      dueRequired: "dueRequired",
      hint: "hint",
      note: "note"
    },
    new: "new",
    subtitle: "Bekleyen ve geciken takipler",
    title: "Takipler",
    completed: "Takip tamamlandı"
  },
  hr: {
    columns: {
      department: "Departman",
      name: "Ad",
      tckn: "TCKN"
    },
    reveal: "Hassas göster",
    subtitle: "İK personel listesi",
    title: "Personel",
    personel: {
      tesvik: {
        open: "SGK teşvikleri",
        catalogTitle: "SGK teşvik ve indirimleri",
        catalogHint: "Oran, işveren SGK payından düşülen yüzde puandır. Teşvik atanmamış SGK'lı personele bordro parametrelerindeki varsayılan indirim (şu an %{{default}}) uygulanır. İşveren payının tamamını karşılayan teşvikler (ör. 6111) için işveren SGK oranını (şu an %{{employer}}) girin; hesap bu oranla sınırlanır. %0 oranlı bir kayıt atanırsa o personele hiç indirim uygulanmaz.",
        code: "Kod",
        name: "Ad",
        rate: "İndirim oranı",
        active: "Aktif",
        activeShort: "Aktif",
        assigned: "Atanan",
        assignedCount: "{{count}} personel",
        zero: "İndirim yok",
        add: "Teşvik ekle",
        required: "Kod ve ad gerekli",
        saved: "Teşvikler kaydedildi",
        deleteTitle: "Teşvik silinsin mi?",
        cardTitle: "SGK durumu ve teşvikler",
        assign: "Teşvik ata",
        pick: "Teşvik seçin",
        start: "Başlangıç",
        end: "Bitiş",
        endPh: "Bitiş (boş: süresiz)",
        openEnded: "süresiz",
        assignInvalid: "Teşvik ve başlangıç tarihi seçin; bitiş başlangıçtan önce olamaz",
        assigned_ok: "Teşvik atandı",
        unassignTitle: "Teşvik ataması kaldırılsın mı?",
        defaultApplies: "Personele özel teşvik yok; bordroda varsayılan indirim (%{{rate}}) uygulanır.",
        effective: "Bugün geçerli teşvik oranı: %{{rate}} (varsayılan indirim yerine uygulanır).",
        bagkurNote: "Bağkur'lu (4/b) personelde bordrodan SGK primi kesilmez, işveren payı ve teşvik uygulanmaz; prim kişi tarafından ödenir.",
        retiredNote: "Prim ödemeyen emeklide SGK primi ve teşvik uygulanmaz; yalnız gelir ve damga vergisi hesaplanır."
      },
      gecmisOdeme: {
        open: "Geçmiş ödeme ekle",
        title: "Geçmiş ödeme ekle",
        hint: "Sistem öncesinde yapılmış maaş, avans, yemek, ulaşım, prim ya da masraf ödemesini girin. Ödendi olarak kaydedilir; onay ve banka ödemesi oluşmaz. Kaydettikten sonra form açık kalır, sıradaki ayı girebilirsiniz.",
        type: "Ödeme türü",
        amount: "Tutar (net ödenen)",
        period: "Ait olduğu dönem",
        date: "Ödeme tarihi",
        description: "Açıklama",
        save: "Kaydet",
        saved: "{{period}} {{type}} ödemesi eklendi",
        periodPast: "İçinde bulunulan ay ya da öncesi seçilmeli",
        datePast: "Ödeme tarihi bugün ya da öncesi olmalı",
        importedNote: "Geçmiş dönemden aktarılan kayıt",
        deleteTitle: "Geçmiş ödeme silinsin mi?",
        deleteBody: "{{period}} dönemine ait {{amount}} tutarlı aktarılmış ödeme silinecek.",
        deleted: "Geçmiş ödeme silindi",
        types: {
          SALARY: "Maaş",
          ADVANCE: "Avans",
          MEAL: "Yemek",
          TRANSPORT: "Ulaşım",
          BONUS: "Prim",
          EXPENSE: "Masraf"
        }
      },
      gecmisBordro: {
        open: "Geçmiş bordro ekle",
        title: "Geçmiş dönem bordrosu",
        hint: "Sistem kurulmadan önceki, ödenmiş bordroyu muhasebe bordrosundaki tutarlarla girin. Kayıt ödendi kabul edilir; onay ve ödeme talebi oluşturulmaz.",
        period: "Dönem",
        workedDays: "Çalışılan gün",
        gross: "Brüt ücret",
        bonus: "Prim / ikramiye",
        sgk: "SGK + işsizlik işçi payı",
        incomeTax: "Gelir vergisi",
        stampTax: "Damga vergisi",
        net: "Net ödenen",
        file: "Muhasebe bordrosu (isteğe bağlı)",
        note: "Not",
        save: "Bordroyu ekle",
        saved: "{{period}} dönemi bordrosu eklendi",
        periodPast: "Yalnız içinde bulunulan aydan önceki dönemler girilebilir",
        netTooHigh: "Net tutar brüt + primden büyük olamaz",
        fileTooBig: "Dosya 15 MB'tan büyük olamaz",
        badge: "Aktarım",
        deleteTitle: "Geçmiş bordro silinsin mi?",
        deleteBody: "{{period}} dönemine ait aktarılmış bordro ve ekli belgesi silinecek.",
        deleted: "Geçmiş bordro silindi"
      },
      listTitle: "Personel Yönetimi",
      listSubtitle: "Çalışan kayıtlarını ve organizasyon yapısını yönetin.",
      detailTitle: "Personel Detayı",
      add: "Personel Ekle",
      export: "Dışa Aktar",
      searchPlaceholder: "Personel ara (ad, e-posta, sicil no...)",
      empty: "Filtreye uyan personel yok",
      rowActions: {
        view: "Detayı görüntüle",
        edit: "Bilgileri düzenle",
        copyEmail: "E-postayı kopyala",
        emailCopied: "{{email}} panoya kopyalandı",
        changeStatus: "Durumu değiştir",
        statusChanged: "{{name}} durumu \"{{durum}}\" olarak güncellendi",
        remove: "Kaydı sil",
        removed: "{{name}} kaydı silindi"
      },
      actions: {
        popupBlocked: "Yazdırma başlatılamadı; lütfen tekrar deneyin.",
        downloaded: "{{name}} indirildi",
        copied: "Panoya kopyalandı",
        copyFailed: "Panoya kopyalanamadı",
        icsReady: "Takvim dosyası indirildi; takvim uygulamanızla açabilirsiniz.",
        required: "Bu alan zorunludur",
        exportFiltered: "Filtrelenmiş liste ({{n}})",
        exportAll: "Tüm personel ({{n}})",
        exportHint: "CSV · Excel ile açılır",
        izin: {
          title: "Yeni İzin Talebi",
          hint: "Talep yönetici ve İK onayına gönderilir.",
          aciklama: "Açıklama",
          bitisOnce: "Bitiş tarihi başlangıçtan önce olamaz",
          noWorkDay: "Seçilen aralıkta iş günü yok",
          belgeGerekli: "Belge gerektirir",
          created: "İzin talebi oluşturuldu ve onaya gönderildi"
        },
        belge: {
          title: "Belge Yükle",
          hint: "Yüklenen belge personel dosyasına eklenir. Eski belgeler için belge tarihini girin; güncel belgenin yerine geçmez.",
          kategori: "Kategori",
          ad: "Belge adı",
          dosya: "Dosya",
          dosyaSec: "Dosya seçmek için tıklayın",
          gecerlilik: "Son geçerlilik tarihi (opsiyonel)",
          belgeTarihi: "Belge tarihi (opsiyonel)",
          uploaded: "{{name}} yüklendi",
          view: "Görüntüle / Yazdır",
          upload: "Dosya yükle",
          replace: "Yeni sürüm yükle",
          replaced: "{{name}} güncellendi",
          remove: "Belgeyi sil",
          removed: "{{name}} silindi",
          kategoriler: {
            ozluk: "Özlük",
            sozlesme: "Sözleşmeler",
            sgk: "SGK",
            egitim: "Eğitim",
            diger: "Diğer"
          }
        },
        degerlendirme: {
          title: "Değerlendirme Ekle",
          hint: "Puan ve not, personelin performans geçmişine eklenir.",
          skor: "Genel puan",
          not: "Değerlendirme notu",
          notMin: "En az 10 karakter yazın",
          unvan: "İnsan Kaynakları",
          created: "Değerlendirme kaydedildi",
          ics: "{{name}} · Performans değerlendirmesi"
        },
        egitim: {
          title: "Eğitim Ata",
          hint: "Atanan eğitim planlanan eğitimler listesine eklenir.",
          ad: "Eğitim adı",
          saglayici: "Sağlayıcı",
          tarih: "Planlanan tarih",
          created: "{{name}} eğitimi planlandı",
          sertifika: "Eğitim Sertifikası",
          tamamlandi: "Tamamlanma tarihi"
        },
        odeme: {
          title: "Ödeme Planla",
          hint: "Planlanan ödeme listeye ve banka dosyasına eklenir.",
          personel: "Personel",
          tutar: "Tutar (TRY)",
          created: "{{name}} için ödeme planlandı",
          markPaid: "Ödendi olarak işaretle",
          approve: "Ödemeyi onayla",
          dekont: "Dekontu görüntüle",
          dekontTitle: "Ödeme Dekontu",
          remove: "Ödemeyi sil",
          paid: "{{name}} ödemesi tamamlandı",
          approved: "{{name}} ödemesi onaylandı",
          removed: "{{name}} ödemesi silindi",
          exportAll: "Tümünü CSV olarak indir",
          payAll: "Planlananları ödendi işaretle",
          payAllDone: "{{n}} ödeme tamamlandı",
          nothingToPay: "Bekleyen planlı ödeme yok",
          ibanCopied: "IBAN panoya kopyalandı",
          islem: {
            created: "Ödeme planlandı",
            paid: "Ödeme tamamlandı",
            approved: "Ödeme onaylandı",
            rejected: "Ödeme reddedildi",
            removed: "Ödeme silindi"
          }
        },
        bordro: {
          started: "{{n}} personel için bordro hesaplaması başlatıldı; tamamlanınca tablo güncellenecek",
          summary: "Özeti göster",
          markKontrol: "Kontrol edildi olarak işaretle",
          approve: "Bordroyu onayla",
          revert: "Taslağa geri al",
          pdf: "Bordro dökümü (PDF)",
          statusChanged: "{{name}} bordrosu \"{{durum}}\" olarak güncellendi",
          created: "{{n}} yeni bordro taslağı oluşturuldu",
          noneMissing: "Tüm personelin bu dönem bordrosu zaten mevcut",
          filtered: "Kontrol aşamasındaki bordrolar listeleniyor"
        }
      },
      backToList: "Personel",
      pagination: "{{total}} kayıttan {{from}} - {{to}} arası gösteriliyor",
      kpi: {
        toplam: "Toplam Personel",
        aktif: "Aktif Çalışan",
        izinli: "İzinli",
        yeni: "Yeni Başlayan",
        hint: {
          toplam: "{{n}} departmanda",
          aktif: "Toplamın %{{pct}}'i",
          izinli: "Bugün itibarıyla izinde",
          yeni: "Son 90 günde işe başlayan"
        }
      },
      tags: {
        ortak: "Ortak",
        emekli: "Emekli"
      },
      sayfaOnceki: "Önceki sayfa",
      sayfaSonraki: "Sonraki sayfa",
      sayfa: "Sayfa {{n}}",
      filters: {
        departman: "Departman",
        durum: "Durum",
        tur: "Çalışma türü",
        allDeps: "Tüm Departmanlar",
        allDurum: "Tüm Durumlar",
        allTur: "Tüm Çalışma Türleri",
        more: "Filtreler"
      },
      columns: {
        personel: "Ad Soyad",
        sicil: "Sicil",
        departman: "Departman",
        pozisyon: "Pozisyon",
        giris: "İşe Giriş Tarihi",
        tur: "Çalışma Türü",
        durum: "Durum",
        islem: "İşlemler"
      },
      durum: {
        aktif: "Aktif",
        izinli: "İzinli",
        deneme: "Deneme Sürecinde"
      },
      calisma: {
        tam_zamanli: "Tam Zamanlı",
        hibrit: "Hibrit",
        yari_zamanli: "Yarı Zamanlı"
      },
      widgets: {
        departman: "Departman Dağılımı",
        yaklasan: "Yaklaşan İşlemler",
        tumunuGor: "Tümünü Gör",
        tumIslemler: "Tümünü gör",
        kalanGun: "{{n}} gün kaldı",
        bugun: "Bugün",
        gecti: "{{n}} gün geçti",
        bos: "Yaklaşan işlem bulunmuyor."
      },
      detail: {
        iseGiris: "İşe Giriş Tarihi",
        duzenle: "Bilgileri Düzenle",
        dahaFazla: "Diğer işlemler",
        gecmis: "Çalışma Geçmişi",
        profilTamam: "Profil Tamamlanma Oranı",
        profilHint: "Eksik alanları tamamlayarak özlük dosyasını güçlendirin",
        profilHintPct: "Profil bilgileri %{{pct}} oranında tamamlandı.",
        tamamlandi: "Tamamlandı",
        eksik: "Eksik",
        yoneticiProfil: "Yönetici profiline git"
      },
      fields: {
        ad: "Ad Soyad",
        email: "E-posta",
        telefon: "Cep Telefonu",
        isTel: "İş Telefonu",
        yonetici: "Yönetici",
        lokasyon: "Lokasyon",
        dogum: "Doğum Tarihi",
        egitim: "Eğitim",
        departman: "Departman",
        pozisyon: "Pozisyon",
        sicil: "Sicil No",
        tckn: "TCKN",
        cinsiyet: "Cinsiyet",
        medeni: "Medeni Durum",
        uyruk: "Uyruk",
        sube: "Şube",
        istihdam: "İstihdam Türü",
        sigorta: "Sigorta durumu",
        calisma: "Çalışma Şekli",
        kidem: "Kıdem",
        adres: "Adres",
        yakinlik: "Yakınlık"
      },
      form: {
        formErrors: "Formda eksik ya da hatalı alanlar var; işaretli alanları düzeltin.",
        addTitle: "Yeni Personel",
        addHint: "Temel özlük bilgilerini girerek personel kaydı oluşturun.",
        addPageHint: "Özlük, iş, iletişim, belge ve panel erişim bilgilerini sekmeler halinde tamamlayın.",
        addSuccess: "Personel kaydı oluşturuldu",
        newPersonel: "Yeni Personel",
        headerHint: "Ad, pozisyon ve departman girildikçe burada görünür.",
        step: "Adım {{n}} / {{total}}",
        tabs: {
          kisisel: "Kişisel Bilgiler",
          is: "İş ve Ücret",
          iletisim: "İletişim ve Adres",
          belgeler: "Belgeler",
          panel: "Panel Erişimi"
        },
        tabErrors: "{{n}} hatalı alan",
        fixErrors: "Kaydetmeden önce işaretli sekmelerdeki hataları düzeltin.",
        removeDoc: "Belgeyi kaldır",
        selectManager: "Yönetici seçin",
        selectPosition: "Pozisyon seçin",
        sicilAuto: "Kayıtta otomatik atanır",
        searchManager: "Personel ara…",
        unsavedTitle: "Kaydedilmemiş değişiklikler",
        unsavedBody: "Formda kaydedilmemiş değişiklikler var. Sayfadan çıkarsanız bu bilgiler kaybolacak.",
        leave: "Çık",
        editTitle: "Personel Bilgilerini Düzenle",
        editHint: "Personel kaydındaki tüm bilgileri güncelleyin. Panel şifresi yetki dahilinde sıfırlanabilir.",
        photo: "Personel fotoğrafı",
        uploadPhoto: "Fotoğraf yükle",
        workStart: "Mesai başlangıç",
        workEnd: "Mesai bitiş",
        brutMaas: "Brüt maaş (TRY)",
        maasGecerlilik: "Ücret geçerlilik tarihi",
        emeklilikTarihi: "Emeklilik tarihi",
        emeklilikNotu: "Emeklilik notu",
        emeklilikNotuPh: "Örn. Emekli sicil no 12345, SGK yazısı 03.05.2022",
        ortak: "Firma ortağı",
        ortakCheck: "Bu kişi firma ortağıdır",
        ortaklikPayi: "Ortaklık payı",
        ortakShare: "Ortak · %{{share}} pay",
        egitimDurumu: "Eğitim durumu",
        universite: "Mezun olunan üniversite",
        mezunBolum: "Mezun olunan bölüm",
        il: "İl",
        ilce: "İlçe",
        selectProvince: "İl seçin",
        searchProvince: "İl ara…",
        selectDistrict: "İlçe seçin",
        searchDistrict: "İlçe ara…",
        selectDepartment: "Departman seçin",
        searchDepartment: "Departman ara…",
        selectUniversity: "Üniversite seçin",
        searchUniversity: "Üniversite ara…",
        uploadDoc: "Belge yükle",
        replaceDoc: "Değiştir",
        docEmpty: "Henüz yüklenmedi",
        panelAccess: "Bu personel paneli kullanacak",
        panelAccessHint: "Açıkken iş e-postası ve roller atanır; geçici şifre iş mailine gider. İsteğe bağlı SMTP kutusu bağlanır.",
        firmaEmail: "İş e-postası (giriş)",
        password: "Giriş şifresi",
        passwordConfirm: "Şifre tekrar",
        resetPassword: "Şifreyi sıfırla (e-posta ile geçici şifre)",
        roles: "Sistem rolleri",
        rolesRequired: "En az bir rol seçin",
        mailboxTitle: "İş maili kutusu",
        mailboxHint: "SMTP gönderimi için sağlayıcı ve uygulama şifresi. Secret API yanıtında dönmez.",
        mailboxAssign: "Kutu ata",
        mailboxProvider: "Mail sağlayıcısı",
        mailboxProviderPick: "Sağlayıcı seçin",
        mailboxProviderRequired: "Sağlayıcı seçin",
        mailboxSecret: "SMTP / uygulama şifresi",
        mailboxSecretRequired: "SMTP şifresi zorunlu",
        mailboxSignature: "İmza (HTML, opsiyonel)",
        sections: {
          ortaklik: "Ortaklık",
          temel: "Temel Bilgiler",
          organizasyon: "Organizasyon",
          ucret: "Ücret",
          egitim: "Eğitim",
          adres: "İkametgah Adresi",
          belgeler: "İstenen Belgeler",
          panel: "Panel Erişimi"
        },
        hints: {
          kisisel: "Kimlik ve kişisel bilgiler",
          ucret: "Aylık brüt tutarı 85.000,00 biçiminde yazın.",
          maasGecerlilik: "Boş bırakılırsa yeni kayıtta işe giriş tarihi, güncellemede bugün kullanılır. Geçmiş zamları eski tarihle girebilirsiniz.",
          sigorta: "Bağkur ve emeklide bordrodan SGK/işsizlik primi kesilmez; yalnız gelir ve damga vergisi hesaplanır.",
          emeklilikTarihi: "Prim ödenmemesinin dayanağı olarak zorunlu. Emeklilik belgesini Belgeler sekmesine \"Emeklilik belgesi (SGK)\" olarak yükleyin.",
          emeklilikNotu: "Emekli sicil no, SGK yazısı tarihi gibi takip bilgisi.",
          ortak: "Ortaklık bordroyu değiştirmez; prim durumu Sigorta durumu alanından belirlenir. Onay ve bildirim yetkileri için Panel Erişimi'nden \"company_owner\" (firma sahibi) rolünü de verin.",
          adres: "İl seçtikten sonra ilçe listesi açılır; listede arama yapabilirsiniz.",
          belgeler: "Belge tipleri önceden tanımlıdır. Zorunlu belgeler kayıt sırasında yüklenmelidir.",
          panel: "Sistem hesabı, roller ve isteğe bağlı iş maili kutusu"
        },
        docTypes: {
          kimlik: "Kimlik fotokopisi",
          ikametgah: "İkametgah belgesi",
          diploma: "Diploma / mezuniyet belgesi",
          sgk_ise_giris: "SGK işe giriş bildirgesi",
          is_sozlesmesi: "İş sözleşmesi",
          adli_sicil: "Adli sicil kaydı",
          saglik_raporu: "Sağlık raporu",
          vesikalik: "Vesikalık fotoğraf"
        },
        errors: {
          share: "Ortaklık payı 0 ile 100 arasında olmalı",
          retiredAtRequired: "Prim ödenmeyen emekli için emeklilik tarihi girin",
          required: "Bu alan zorunludur",
          min: "En az {{min}} karakter olmalı",
          email: "Geçerli bir e-posta girin",
          phone: "Geçerli bir telefon numarası girin",
          date: "Geçerli bir tarih seçin",
          time: "Geçerli bir saat seçin",
          money: "Geçerli bir tutar girin (örn. 85000.00)",
          tckn: "TCKN 11 haneli olmalı veya maskeli formatta girilmeli",
          option: "Geçerli bir seçenek seçin",
          firmaEmail: "Panel erişimi için firma e-postası gerekli",
          password: "Şifre alanlarını kontrol edin",
          passwordMin: "Şifre en az 8 karakter olmalı",
          passwordMatch: "Şifreler eşleşmiyor",
          docs: "Zorunlu belgeler eksik",
          docRequired: "Zorunlu belge eksik: {{tip}}"
        },
        options: {
          cinsiyet: {
            erkek: "Erkek",
            kadin: "Kadın",
            diger: "Diğer"
          },
          medeni: {
            bekar: "Bekar",
            evli: "Evli",
            bosanmis: "Boşanmış",
            dul: "Dul"
          },
          sigorta: {
            sgk: "SGK (4/a)",
            bagkur: "Bağkur (4/b) — prim kişi tarafından ödenir",
            emekli: "Emekli — prim ödenmez"
          },
          istihdam: {
            tam_zamanli: "Tam Zamanlı",
            yari_zamanli: "Yarı Zamanlı",
            stajyer: "Stajyer",
            sozlesmeli: "Sözleşmeli"
          },
          egitim: {
            lise: "Lise",
            onlisans: "Ön Lisans",
            lisans: "Lisans",
            yuksek_lisans: "Yüksek Lisans",
            doktora: "Doktora"
          }
        }
      },
      genel: {
        kisisel: "Kişisel Bilgiler",
        organizasyon: "Organizasyon ve İş Bilgileri",
        iletisim: "İletişim Bilgileri",
        acil: "Acil Durum Kişisi",
        check: {
          kisisel: "Kişisel bilgiler",
          iletisim: "İletişim bilgileri",
          organizasyon: "Organizasyon",
          acil: "Acil durum kişisi",
          belge: "Belgeler ve sözleşmeler"
        }
      },
      tabs: {
        genel: "Genel Bilgiler",
        ucret: "Ücret ve Bordro",
        izin: "İzin ve Mesai",
        belge: "Belgeler ve Sözleşmeler",
        odeme: "Ödeme Geçmişi",
        perf: "Performans ve Eğitim"
      },
      ucret: {
        donem: "Dönem",
        brut: "Brüt Ücret",
        net: "Net Ödeme",
        yan: "Yan Haklar",
        iseveren: "İşveren Maliyeti",
        kazanclar: "Kazançlar",
        kesintiler: "Kesintiler",
        donemOzet: "Dönem Özeti",
        gecmis: "Bordro Geçmişi",
        pdf: "Bordro PDF"
      },
      izin: {
        yillik: "Yıllık İzin Hakkı",
        kullanilan: "Kullanılan İzin",
        kalan: "Kalan İzin",
        mesai: "Aylık Fazla Mesai",
        bekleyen: "Bekleyen talep",
        takvim: "Takvim",
        onayTimeline: "İzin Talebi Onay Süreci",
        talepler: "İzin Talepleri",
        puantaj: "Puantaj",
        yeniTalep: "Yeni İzin Talebi",
        tur: "Tür",
        baslangic: "Tarih",
        bitis: "Bitiş",
        gun: "gün",
        saat: "saat",
        sure: "Süre",
        legend: {
          izin: "İzinli",
          resmi: "Resmi tatil",
          mesai: "Mesai",
          calisti: "Çalıştı",
          haftaSonu: "Hafta Sonu"
        },
        steps: {
          talep: "Talep oluşturuldu",
          yonetici: "Yönetici onayı",
          ik: "İK onayı"
        },
        durum: {
          onaylandi: "Onaylandı",
          bekliyor: "Bekliyor",
          red: "Reddedildi"
        }
      },
      belge: {
        title: "Belgeler ve Sözleşmeler",
        subtitle: "Personel belgelerini yönetin, eksikleri ve geçerlilik tarihlerini takip edin.",
        search: "Belge adı ile ara...",
        ad: "Adı",
        klasor: "Kategori",
        boyut: "Boyut",
        tarih: "Belge Tarihi",
        gecerlilik: "Son Geçerlilik Tarihi",
        sozlesme: "Sözleşme Bilgileri",
        sozlesmeTip: "Sözleşme Türü",
        belirsiz: "Belirsiz Süreli",
        baslangic: "Başlangıç",
        bitis: "Bitiş",
        deneme: "Deneme Süresi",
        goruntule: "Görüntüle",
        yukle: "Belge Yükle",
        tamamlanma: "Belge Tamamlanma Durumu",
        yuklu: "yüklü",
        zorunlu: "Zorunlu belgeler {{done}}/{{total}} tamamlandı",
        zorunluTag: "Zorunlu",
        suresiz: "Süresiz",
        gunKaldi: "gün kaldı",
        belgeSay: "{{n}} belge",
        listeSay: "{{n}} öğe listeleniyor",
        allKat: "Tüm Kategoriler",
        allDurum: "Tüm Durumlar",
        eksik: "Eksik Belgeler",
        eksikYok: "Eksik belge yok",
        yaklasan: "Yaklaşan Geçerlilik Tarihleri",
        yaklasanYok: "Süresi yaklaşan belge yok",
        legend: {
          tamam: "Tamamlanan Belge",
          eksik: "Eksik Belge",
          gecen: "Süresi Geçen Belge"
        },
        durum: {
          tamam: "Geçerli",
          eksik: "Eksik",
          suresi_doluyor: "Süresi Yaklaşıyor",
          inceleniyor: "İncelemede",
          klasor: "—"
        }
      },
      odemeGecmis: {
        title: "Ödeme Geçmişi",
        yil: "Bu Yıl Ödenen",
        bekleyen: "Bekleyen Ödemeler",
        avans: "Avans Bakiyesi",
        odeme: "ödeme",
        aktifAvans: "aktif avans",
        adet: "İşlem adedi",
        son: "Son ödeme",
        tur: "Ödeme Türü",
        tum: "Tümü",
        tutar: "Tutar",
        tarih: "Tarih",
        aciklama: "Açıklama",
        yontem: "Yöntem",
        detay: "Ödeme Detayı",
        onay: "Onay ve Mutabakat",
        banka: "Banka Hesabı",
        sec: "Detay için bir satır seçin"
      },
      odeme: {
        tur: {
          maas: "Maaş",
          avans: "Avans",
          prim: "Prim",
          yemek: "Yemek",
          ulasim: "Ulaşım",
          masraf: "Masraf"
        },
        durum: {
          odendi: "Ödendi",
          planlandi: "Planlandı",
          onay_bekliyor: "Onay Bekliyor"
        }
      },
      perf: {
        skor: "Son Değerlendirme",
        skorTarih: "{{date}} tarihinde",
        hedefTamam: "Hedef Tamamlama",
        buYil: "Bu yıl ({{year}})",
        egitimTamam: "Tamamlanan Eğitim",
        sertifikali: "Sertifikalı eğitim",
        egitimPlan: "Planlanan Eğitim",
        yaklasanEgitim: "Yaklaşan eğitim",
        egitimAta: "Eğitim Ata",
        hedefler: "Hedefler",
        tamamlanan: "Tamamlanan",
        egitim: "Eğitim",
        hedefList: "Yıl İçi Hedefleri",
        hedef: "Hedef",
        ilerleme: "İlerleme",
        sonTarih: "Son Tarih",
        degerlendirme: "Son Değerlendirme",
        degerlendirmeEkle: "Değerlendirme Ekle",
        donem: "Dönem",
        yoneticiNot: "Yönetici Notları",
        yoneticiNotBody: "Teslim disiplini güçlü; teknik liderlikte örnek. Mentörlük hedeflerinde ivme bekleniyor. Kod kalitesi ve ekip içi iletişimde tutarlı performans sergiliyor.",
        oncekiNot: "Önceki not",
        sonrakiNot: "Sonraki not",
        yoneticiUnvan: "Teknoloji Direktörü",
        yetkinlik: "Yetkinlik Değerlendirmeleri",
        ustunde: "Beklentilerin Üzerinde",
        beklenen: "Beklenen Düzeyde",
        guclu: "Güçlü yönler",
        gucluBody: "Teknik liderlik, kod kalitesi, ekip içi iletişim",
        egitimTimeline: "Eğitim Geçmişi ve Planı",
        sertifika: "Sertifika",
        planlandi: "Planlandı",
        sonraki: "Sonraki Değerlendirme Tarihi",
        sonrakiHint: "Yıllık performans görüşmesi",
        takvimeEkle: "Takvime Ekle",
        durum: {
          yolda: "Devam Ediyor",
          risk: "Risk",
          tamam: "Tamamlandı"
        }
      },
      bordro: {
        title: "Bordro Yönetimi",
        subtitle: "Dönem bordro hazırlığı ve onay süreci",
        olustur: "Bordro Oluştur",
        excel: "Excel İndir",
        search: "Personel ara...",
        bannerTitle: "{{donem}} bordrolarında {{n}} satır onay bekliyor",
        bannerBody: "Tüm bordrolarınızı kontrol ederek onay sürecini tamamlayabilirsiniz.",
        dokum: {
          gvIstisna: "Asgari ücret gelir vergisi istisnası",
          dvIstisna: "Asgari ücret damga vergisi istisnası",
          istisnaTitle: "Uygulanan istisnalar",
          isverenTitle: "İşveren payları",
          sgkIsveren: "SGK işveren payı",
          issizlikIsveren: "İşsizlik sigortası işveren payı (%2)",
          tesvik: "SGK teşviki (%{{rate}})",
          isverenMaliyet: "Toplam işveren maliyeti",
          sgkIsciLabel: "SGK işçi payı",
          issizlikIsciLabel: "İşsizlik işçi payı",
          gelirVergisi: "Gelir vergisi",
          damgaVergisi: "Damga vergisi",
          missing: "Yasal kesinti dökümü yok (bordro parametresi tanımlanmamış ya da muhasebeden yüklenmiş bordro).",
          matrahLine: "SGK matrahı {{sgk}} · GV matrahı {{gv}} · Kümülatif matrah {{kum}}"
        },
        params: {
          open: "Bordro Parametreleri",
          title: "Bordro parametreleri",
          hint: "Asgari ücret, SGK/işsizlik oranları, teşvik ve gelir vergisi dilimleri geçerlilik tarihine göre uygulanır. Değerleri mali müşavirinizle doğrulayın.",
          validFrom: "Geçerlilik başlangıcı",
          minWage: "Brüt asgari ücret",
          ceiling: "SGK tavan katsayısı",
          employeeSgk: "SGK işçi payı (%)",
          employeeUnemp: "İşsizlik işçi payı (%)",
          employerSgk: "SGK işveren payı (%)",
          employerUnemp: "İşsizlik işveren payı (%)",
          discount: "Varsayılan SGK teşviki (puan)",
          stamp: "Damga vergisi (%)",
          exemption: "Asgari ücret gelir/damga vergisi istisnası uygulanır",
          brackets: "Gelir vergisi dilimleri (yıllık kümülatif matrah)",
          upTo: "Üst sınır",
          lastBracket: "Üzeri",
          rate: "Oran (%)",
          addBracket: "Dilim ekle",
          note: "Not",
          minWageNet: "Asgari ücret neti",
          minWageCost: "Asgari ücret işveren maliyeti",
          newSet: "Yeni dönem",
          saved: "Bordro parametreleri kaydedildi",
          deleted: "Parametre kaydı silindi",
          deleteTitle: "Parametre kaydı silinsin mi?",
          deleteBody: "{{date}} tarihli parametre kaydı silinecek. Yeniden hesaplanan bordrolar bir önceki kaydı kullanır.",
          calculator: "Brütten nete hesaplayıcı",
          gross: "Brüt ücret",
          month: "Ay",
          prior: "Önceki aylar GV matrahı",
          calculate: "Hesapla"
        },
        bannerCta: "Detayları Gör",
        tableTitle: "Personel Bordro Listesi ({{n}} kişi)",
        notGenerated: "Bu dönemin bordrosu henüz hesaplanmadı. \"Bordro oluştur\" ile hesaplamayı başlatabilirsiniz.",
        ek: "Ek Kazanç",
        surec: "Bordro Süreçleri",
        ozet: "Bordro Özeti",
        pdf: "Bordro Dökümünü Görüntüle (PDF)",
        sec: "Özet için bir satır seçin",
        kpi: {
          personel: "Personel",
          brut: "Toplam Brüt",
          net: "Toplam Net",
          isveren: "İşveren Maliyeti",
          bekleyen: "Onay Bekleyen"
        },
        durum: {
          taslak: "Taslak",
          kontrol: "Kontrol Edildi",
          onay: "Onaylandı"
        }
      },
      odemeler: {
        title: "Personel Ödemeleri",
        subtitle: "Maaş, avans ve masraf ödemelerini planlayın ve takip edin.",
        yeni: "Ödeme Planla",
        allDonem: "Tüm Dönemler",
        bankaDosyasi: "Banka Dosyası İndir",
        detaySheet: "Ödeme detayı",
        islem: "İşlem Yap",
        kopyala: "Kopyala",
        bankaYok: "Banka bilgisi girilmemiş",
        onayHint: "Onay adımları bu panoda listelenir.",
        mutabakatOk: "Banka ile eşleşti",
        takvim: "Ödeme Takvimi",
        sonIslemler: "Son İşlemler",
        tabs: {
          detay: "Ödeme Detayı",
          banka: "Banka Bilgileri",
          onay: "Onay Geçmişi",
          mutabakat: "Mutabakat"
        },
        kpi: {
          toplam: "Toplam",
          odendi: "Ödendi",
          planlandi: "Planlandı",
          bekleyen: "Bekleyen",
          avans: "Avanslar"
        }
      }
    },
    belgeler: {
      remind: {
        auto: "Otomatik hatırlatma: son tarihe 7 ve 1 gün kala, son gün ve gecikmede haftada bir; personel, yöneticisi ve belge takip yetkilileri.",
        button: "Eksik belgeler için hatırlat",
        cardTitle: "Belge takibi",
        hint: "Personele ve yöneticisine bildirim ile e-posta gider; günde bir kez gönderilebilir.",
        kind: { auto: "Otomatik", manual: "Elle" },
        none: "Henüz hatırlatma gönderilmedi",
        notePlaceholder: "İsteğe bağlı not (ör. bu hafta sonuna kadar)",
        send: "Hatırlat",
        sent: "Hatırlatma gönderildi ({{count}} kişi)",
        title: "Eksik belgeler için hatırlatma"
      },
      request: {
        button: "Belge iste",
        done: "{{created}} talep açıldı, {{skipped}} kişide zaten açık talep vardı",
        due: "Son tarih",
        dueHint: "Boş bırakılırsa şablondaki süre kullanılır.",
        hint: "{{count}} personelden belge istenecek; personele bildirim ve e-posta gider.",
        noTemplates: "Yayımlanmış şablon yok. Önce belge şablonu yayımlayın.",
        note: "Not",
        notePlaceholder: "Neden istendiği, nasıl hazırlanacağı…",
        openCase: "Talep aç",
        submit: "Talebi gönder",
        template: "Belge",
        templatePlaceholder: "Şablon seçin",
        title: "Belge iste"
      },
      review: {
        approved: "Onayla",
        approvedDone: "Belge onaylandı",
        approvedTitle: "Belge onaylansın mı?",
        correction_requested: "Düzeltme iste",
        correction_requestedDone: "Düzeltme istendi; personele yeniden açıldı",
        correction_requestedTitle: "Düzeltme iste",
        download: "Dosyayı indir",
        reasonPlaceholder: "Gerekçe (personele gösterilir)",
        reasonRequired: "Gerekçe zorunlu",
        rejected: "Reddet",
        rejectedDone: "Belge reddedildi",
        rejectedTitle: "Belge reddedilsin mi?"
      },
      takip: {
        due: "son tarih {{date}}",
        empty: "İnceleme bekleyen belge yok",
        noPermission: "Belge inceleme yetkiniz yok",
        queue: "İnceleme bekleyenler",
        revision: "{{n}}. gönderim",
        submitted: "gönderildi {{at}}",
        subtitle: "Personelin yüklediği belgeler: dosyayı inceleyin, onaylayın, düzeltme isteyin ya da reddedin.",
        title: "Belge İnceleme"
      },
      listTitle: "Personel Belge Şablonları",
      listSubtitle: "Belge tanımlarını ve şablon sürümlerini yönetin.",
      newTemplate: "Belge Oluştur",
      search: "Şablon adı ile ara…",
      allCategories: "Tüm kategoriler",
      allStatuses: "Tüm durumlar",
      createTitle: "Belge Oluştur • Şablon Hazırlama",
      createSubtitle: "Belge bilgilerini tanımlayın, şablonu hazırlayın ve yayımlayın.",
      editorTitle: "Şablon Düzenleyici • {{name}}",
      versionTitle: "Şablon Düzenle • v{{from}} → v{{to}}",
      saveDraft: "Taslak Kaydet",
      saveTemplate: "Şablonu Kaydet",
      previewAction: "Önizle",
      unsavedTitle: "Kaydedilmemiş değişiklikler",
      unsavedConfirm: "Kaydedilmemiş değişiklikler var. Çıkmak istediğinize emin misiniz?",
      columns: {
        name: "Şablon",
        category: "Kategori",
        method: "Yöntem",
        version: "Sürüm",
        status: "Durum",
        updated: "Güncelleme",
        actions: "İşlem"
      },
      status: {
        taslak: "Taslak",
        yayinda: "Yayında",
        arsiv: "Arşiv"
      },
      categories: {
        ise_giris: "İşe Giriş",
        sozlesmeler: "Sözleşmeler",
        acil_durum: "Acil Durum",
        kvkk: "KVKK",
        egitim: "Eğitim",
        diger: "Diğer"
      },
      method: {
        sistem: "Sistem İçinde Oluştur",
        sistemDesc: "Zengin metin editörü ile sıfırdan oluşturun; değişken ve alan ekleyin.",
        docx: "Word Şablonu Yükle",
        docxDesc: ".docx dosyası yükleyin. Değişkenler demo listesi olarak gösterilir.",
        pdf: "PDF Yükle",
        pdfDesc: "Sabit PDF şablonu. Metin düzenleme desteklenmez; görüntüleme/indirme amaçlıdır.",
        selected: "Seçili"
      },
      actions: {
        edit: "Düzenle",
        versions: "Sürümler"
      },
      wizard: {
        steps: {
          info: "Belge Bilgileri",
          fields: "Şablon Alanları",
          preview: "Önizleme",
          publish: "Yayınla"
        },
        hints: {
          info: "Tanım ve kapsamı belirleyin",
          fields: "İçerik ve değişkenleri ekleyin",
          preview: "Son kontrolü yapın",
          publish: "Şablonu kullanıma açın"
        },
        next: {
          "1": "Sonraki: Şablon Alanları",
          "2": "Sonraki: Önizleme",
          "3": "Sonraki: Yayınla"
        },
        nextShort: "İleri",
        label: "Şablon oluşturma adımları",
        stepN: "Adım {{n}}",
        stepOf: "{{current}} / {{total}}"
      },
      newCrumb: "Yeni şablon",
      form: {
        name: "Belge adı",
        category: "Kategori",
        description: "Açıklama",
        required: "Zorunluluk",
        requiredYes: "Zorunlu belge",
        requiredNo: "İsteğe bağlı",
        departments: "İlgili departmanlar",
        positions: "İlgili pozisyonlar",
        positionsHint: "Seçim yapılmazsa belge seçili departmanlardaki (ya da tüm) personele uygulanır.",
        positionsEmpty: "Tanımlı pozisyon yok. Pozisyonlar Erişim > Pozisyonlar ekranından eklenir.",
        owner: "Kontrol sorumlusu",
        ownerPick: "Personel seçin",
        fieldRequired: "Bu alan zorunlu",
        sideTitle: "Ne tanımlanır?",
        sideBody: "Belge tanımı personel belgelerinden ayrıdır. Şablon sürümleri buradan yönetilir; onaylı personel belgeleri değişmez."
      },
      structure: {
        pages: "Sayfalar ve Bölümler",
        sections: "Bölümler",
        addPage: "Sayfa Ekle",
        addSection: "Bölüm Ekle",
        addContent: "İçerik Ekle",
        textBlock: "Metin Bloğu",
        table: "Tablo",
        image: "Görsel",
        divider: "Yatay Çizgi",
        rename: "Adını değiştir",
        delete: "Sil",
        moveUp: "Yukarı taşı",
        moveDown: "Aşağı taşı",
        reorder: "Yeniden sırala",
        sectionMenu: "Bölüm menüsü",
        pageMenu: "Sayfa menüsü",
        renamePrompt: "Yeni ad",
        newSection: "Yeni Bölüm",
        cannotDeleteLastSection: "Son bölüm silinemez",
        cannotDeleteLastPage: "Son sayfa silinemez",
        imageUnavailable: "Görsel ekleme bu sürümde desteklenmiyor"
      },
      table: {
        label: "Tablo",
        column: "Sütun {{n}}",
        headerPlaceholder: "Başlık",
        cellPlaceholder: "—",
        cellLabel: "{{row}}. satır, {{col}}. sütun",
        headerLabel: "{{col}}. sütun başlığı",
        addRow: "Satır ekle",
        addColumn: "Sütun ekle",
        removeRow: "Satırı sil",
        removeColumn: "Sütunu sil",
        maxColumns: "En fazla {{n}} sütun eklenebilir",
        headerColor: "Başlık rengi",
        tones: {
          primary: "Mavi",
          navy: "Lacivert",
          sky: "Gök mavisi",
          orange: "Turuncu",
          dark: "Koyu",
          light: "Açık"
        },
        removeRowTitle: "Satır silinsin mi?",
        removeRowBody: "Bu satırdaki tüm hücre içerikleri silinecek.",
        removeColumnTitle: "Sütun silinsin mi?",
        removeColumnBody: "“{{name}}” sütunu ve içindeki tüm hücreler silinecek."
      },
      remove: {
        fieldTitle: "Alan kaldırılsın mı?",
        fieldBody: "“{{name}}” alanı belgeden ve şablonun alan listesinden kaldırılacak.",
        blockTitle: "Blok kaldırılsın mı?",
        blockBody: "Bu blok ve içeriği belgeden kaldırılacak.",
        confirm: "Kaldır",
        fieldDone: "Alan belgeden kaldırıldı",
        blockDone: "Blok belgeden kaldırıldı",
        fieldAction: "Alanı belgeden kaldır",
        blockAction: "Bloğu kaldır"
      },
      canvas: {
        dragBlock: "Bloğu sürükleyerek taşı",
        dropHere: "Bloğu buraya bırakın",
        pageOf: "Sayfa {{current}} / {{total}}",
        empty: "Bu sayfada henüz içerik yok",
        zoomIn: "Yakınlaştır",
        zoomOut: "Uzaklaştır",
        zoomReset: "Ölçeği sıfırla"
      },
      right: {
        vars: "Değişken Kütüphanesi",
        addField: "Alan Ekle",
        layout: "Satır düzeni",
        layoutHint: "İkili veya üçlü seçildiğinde art arda eklenen alanlar aynı satıra yan yana yerleşir.",
        columns: {
          "1": "Tekli",
          "2": "İkili",
          "3": "Üçlü"
        },
        fields: "Alanlar",
        variables: "Değişkenler",
        pageSettings: "Sayfa Ayarları",
        tabField: "Alan",
        tabVars: "Değişken",
        tabPage: "Sayfa",
        varsHint: "Personel kaydından otomatik dolar. Eklemek için tıklayın.",
        searchVar: "Değişken ara…",
        noField: "Özellikleri görmek için belgeden bir alan seçin.",
        selectedField: "Seçili alan",
        pageLayout: "Sayfa düzeni",
        letterhead: "Antet",
        letterheadHint: "Boş bırakılan alanlarda varsayılan firma bilgisi kullanılır.",
        companyName: "Firma adı",
        legalName: "Ticari unvan",
        department: "Departman",
        margins: "Kenar boşlukları (mm)",
        selectedProps: "Seçili Alanın Özellikleri",
        manualFieldNote: "Bu alan personel tarafından doldurulur; sistem otomatik doldurmaz.",
        autoFieldNote: "Bu alan personel kaydından otomatik doldurulur."
      },
      varGroups: {
        temel: "Temel Bilgiler",
        iletisim: "İletişim Bilgileri",
        is: "İş Bilgileri",
        egitim: "Eğitim Bilgileri",
        diger: "Diğer"
      },
      field: {
        type: "Alan türü",
        label: "Alan etiketi",
        key: "Değişken / alan adı",
        whoFills: "Alanı kim dolduracak?",
        variable: "Sistem değişkeni",
        selectVar: "Değişken seçin",
        required: "Zorunlu alan",
        placeholder: "Açıklayıcı ipucu",
        validation: "Doğrulama",
        validationNone: "Yok",
        validationPhone: "Telefon formatı",
        validationEmail: "E-posta formatı",
        validationNumber: "Sayı",
        errorMessage: "Hata mesajı",
        signatureHint: "Görsel imza alanı (elektronik imza hizmeti değil)",
        yes: "Evet",
        no: "Hayır",
        source: {
          otomatik: "Otomatik doldurulan",
          personel: "Personelin dolduracağı"
        },
        sourceShort: {
          otomatik: "Sistem",
          personel: "Personel"
        }
      },
      fieldTypes: {
        kisa_metin: "Kısa metin",
        uzun_metin: "Uzun metin",
        tarih: "Tarih",
        telefon: "Telefon",
        eposta: "E-posta",
        sayi: "Sayı",
        secim: "Seçim listesi",
        checkbox: "Onay kutusu",
        imza: "Görsel imza alanı"
      },
      page: {
        lineHeight: "Satır aralığı",
        margin: {
          top: "Üst",
          right: "Sağ",
          bottom: "Alt",
          left: "Sol"
        }
      },
      editor: {
        toolbar: "Belge biçimlendirme",
        body: "Belge içeriği",
        font: "Yazı tipi",
        fontSize: "Yazı boyutu",
        bold: "Kalın",
        italic: "İtalik",
        underline: "Altı çizili",
        alignLeft: "Sola hizala",
        alignCenter: "Ortala",
        alignRight: "Sağa hizala",
        bulletList: "Madde listesi",
        numberedList: "Numaralı liste",
        link: "Bağlantı",
        linkPrompt: "Bağlantı adresi",
        undo: "Geri al",
        redo: "Yinele",
        lastSaved: "Son kaydedilme: {{time}}",
        autosaveHint: "Değişiklikleri kaydetmeyi unutmayın",
        saving: "Kaydediliyor…",
        unsaved: "Kaydedilmedi",
        settings: "Şablon Ayarları",
        continuePublish: "Sürüme Geç / Yayınla",
        pdfReadonly: "PDF şablonları düzenlenemez; sürüm ekranından dosyayı değiştirebilirsiniz."
      },
      upload: {
        title: "Word / PDF Şablonu Yükle",
        drop: "Dosyayı sürükleyip bırakın veya seçin",
        hint: "DOCX veya PDF, en fazla 10 MB",
        replace: "Değiştir",
        remove: "Kaldır",
        tooLarge: "Dosya 10 MB sınırını aşıyor",
        invalidType: "Yalnızca DOCX veya PDF kabul edilir",
        ok: "Dosya eklendi",
        docxCapabilities: "DOCX: metin düzenleme ve değişkenler sistem editöründe demo olarak gösterilir. Gerçek DOCX içeriği okunmaz.",
        pdfCapabilities: "PDF: metin düzenleme ve AcroForm tespiti uygulanmaz. Dosya görüntüleme/indirme için saklanır.",
        limitsTitle: "Destek sınırları",
        limitNoParse: "Yüklenen dosyanın içeriği otomatik okunmaz.",
        limitDemo: "DOCX değişkenleri «Demo şablon» listesinden gelir.",
        limitPdf: "PDF alan eşlemesi bu sürümde yoktur.",
        externalPdf: "Harici PDF Yükleme"
      },
      mapping: {
        title: "Değişken Eşleştirme ve Kontrol",
        subtitle: "Şablon değişkenlerinin personel alanlarıyla eşleşmesini kontrol edin.",
        demoBadge: "Demo şablon değişkenleri",
        errorBanner: "Yayımlama engellendi: {{undefined}} tanımsız değişken, {{missing}} eksik zorunlu eşleme.",
        templateVar: "Şablon değişkeni",
        mapped: "Eşleştirilen alan",
        status: "Durum",
        actions: "İşlem",
        edit: "Düzenle",
        empty: "Gösterilecek eşleme yok",
        filter: {
          all: "Tümü",
          eslesti: "Eşleşti",
          manuel: "Manuel",
          tanimsiz: "Hata"
        },
        statusLabel: {
          eslesti: "Eşleşti",
          manuel: "Manuel",
          tanimsiz: "Tanımsız"
        }
      },
      preview: {
        sampleEmployee: "Örnek personel",
        empty: "Boş şablon",
        filled: "Doldurulmuş",
        pdfOnly: "PDF önizleme için dosyayı indirin; tarayıcıda metin düzenleme yok.",
        pdfReloadTitle: "PDF önizlemesi için dosyayı yeniden yükleyin",
        pdfReloadBody: "Önizleme bağlantısı yalnızca bu oturumda tutulur. Sayfa yenilendiyse PDF’i tekrar seçin.",
        demoBadge: "Demo şablon",
        docxNote: "Yüklenen .docx içeriği tarayıcıda açılmaz. Aşağıda eşlenen alanlarla demo önizleme gösterilir.",
        mappingSummary: "Eşleşti: {{eslesti}} · Manuel: {{manuel}} · Tanımsız: {{tanimsiz}}",
        exportTitle: "Dışa aktarma",
        exportBody: "Gerçek DOCX/PDF üretimi yok. Yazdır / PDF olarak kaydet yolunu kullanın.",
        print: "Yazdır / PDF olarak kaydet"
      },
      publish: {
        versionInfo: "Sürüm Bilgileri",
        version: "Sürüm",
        changeReason: "Değişiklik nedeni",
        changeReasonPh: "Bu sürümde ne değişti?",
        options: "Yayımlama Seçenekleri",
        futureOnly: "Yalnızca gelecekteki taleplerde kullan",
        allMatching: "Kapsama uyan tüm mevcut çalışanlardan iste",
        selectedEmployees: "Seçili mevcut çalışanlar için yeni talepler oluştur",
        affected: "Etkilenecek çalışanlar",
        employeeCount: "{{n}} çalışan",
        searchPersonel: "Personel ara…",
        selectAll: "Tümünü seç",
        clear: "Temizle",
        checklist: "Yayımlama kontrol listesi",
        preserveNote: "Mevcut onaylı personel belgeleri korunur; yeni sürüme otomatik güncellenmez.",
        action: "Şablonu Yayınla",
        newVersion: "Yeni Sürümü Yayınla",
        firstPublish: "İlk yayımlama",
        check: {
          file: "Kaynak dosya / içerik hazır",
          required: "Zorunlu alanlar tanımlı",
          mapped: "Değişkenler eşleşti",
          autoConfigured: "Otomatik alanlar yapılandırıldı",
          structure: "Şablon yapısı tamam"
        }
      },
      version: {
        historyTitle: "Sürüm Geçmişi ve Karşılaştırma",
        compareAction: "Sürüm Karşılaştır",
        current: "v{{v}} Mevcut Sürüm",
        draft: "v{{v}} Yeni Sürüm (Taslak)",
        publishedAt: "Yayımlanma: {{date}}",
        editedAt: "Son düzenleme: {{date}}",
        noPublished: "Yayımlanmış sürüm yok",
        noReason: "Açıklama yok",
        editorLocal: "Yerel düzenleyici (Ürünver)",
        sourceFile: "Kaynak Dosya",
        newSectionBadge: "+ Yeni alanlar",
        diffTitle: "Alan farkları",
        diff: {
          added: "Eklendi",
          changed: "Değişti",
          removed: "Kaldırıldı"
        }
      },
      breadcrumb: {
        docs: "Belgeler",
        templates: "Şablonlar",
        edit: "Şablon Düzenle"
      },
      toasts: {
        draftSaved: "Taslak kaydedildi",
        draftRestored: "Kaydedilmiş taslak geri yüklendi",
        published: "Şablon yayımlandı",
        publishBlocked: "Yayımlama engellendi; eşleme ve zorunlu alanları kontrol edin",
        infoInvalid: "Belge bilgilerini tamamlayın",
        fileRequired: "DOCX veya PDF dosyası yükleyin",
        selectEmployees: "En az bir personel seçin",
        reasonRequired: "Değişiklik nedeni zorunludur",
        fieldAdded: "Alan eklendi",
        varInserted: "Değişken eklendi"
      }
    }
  },
  id: "id",
  installation_id: "installation id",
  installations: {
    certs: "Sertifikalar",
    certSerial: "Seri / parmak izi",
    certValid: "Geçerlilik",
    columns: {
      account: "Hesap",
      created: "Oluşturma",
      env: "Ortam",
      environment: "Ortam",
      health: "Sağlık",
      heartbeat: "Son heartbeat",
      name: "Ad",
      status: "Durum",
      seen: "Son görülme"
    },
    csrHint: "PEM formatında CSR yapıştırın.",
    detail: "Kurulum detayı",
    empty: "Kurulum yok",
    exportCerts: "Bekleyen CSR dışa aktar",
    exportDone: "CSR paketi indirildi",
    form: {
      accountId: "Hesap kimliği",
      entitlementId: "Hak kaydı kimliği",
      hint: "Yeni kurulum oluşturun.",
      hosting: "Barındırma"
    },
    importCerts: "İmzalı sertifika içe aktar",
    importDone: "Sertifika paketi içe aktarıldı",
    new: "Yeni kurulum",
    noCerts: "Sertifika yok",
    reason: "Gerekçe",
    revoke: "İptal et",
    revokeConfirmBody: "Bu sertifika kalıcı olarak iptal edilir. Devam edilsin mi?",
    revokeConfirmTitle: "Sertifikayı iptal et",
    selectHint: "Kurulum seçin",
    submitCsr: "CSR gönder",
    subtitle: "Müşteri kurulumları ve sağlık",
    title: "Kurulumlar"
  },
  kinds: "kinds",
  licenses: {
    columns: {
      actions: "İşlemler",
      created: "Oluşturma",
      reason: "Gerekçe",
      sequence: "Sıra",
      status: "Durum",
      account: "Hesap",
      issued: "Düzenlenme"
    },
    envelope: "Zarf indir",
    envelopeDone: "Lisans zarfı indirildi",
    export: "İstekleri dışa aktar",
    exportDone: "İstek paketi indirildi",
    import: "İmzalı paket içe aktar",
    importDone: "İmzalı paket içe aktarıldı",
    installation: "Kurulum",
    newRequest: "Lisans isteği oluştur",
    reason: "Gerekçe",
    requestHint: "İmza için bekleyen lisans isteği oluşturulur.",
    selectHint: "Kurulum seçin",
    selectInstallation: "Kurulum",
    stale: "Eski",
    subtitle: "Lisans istekleri ve zarflar",
    title: "İmzalı lisanslar",
    exportRequests: "İstekleri dışa aktar",
    exported: "Dışa aktarıldı"
  },
  mail: {
    columns: {
      email: "E-posta",
      name: "Görünen ad",
      provider: "Sağlayıcı"
    },
    subtitle: "Kurumsal posta hesapları",
    title: "Mail hesapları",
    mailbox: {
      title: "Posta kutusu",
      listMeta: "{{count}} konuşma",
      unreadMeta: "{{count}} okunmamış",
      loadMore: "Daha eski mailleri yükle",
      emptySearch: "Aramanızla eşleşen mail yok",
      unreadDot: "Okunmadı",
      hasAttachments: "Ek var",
      position: "{{index}} / {{total}}",
      prev: "Önceki mail",
      next: "Sonraki mail",
      chips: {
        all: "Tümü",
        unread: "Okunmamış",
        starred: "Yıldızlı",
        attachments: "Ekli"
      },
      bulk: {
        select: "Seç: {{subject}}",
        selectAll: "Tümünü seç",
        selected: "{{count}} seçili",
        read: "Okundu yap",
        unread: "Okunmadı yap",
        star: "Yıldızla",
        restore: "Gelen kutusuna taşı",
        clear: "Seçimi temizle"
      },
      dates: {
        today: "Bugün",
        yesterday: "Dün",
        week: "Bu hafta",
        month: "Bu ay",
        older: "Daha eski"
      },
      shortcuts: {
        title: "Klavye kısayolları",
        hint: "Yazı alanı dışındayken tek tuşla çalışır.",
        navigateHint: "ile mailler arasında gezinin",
        next: "Sonraki mail",
        prev: "Önceki mail",
        close: "Maili kapat",
        reply: "Yanıtla",
        replyAll: "Tümünü yanıtla",
        forward: "İlet",
        star: "Yıldızla / kaldır",
        unread: "Okunmadı yap",
        trash: "Çöpe taşı",
        compose: "Yeni mail",
        search: "Aramaya git",
        help: "Bu listeyi aç"
      },
      nav: "Posta klasörleri",
      compose: "Yeni mail",
      composeReply: "Yanıtla",
      composeForward: "İlet",
      composeDraft: "Taslağı düzenle",
      composeHint: "İmzanız otomatik eklenir. Metni araç çubuğuyla biçimlendirin.",
      composeExpand: "Büyüt",
      composeCollapse: "Küçült",
      collapseNav: "Posta menüsünü daralt",
      expandNav: "Posta menüsünü genişlet",
      attachments: {
        add: "Dosya ekle",
        download: "{{name}} indir",
        remove: "Eki kaldır",
        quota: "{{used}} / {{max}}",
        typeError: "\"{{name}}\" desteklenmeyen bir dosya türü.",
        totalSizeError: "Eklerin toplam boyutu 20 MB sınırını aşıyor."
      },
      composeToRequired: "En az bir alıcı gerekli",
      send: "Gönder",
      saveDraft: "Taslak kaydet",
      draftSaved: "Taslak kaydedildi",
      sent: "Mail gönderildi",
      search: "Maillerde ara…",
      unreadOnly: "Yalnızca okunmamış",
      empty: "Bu görünümde mail yok",
      emptyHint: "Başka bir klasör veya grup seçin",
      selectPrompt: "Bir mail seçin",
      selectHint: "Listeden bir ileti açarak içeriğini görüntüleyin",
      from: "Kimden",
      to: "Kime",
      toPlaceholder: "alici@ornek.com",
      cc: "Cc",
      ccPlaceholder: "cc@ornek.com",
      bcc: "Bcc",
      bccPlaceholder: "bcc@ornek.com",
      subject: "Konu",
      dragHint: "Bir maili sol gruplara sürükleyip bırakarak etiketleyebilirsiniz.",
      draftAutoSaved: "Taslak olarak kaydedildi.",
      threadCount: "{{count}} ileti",
      subjectPlaceholder: "Konu",
      body: "Gövde",
      editor: {
        toolbar: "Biçimlendirme",
        image: "Logo / görsel ekle",
        imageType: "Yalnız PNG, JPG, GIF ya da WEBP görsel eklenebilir.",
        imageTooBig: "Görsel en fazla 300 KB olabilir; daha küçük bir logo kullanın.",
        bold: "Kalın",
        italic: "İtalik",
        underline: "Altı çizili",
        bulletList: "Madde listesi",
        numberedList: "Numaralı liste",
        link: "Bağlantı ekle",
        linkPrompt: "Bağlantı adresini girin",
        strike: "Üstü çizili",
        fontFamily: "Yazı tipi",
        fontDefault: "Varsayılan",
        fontSize: "Yazı boyutu",
        sizes: {
          small: "Küçük",
          normal: "Normal",
          large: "Büyük",
          huge: "Çok büyük"
        },
        color: "Yazı rengi",
        alignLeft: "Sola hizala",
        alignCenter: "Ortala",
        alignRight: "Sağa hizala",
        quote: "Alıntı",
        indent: "Girintiyi artır",
        outdent: "Girintiyi azalt",
        clear: "Biçimi temizle",
        undo: "Geri al",
        redo: "Yinele",
        htmlPasted: "HTML kodu imza olarak eklendi."
      },
      recipients: {
        invalid: "Geçersiz e-posta adresi",
        remove: "{{address}} adresini kaldır"
      },
      noSubject: "(konu yok)",
      replyPrefix: "Ynt: ",
      forwardPrefix: "İlt: ",
      star: "Favorilere ekle",
      unstar: "Favorilerden çıkar",
      folders: {
        inbox: "Gelen kutusu",
        favorites: "Favoriler",
        sent: "Gönderilenler",
        drafts: "Taslaklar",
        spam: "Spam",
        trash: "Çöp kutusu"
      },
      groups: {
        title: "Gruplarım",
        add: "Grup ekle",
        delete: "Grubu sil",
        newPlaceholder: "Yeni grup adı",
        assign: "Gruplar",
        added: "Mail gruba eklendi",
        empty: "Henüz grup yok"
      },
      actions: {
        reply: "Yanıtla",
        replyAll: "Tümünü yanıtla",
        forward: "İlet",
        spam: "Spam'e taşı",
        notSpam: "Spam değil",
        trash: "Çöpe taşı",
        deleteForever: "Kalıcı sil",
        editDraft: "Taslağı aç"
      },
      settings: {
        title: "Mail ayarları",
        subtitle: "İmzanız yeni mail ve yanıtlarda otomatik kullanılır.",
        signature: "Mail imzası",
        signatureHint: "Her gönderimde alta eklenir. Gmail imzanızı kopyalayıp yapıştırabilir, imzanın HTML kodunu doğrudan yapıştırabilir ya da araç çubuğuyla yazıp logonuzu ekleyebilirsiniz.",
        signatureHtml: "HTML kodu",
        signatureVisual: "Görsel düzenleyici",
        signatureHtmlHint: "Mevcut imzanızın HTML kodu; doğrudan düzenleyebilir ya da yenisini yapıştırabilirsiniz, önizleme anında güncellenir. Logo gibi görselleri herkese açık bir https adresiyle verin (örn. https://www.urunver.com.tr/logo.png); böylece maile ek olarak gömülmez.",
        preview: "İmza önizleme",
        saved: "Mail ayarları kaydedildi"
      }
    }
  },
  meetings: {
    kinds: {
      demo: "Demo",
      diger: "Diğer",
      telefon: "Telefon",
      toplanti: "Toplantı",
      ziyaret: "Ziyaret"
    },
    columns: {
      account: "Hesap",
      kind: "Tür",
      location: "Konum",
      planned: "Planlanan",
      status: "Durum",
      subject: "Konu",
      when: "Zaman"
    },
    edit: "edit",
    empty: "empty",
    form: {
      accountId: "accountId",
      accountRequired: "accountRequired",
      endsAt: "endsAt",
      hint: "hint",
      kind: "kind",
      location: "location",
      plannedAt: "plannedAt",
      plannedRequired: "plannedRequired",
      status: "status",
      subject: "subject",
      subjectRequired: "subjectRequired"
    },
    new: "new",
    subtitle: "Planlanan ve yapılan görüşmeler",
    title: "Görüşmeler"
  },
  nav: {
    accounts: "Hesaplar",
    audit: "Denetim kayıtları",
    crmAccess: "Erişim Talepleri",
    crmCollections: "Tahsilatlar",
    crmCustomers: "Müşteriler",
    crmDelivery: "Demo ve Kurulum",
    crmMeetings: "Görüşmeler",
    crmOffers: "Teklifler",
    crmFollowups: "Takipler",
    crmOrders: "Siparişler",
    crmRenewals: "Yenilemeler",
    crmOverview: "Genel Bakış",
    crmSupport: "Destek",
    dashboard: "Panel",
    demos: "Demolar",
    departments: "Departmanlar",
    financeAccounts: "Kasa ve POS",
    financeApprovals: "İptal Onayları",
    financeBooks: "Yevmiye ve Mizan",
    financeCards: "Kartlar",
    financeCashFlow: "Nakit Akışı",
    financeCategories: "Kategoriler",
    financeEDocs: "GİB e-Belgeler",
    financeObligations: "Ödeme Planı",
    financeLoans: "Krediler",
    financeBanks: "Bankalar",
    financeBankReport: "Banka Raporu",
    financePnL: "Kâr / Zarar",
    financeReimbursements: "Personel Geri Ödemeleri",
    financeStaffAdvances: "İş Avansları",
    financeBudgets: "Bütçe",
    financeDepartments: "Departman Ataması",
    crmExpenses: "Müşteri Giderleri",
    financeDeposits: "Vadeli Hesaplar",
    financeFx: "Kurlar ve Değerleme",
    financePaymentRequests: "Ödeme Onayları",
    financeCashAdvances: "Nakit Avans",
    financeOverview: "Genel Bakış",
    financeParties: "Cariler",
    financePersonal: "Kişisel Finans",
    financeTransactions: "Gelir ve Giderler",
    followups: "Takipler",
    accessUsers: "Kullanıcılar",
    accessRoles: "Roller",
    groups: {
      admin: "Yönetim",
      hr: "Personel Yönetimi",
      insights: "Raporlar",
      licensing: "Lisans ve kurulum",
      mail: "Mailler",
      operations: "Operasyon",
      customers: "Müşteri Yönetimi",
      finance: "Finansal Yönetim",
      overview: "Genel",
      printers: "Yazıcı Yönetimi",
      projects: "Projeler",
      sales: "Satış",
      access: "Erişim Yönetimi"
    },
    hr: "İK (API)",
    hrPersonel: "Personeller",
    hrBelgeTakip: "Belge İnceleme",
    hrBelgeler: "Belge Şablonları",
    hrBordro: "Bordro",
    hrOdemeler: "Ödemeler",
    hrPositions: "Pozisyonlar",
    infra: "Altyapı",
    installations: "Kurulumlar",
    licenses: "İmzalı lisanslar",
    customerCategories: "Müşteri Kategorileri",
    discounts: "İskonto Limitleri",
    mail: "Mail hesapları",
    mailbox: "Posta kutusu",
    meetings: "Görüşmeler",
    orders: "Teklif ve siparişler",
    pipelines: "Satış aşamaları",
    printerInstalls: "Kurulum Bilgileri",
    printers: "Yazıcılar",
    projectRules: "Görev Kuralları",
    projectTasks: "Görev Panoları",
    projectAssignments: "Atama Talepleri",
    projectBoards: "Proje Panoları",
    projectCatalog: "Modül ve Fiyatlar",
    releases: "Sürümler ve imajlar",
    renewals: "Yenilemeler",
    reportCustomers: "Müşteri ve Destek",
    reportFinance: "Finans",
    reportHr: "İnsan Kaynakları",
    reportOperations: "Proje ve Operasyon",
    reportProfitability: "Kârlılık",
    reportOverview: "Yönetim Özeti",
    reportSales: "Satış",
    regions: "Bölgeler",
    roles: "Roller ve Yetkiler",
    tax: "Vergi ve Muhasebe",
    tickets: "Destek",
  },
  notifications: {
    allCategories: "Tüm kategoriler",
    allLevels: "Tüm önem düzeyleri",
    allMarked: "Tüm bildirimler okundu olarak işaretlendi",
    allRead: "Okunmamış bildirim yok",
    bellUnread: "Bildirimler, {{count}} okunmamış",
    bucket: {
      older: "Daha eski",
      today: "Bugün",
      week: "Bu hafta",
      yesterday: "Dün"
    },
    categories: {
      crm: "Müşteri",
      finance: "Finans",
      hr: "Personel",
      infra: "Altyapı",
      printer: "Yazıcı",
      project: "Proje",
      system: "Sistem"
    },
    category: "Kategori",
    count: "{{count}} / {{total}} bildirim",
    empty: "Bildirim yok",
    filter: {
      all: "Tümü",
      read: "Okunmuş",
      unread: "Okunmamış"
    },
    level: "Önem",
    levels: {
      critical: "Kritik",
      info: "Bilgi",
      success: "Başarılı",
      warning: "Uyarı"
    },
    markAllRead: "Tümünü okundu işaretle",
    markRead: "Okundu olarak işaretle",
    markUnread: "Okunmadı olarak işaretle",
    noMatch: "Filtrelere uyan bildirim yok",
    open: "İlgili kayda git",
    read: "Okunmuş",
    readAt: "{{time}} okundu",
    removed: "Bildirim silindi",
    removedRead: "Okunmuş bildirimler silindi",
    removeRead: "Okunmuşları sil",
    removeReadBody: "{{count}} okunmuş bildirim kalıcı olarak silinecek.",
    removeReadTitle: "Okunmuş bildirimler silinsin mi?",
    search: "Başlık, içerik ya da kişi ara…",
    seeAll: "Tümünü gör",
    subtitle: "Müşteri, finans, proje, altyapı ve personel bildirimleriniz.",
    title: "Bildirimler",
    unread: "Okunmamış",
    unreadCount: "{{count}} okunmamış bildirim"
  },
  orders: {
    approve: "Onayla",
    approveConfirm: "approveConfirm",
    approveHint: "approveHint",
    columns: {
      account: "Hesap",
      created: "Oluşturma",
      status: "Durum",
      total: "Toplam"
    },
    detail: "detail",
    emptyOrders: "emptyOrders",
    emptyQuotes: "emptyQuotes",
    finalize: "Kesinleştir",
    form: {
      branchLimit: "branchLimit",
      licenseTerm: "licenseTerm",
      maintenanceUntil: "maintenanceUntil",
      rejectNote: "rejectNote",
      supportUntil: "supportUntil"
    },
    licenseTerm: {
      perpetual: "perpetual",
      subscription: "subscription"
    },
    lines: {
      discount: "discount",
      lineTotal: "lineTotal",
      lineType: "lineType",
      qty: "qty",
      refCode: "refCode",
      unitPrice: "unitPrice"
    },
    reject: "Reddet",
    rejectConfirm: "rejectConfirm",
    rejectHint: "rejectHint",
    subtitle: "Tekliften siparişe",
    tabs: {
      orders: "Siparişler",
      quotes: "Teklifler"
    },
    title: "Teklif ve siparişler",
    finalized: "Teklif kesinleştirildi",
    approveConfirmTitle: "Siparişi onayla",
    rejectConfirmTitle: "Siparişi reddet",
    confirmBody: "{{account}} için işlemi onaylıyor musunuz?"
  },
  printers: {
    actions: {
      detail: "Detay"
    },
    add: "Yazıcı Ekle",
    allDepartments: "Tüm departmanlar",
    allOffices: "Tüm ofisler",
    allStatuses: "Tüm durumlar",
    columns: {
      actions: "İşlemler",
      installs: "Kurulum",
      location: "Konum",
      printer: "Yazıcı"
    },
    connection: {
      network: "Kablolu ağ",
      usb: "USB",
      wifi: "Wi-Fi"
    },
    count: "{{count}} / {{total}} yazıcı",
    created: "Yazıcı eklendi",
    deleteBody: "“{{name}}” yazıcısı silinecek.",
    deleteBodyInstalls: "“{{name}}” yazıcısı ve {{count}} kurulum bilgisi silinecek.",
    deleted: "Yazıcı silindi",
    deleteTitle: "Yazıcı silinsin mi?",
    detail: {
      installs: "Kurulum bilgileri ({{count}})",
      noInstalls: "Bu yazıcı için henüz kurulum bilgisi oluşturulmadı."
    },
    empty: "Henüz yazıcı eklenmedi",
    fields: {
      assetTag: "Demirbaş no",
      brand: "Marka",
      connection: "Bağlantı",
      department: "Departman",
      hostComputer: "Bağlı bilgisayar",
      hostname: "Ağ adı (hostname)",
      ip: "IP adresi",
      mac: "MAC adresi",
      model: "Model",
      name: "Yazıcı adı",
      notes: "Notlar",
      office: "Ofis",
      queueName: "Yazdırma kuyruğu",
      room: "Kat / oda",
      serialNo: "Seri numarası",
      status: "Durum",
      type: "Tür"
    },
    form: {
      chooseDepartment: "Departman seçin",
      createTitle: "Yeni yazıcı",
      departmentRequired: "Departman seçin",
      editTitle: "Yazıcıyı düzenle: {{name}}",
      hint: "Şirket ofisindeki yazıcının cihaz, konum ve bağlantı bilgileri.",
      nameHint: "Bilgisayarlarda yazıcı listesinde bu adla görünür.",
      nameRequired: "Ad en az 2 karakter olmalı",
      queueHint: "Yazdırma sunucusundaki paylaşım adı.",
      required: "Bu alan zorunlu",
      roomPlaceholder: "Ör. Kat 2 · Koridor",
      sections: {
        connection: "Bağlantı",
        device: "Cihaz bilgileri",
        location: "Konum ve departman"
      }
    },
    install: {
      add: "Kurulum Bilgisi Oluştur",
      allMethods: "Tüm yöntemler",
      allPrinters: "Tüm yazıcılar",
      allResults: "Tüm sonuçlar",
      computer: "Bilgisayar adı",
      count: "{{count}} / {{total}} kayıt",
      created: "Kurulum bilgisi oluşturuldu",
      date: "Kurulum tarihi",
      deleteBody: "{{printer}} yazıcısının {{computer}} bilgisayarındaki kurulum bilgisi silinecek.",
      deleted: "Kurulum bilgisi silindi",
      deleteTitle: "Kurulum bilgisi silinsin mi?",
      detailTitle: "{{printer}} · {{user}}",
      driver: "Sürücü",
      driverVersion: "Sürücü sürümü",
      empty: "Henüz kurulum bilgisi oluşturulmadı",
      form: {
        choosePrinter: "Yazıcı seçin",
        chooseInstaller: "Kurulum ve Altyapı ekibinden seçin",
        chooseUser: "Personel seçin",
        createTitle: "Kurulum bilgisi oluştur",
        editTitle: "Kurulum bilgisini düzenle",
        hint: "Yazıcının hangi personelin bilgisayarına, hangi yöntem ve sürücüyle kurulduğunu kaydedin.",
        installerRequired: "Kurulumu yapan kişiyi seçin",
        printerRequired: "Yazıcı seçin",
        sections: {
          setup: "Kurulum",
          target: "Yazıcı ve bilgisayar"
        },
        stepsHint: "Her adımı ayrı satıra yazın; aynı kurulum başka bilgisayarda bu adımlarla tekrarlanabilir.",
        testHint: "Test sayfası sorunsuz çıktıysa işaretleyin.",
        userRequired: "Personel seçin"
      },
      installedBy: "Kurulumu yapan",
      installedByDate: "Kurulumu yapan / tarih",
      kpi: {
        failed: "Test başarısız",
        failedHint: "Tekrar kurulum gerekebilir",
        noInstall: "Kurulumu olmayan yazıcı",
        noInstallOk: "Tüm yazıcılar kurulu",
        thisMonth: "Bu ay",
        thisMonthHint: "Bu ay oluşturulan kurulum",
        total: "Toplam kurulum",
        totalHint: "{{count}} bilgisayarda"
      },
      method: "Yöntem",
      noSteps: "Kurulum adımı yazılmadı.",
      notes: "Notlar",
      os: "İşletim sistemi",
      printer: "Yazıcı",
      search: "Yazıcı, personel, bilgisayar ya da sürücü ara…",
      steps: "Kurulum adımları",
      subtitle: "Yazıcıların hangi personelin bilgisayarına, hangi yöntem ve sürücüyle kurulduğu.",
      testFailed: "Başarısız",
      testOk: "Başarılı",
      testPrint: "Test sayfası",
      title: "Kurulum Bilgileri",
      user: "Personel",
      userAndComputer: "Personel / bilgisayar",
      whatBody: "Her kayıt bir yazıcının bir bilgisayara kurulumudur: kimin bilgisayarı, hangi yöntem (yazdırma sunucusu, grup ilkesi ya da elle), sürücü ve izlenen adımlar. Yeni personele aynı yazıcıyı kurarken bu adımlar kullanılır.",
      whatTitle: "Kurulum bilgisi nedir?"
    },
    method: {
      gpo: "Grup ilkesi (GPO)",
      manual: "Elle kurulum",
      print_server: "Yazdırma sunucusu"
    },
    methodHint: {
      gpo: "Departman bilgisayarlarına otomatik dağıtıldı",
      manual: "Bilgisayara doğrudan kuruldu",
      print_server: "Sunucudaki paylaşımdan eklendi"
    },
    kpi: {
      faulty: "Arızalı",
      faultyHint: "Servis bekleyen yazıcı",
      inUse: "Kullanımdaki yazıcı",
      inUseHint: "{{count}} ofiste",
      installs: "Kurulum bilgisi",
      installsHint: "{{count}} yazıcının kurulumu yok",
      network: "Ağ yazıcısı",
      networkHint: "Kablolu ağ ya da Wi-Fi"
    },
    noMatch: "Filtrelere uyan kayıt yok",
    os: {
      linux: "Linux",
      macos: "macOS",
      windows: "Windows"
    },
    search: "Yazıcı, marka, model, oda, seri/demirbaş no, IP ara…",
    status: {
      active: "Kullanımda",
      faulty: "Arızalı",
      retired: "Kullanım dışı"
    },
    subtitle: "Şirket ofislerindeki yazıcılar; cihaz, konum, departman ve bağlantı bilgileri.",
    title: "Yazıcılar",
    type: {
      inkjet: "Mürekkep püskürtmeli",
      label: "Etiket",
      laser_color: "Renkli lazer",
      laser_mono: "Siyah-beyaz lazer",
      multifunction: "Çok fonksiyonlu",
      thermal: "Termal (POS)"
    }
  },
  projects: {
    board: {
      title: "Görev Panoları",
      subtitle: "Teknik, satış ve destek ekiplerinin görevleri. Kuralların ve sistemin açtığı görevler de burada; kartı sürükleyerek ilerletin.",
      noBoards: "Henüz pano yok",
      add: "Görev ekle",
      search: "Görev, müşteri ya da proje ara",
      summary: "{{count}} açık görev",
      overdue: "{{count}} gecikmiş",
      wipTitle: "Bu kolonda aynı anda en fazla {{limit}} görev olmalı",
      none: "Yok",
      createTitle: "{{board}} panosuna görev ekle",
      editTitle: "Görevi düzenle",
      titleRequired: "Görev başlığı gerekli",
      created: "Görev eklendi",
      updated: "Görev güncellendi",
      archive: "Arşivle",
      archiveTitle: "Görev arşivlensin mi?",
      archived: "Görev arşivlendi",
      fields: {
        title: "Başlık",
        description: "Açıklama",
        column: "Kolon",
        priority: "Öncelik",
        assignee: "Sorumlu",
        due: "Bitiş tarihi",
        customer: "Müşteri",
        project: "Proje"
      },
      filters: {
        everyone: "Herkes",
        mine: "Bana atananlar",
        anyPriority: "Tüm öncelikler"
      },
      columns: {
        open: "Kolonları düzenle",
        title: "{{board}} panosunun kolonları",
        hint: "Kolonları sıralayın, yeniden adlandırın ya da ekleyin. \"Bitti\" işaretli kolona taşınan görev tamamlanmış sayılır; iş sınırı bir kolonda aynı anda kaç görev olabileceğini belirler.",
        name: "Kolon adı",
        wip: "İş sınırı",
        noLimit: "Sınırsız",
        done: "Bitti kolonu",
        doneShort: "Bitti",
        add: "Kolon ekle",
        newName: "Yeni kolon",
        up: "Yukarı taşı",
        down: "Aşağı taşı",
        taskCount: "{{count}} görev",
        deleteTitle: "Kolon silinsin mi?",
        notEmpty: "\"{{name}}\" kolonunda {{count}} görev var; önce görevleri başka kolona taşıyın.",
        nameRequired: "Her kolonun bir adı olmalı",
        needDone: "En az bir kolon \"Bitti\" olarak işaretlenmeli",
        saved: "Kolonlar kaydedildi"
      }
    },
    rules: {
      add: "Kural ekle",
      assign: {
        default: "Varsayılan sorumlu",
        hint: "Her rol için seçtiğiniz kişi o roldeki görevlere atanır; seçmezseniz görev varsayılan sorumluya (olayın sorumlusu ya da proje lideri) düşer.",
        taskCount: "{{count}} görev",
        title: "Görevleri kime atayalım?"
      },
      defaultAssignee: "Varsayılan sorumlu",
      deleteTitle: "Kural silinsin mi?",
      dueDays: "{{count}} gün içinde",
      editTitle: "Kuralı düzenle",
      empty: "Henüz görev kuralı yok",
      events: {
        "demo.converted": "Demo satışa dönüştü",
        "demo.created": "Demo oluşturuldu",
        "demo.expired": "Demo bitti",
        "demo.expiring": "Demo bitmek üzere",
        "install.stage_changed": "Kurulum aşaması değişti",
        manual: "Elle çalıştırılan kural grupları",
        "meeting.planned": "Görüşme planlandı",
        "order.approved": "Sipariş onaylandı",
        "sales.stage_changed": "Satış aşaması değişti"
      },
      f: {
        active: "Aktif",
        board: "Hangi panoya",
        column: "Hangi kolonda açılsın",
        description: "Açıklama",
        due: "Kaç gün içinde bitsin",
        event: "Olay",
        group: "Kural grubu",
        groupPlaceholder: "Örn. Demo kurulumu",
        match: "Hangi durumda",
        matchValue: "Koşul değeri",
        priority: "Öncelik",
        role: "Kime (görev rolü)",
        rolePlaceholder: "Örn. Kurulum sorumlusu",
        title: "Görev başlığı",
        titlePlaceholder: "Örn. Demo sunucusunu kur"
      },
      inactive: "Pasif",
      match: {
        always: "Her seferinde",
        deliverable: "Belirli bir teslimat istendiyse",
        each_module: "Satılan her modül için ayrı görev",
        group: "Grup",
        meeting_kind: "Belirli bir görüşme türündeyse",
        module: "Belirli bir modül satıldıysa",
        stage: "Belirli bir aşamaya geçildiyse"
      },
      matchValue: {
        deliverable: "Teslimat",
        meeting_kind: "Görüşme türü",
        module: "Modül",
        stage: "Aşama"
      },
      eventHints: {
        "demo.converted": "Demo müşterisi satışa dönüştüğünde",
        "demo.created": "Bir müşteri için demo kurulduğunda",
        "demo.expired": "Demonun süresi dolduğunda",
        "demo.expiring": "Demonun bitmesine 7, 3 ve 1 gün kala",
        "install.stage_changed": "Müşterinin kurulum aşaması değiştiğinde",
        manual: "Kural grubunu yukarıdaki \"Kural grubunu çalıştır\" bölümünden bir müşteri ya da proje için siz çalıştırırsınız",
        "meeting.planned": "Müşteriyle bir görüşme planlandığında",
        "order.approved": "Bir sipariş onaylandığında",
        "sales.stage_changed": "Müşterinin satış aşaması değiştiğinde"
      },
      steps: {
        when: "Ne zaman?",
        condition: "Hangi durumda?",
        task: "Hangi görev açılsın?",
        where: "Nereye ve kime?"
      },
      hints: {
        group: "Birlikte çalıştırılacak kurallar aynı grupta toplanır (örn. \"Demo kurulumu\"). Var olan bir grubu seçin ya da yeni ad yazın.",
        due: "Olay anından itibaren gün sayısı; boş bırakırsanız bitiş tarihi olmaz.",
        column: "Görev panonun bu kolonunda açılır.",
        role: "Rol verirseniz kural çalışmadan önce bu role bir personel seçilir ve görev ona atanır. Boş bırakırsanız olayın sorumlusuna (ya da proje liderine) atanır."
      },
      errors: {
        group: "Kural grubunu seçin ya da yazın",
        value: "Bir değer seçin",
        title: "Görev başlığı gerekli"
      },
      vars: {
        account: "Müşteri adı",
        module: "Modül adı",
        stage: "Aşama",
        meeting_kind: "Görüşme türü",
        days: "Kalan gün"
      },
      editorHint: "Kuralı dört adımda tanımlayın. Pano, kolon, aşama ve modül sistemden seçilir.",
      insertVar: "Başlığa ekle:",
      pick: "Seçin",
      noDue: "Bitiş tarihi yok",
      groupTitle: "Elle çalıştırılan grup: {{group}}",
      howTitle: "Görev kuralları nasıl çalışır?",
      how: "Bir olay olduğunda (sipariş onaylandı, demo kuruldu, aşama değişti…) ya da bir kural grubunu elle çalıştırdığınızda, burada tanımlı kurallar seçilen panoda görev açar. Açılan görevleri Görev Panoları ekranında izleyebilirsiniz.",
      emptyHint: "\"Kural ekle\" ile ilk kuralınızı oluşturun.",
      priority: { high: "Yüksek", low: "Düşük", normal: "Normal", urgent: "Acil" },
      run: {
        account: "Müşteri",
        again: "Yine de çalıştır",
        againTitle: "Kural grubu zaten çalıştırılmış",
        done: "{{count}} görev oluşturuldu ve atandı",
        for: "Kimin için",
        pickGroup: "Grup seçin",
        pickTarget: "Seçin",
        project: "Proje",
        submit: "Kuralı çalıştır",
        title: "Kural grubunu çalıştır"
      },
      saved: "Kural kaydedildi",
      subtitle: "Olay olduğunda ya da elle çalıştırıldığında açılacak görevler. Görev rolü tanımlayın; tetiklemeden önce her role personel seçilir, motor görevleri o kişilere atar.",
      title: "Görev Kuralları"
    },
    deploymentDerived: "Altyapı yerleşimlerinden hesaplanır: bizim sunucularımızda çalışıyorsa Bulut, müşteride çalışıyorsa Müşteri Sunucusu, ikisi birden varsa Hibrit.",
    deploymentNone: "Henüz dağıtım yok",
    servers: {
      customerServer: "Müşteri sunucusu",
      empty: "Bu proje henüz hiçbir sunucuda çalışmıyor.",
      openInfra: "Altyapı",
      openServer: "{{name}} sunucu detayını aç",
      summary: "{{total}} aktif ortam · {{servers}} sunucumuzda, {{onPrem}} müşteri sunucusunda",
      title: "Sunucular"
    },
    assign: {
      allAssigned: "Tüm açık görevlerin sorumlusu var.",
      hint: "Ekip üyelerinin açık görev yükünü görün; atamayı satırdaki seçimden değiştirin. Tamamlanan görevler listelenmez.",
      load: "İş yükü",
      newFor: "{{name}} için yeni görev",
      openCount: "{{count}} açık görev",
      overdue: "{{count}} gecikmiş",
      reassign: "{{key}} sorumlusu",
      remainingHours: "Kalan tahmini {{count}} saat",
      unassigned: "Atanmamış görevler ({{count}})"
    },
    boards: {
      create: "Proje Panosu Oluştur",
      subtitle: "Tüm projelerin, ekiplerin ve müşteri çalışmalarının genel görünümü.",
      title: "Proje ve Ekip Panoları"
    },
    calendar: {
      empty: "Bu ay için görev ya da hedef tarih yok.",
      hint: "Görevler bitiş tarihine, kurulum ve demolar hedef tarihine göre gösterilir.",
      more: "+{{count}} daha",
      target: "Hedef: {{name}}"
    },
    catalog: {
      activeLabel: "Aktif",
      featureList: {
        chooseModule: "Özelliğin ekleneceği modülü seçin",
        deleteFor: "{{name}} özelliğini sil",
        editFor: "{{name}} özelliğini düzenle",
        empty: "Henüz hiçbir modüle özellik eklenmedi",
        fillFirst: "{{name}} için ekle",
        formHint: "Özellik bir modülün kapsamına eklenir; o modülü alan her üründe görünür.",
        openModule: "Modül sayfası",
        openModuleFor: "{{name}} modül sayfasını aç",
        whatBody: "Özellikler, bir modülü alan müşterinin neler yapabildiğini anlatır (ör. QR Menü → Çoklu dil, Garson çağırma). Ayrı satılmaz ve fiyatı yoktur; teklif, demo ve satış görüşmesinde “bu modülde ne var?” sorusunu cevaplar. Buradan ya da modül sayfasından eklenir, ikisi aynı kaydı değiştirir.",
        whatTitle: "Özellikler ne işe yarar?",
        allGroups: "Tüm gruplar",
        allModules: "Tüm modüller",
        count: "{{count}} / {{total}} özellik",
        feature: "Özellik",
        module: "Modül",
        noFeatures: "Kapsamı tanımlanmamış modüller: {{names}}",
        products: "Sunulduğu ürünler",
        search: "Özellik, açıklama ya da grup ara…"
      },
      actions: "İşlemler",
      packages: {
        addModule: "Modül ekle",
        addons: "Ek modüller ({{count}})",
        base: "Başlangıç paketi ({{count}} zorunlu modül)",
        customers: "{{count}} müşteri · {{live}} canlıda",
        includes: "Pakete dahil",
        noBase: "Zorunlu modül tanımlanmamış; ürün tek başına satılamaz.",
        openProject: "Projeye git",
        showModules: "Modüller"
      },
      priceDetail: {
        offeredCount: "{{count}} / {{total}} ürün",
        offeredIn: "Sunulduğu ürün",
        openModule: "Modül sayfası",
        price: "Fiyat",
        product: "Ürün",
        special: "Ürüne özel fiyat",
        status: "Durum",
        subtitle: "Modülün liste fiyatı ve her üründeki fiyatı, zorunluluğu.",
        title: "Fiyat detayı: {{name}}"
      },
      priceList: {
        detail: "Detay",
        detailFor: "{{name}} fiyat detayını göster",
        edit: "Fiyatları düzenle",
        editFor: "{{name}} fiyatlarını düzenle",
        inactive: "pasif",
        legendNone: "Bu üründe sunulmuyor",
        legendOptional: "Opsiyonel (ek modül)",
        legendRequired: "Zorunlu (pakete dahil)",
        legendSpecial: "Liste fiyatından farklı, ürüne özel fiyat",
        listPrice: "Liste fiyatı",
        module: "Modül",
        special: "özel"
      },
      pricing: {
        editLinkFor: "{{project}} için {{module}} fiyatını düzenle",
        depsHint: "Bu modülün bağımlılıkları var; yeni eklendiği üründe eksik olanlar otomatik olarak zorunlu eklenir.",
        inactive: "Pasif modül yeni ürüne eklenemez",
        listHint: "Bir ürüne ilk eklenirken önerilen fiyat. Ürünlerdeki mevcut fiyatları değiştirmez.",
        notOffered: "Bu üründe sunulmuyor",
        offered: "Bu üründe sunuluyor",
        partial: "Bazı değişiklikler kaydedilemedi",
        perProduct: "Ürünlerdeki fiyatı",
        priceFor: "{{project}} fiyatı",
        removeBody: "{{module}} şu ürünlerden çıkarılacak: {{projects}}. Bu modüle bağlı başka modül varsa çıkarılamaz.",
        removeTitle: "Modül ürünlerden çıkarılsın mı?",
        requirement: "{{project}} için zorunluluk",
        title: "Fiyatlandırma: {{name}}"
      },
      sectors: {
        customer: "Müşteri",
        customersTitle: "Bu sektördeki müşteriler ({{count}})",
        detail: "Detay",
        detailFor: "{{name}} sektör detayını göster",
        noCustomers: "Bu sektörde henüz CRM müşterisi yok.",
        openCustomer: "Müşteri kartı",
        openCustomerFor: "{{name}} müşteri kartını aç",
        openProjectFor: "{{name}} projesini aç",
        stage: "Aşama",
        whatTitle: "Sektörler ne işe yarar?",
        customers: "CRM müşterisi",
        deleteBody: "“{{name}}” sektörü silinecek. Bu sektörde CRM müşterisi varsa silinemez.",
        deleted: "Sektör silindi",
        deleteFor: "{{name}} sektörünü sil",
        deleteTitle: "Sektör silinsin mi?",
        description: "Açıklama",
        editFor: "{{name}} sektörünü düzenle",
        editTitle: "Sektörü düzenle",
        empty: "Henüz sektör yok",
        hint: "Hangi ürünün hangi sektöre satıldığını gösterir. CRM müşteri formunda ve website temalarında buradaki liste seçilir; müşteri sayıları müşteri kartındaki sektörden hesaplanır.",
        live: "{{count}} canlıda",
        name: "Sektör adı",
        nameRequired: "Sektör adı en az 2 karakter olmalı",
        new: "Yeni Sektör",
        noProduct: "Henüz ürün yok",
        products: "Satıldığı ürünler",
        renameHint: "Ad değişirse bu sektördeki CRM müşteri kartları da güncellenir.",
        sector: "Sektör"
      },
      tabs: {
        features: "Özellikler",
        modules: "Modüller",
        packages: "Ürün Paketleri",
        prices: "Fiyat Listesi",
        sectors: "Sektörler"
      },
      addToProject: "Projeye Ekle",
      allCategories: "Tüm kategoriler",
      allProjects: "Tüm projeler",
      changelog: {
        add: "Sürüm Notu Ekle",
        createTitle: "Yeni sürüm notu",
        deleteBody: "v{{version}} sürüm notu silinecek.",
        deleteTitle: "Sürüm notu silinsin mi?",
        editTitle: "Sürüm notunu düzenle",
        empty: "Henüz sürüm notu yok.",
        hint: "{{module}} modülündeki değişiklikler.",
        notesRequired: "En az 3 karakter girin",
        title: "Sürüm Notları",
        versionInvalid: "Sürüm biçimi örn. 1.4 ya da 2.0.1 olmalı"
      },
      chipHint: "{{requirement}} · {{price}} — düzenlemek için tıklayın",
      created: "Modül kataloğa eklendi",
      deleteBody: "“{{name}}” katalogdan kalıcı olarak silinecek. Projelerde kullanılıyorsa önce projelerden çıkarılmalıdır.",
      deleted: "Modül katalogdan silindi",
      deleteTitle: "Modül katalogdan silinsin mi?",
      detail: {
        added: "Eklenme",
        addedAt: "Eklenme: {{date}}",
        dependencies: "Bağımlılıklar",
        featureCount: "Özellik sayısı",
        info: "Modül Bilgileri",
        noRequiredBy: "Bu modülü gerektiren başka modül yok.",
        noRequirements: "Özel bir gereksinim yok.",
        noRequires: "Bağımsız çalışır.",
        notFound: "Modül bulunamadı",
        noTrial: "Yok",
        projects: "Eklendiği Projeler",
        requiredBy: "Bu modülü gerektirenler",
        requirements: "Teknik Gereksinimler",
        special: "projeye özel",
        usage: "Kullanım",
        usageValue: "{{count}} proje ({{required}} zorunlu)"
      },
      details: "Detaylar",
      empty: "Katalogda modül yok",
      emptyHint: "“Yeni Modül” ile ilk modülü tanımlayın, ardından projelere entegre edin.",
      features: {
        add: "Özellik Ekle",
        addTo: "{{group}} grubuna özellik ekle",
        count: "{{count}} özellik",
        created: "Özellik eklendi",
        createTitle: "Yeni özellik",
        deleteBody: "“{{name}}” özelliği {{module}} kapsamından çıkarılacak.",
        deleted: "Özellik silindi",
        deleteTitle: "Özellik silinsin mi?",
        editTitle: "Özelliği düzenle",
        empty: "Bu modülün kapsamı henüz tanımlanmadı. “Özellik Ekle” ile içerdiği işlemleri listeleyin.",
        group: "Grup",
        groupHint: "Benzer işlemler aynı grup başlığında listelenir; mevcut gruplardan seçebilir ya da yenisini yazabilirsiniz.",
        groupRequired: "Grup adı en az 2 karakter olmalı",
        hint: "{{module}} modülünün içerdiği bir işlem ya da özellik.",
        name: "Özellik adı",
        nameRequired: "Özellik adı en az 2 karakter olmalı",
        title: "Modül İçeriği",
        updated: "Özellik güncellendi"
      },
      fields: {
        active: "Aktif (projelere eklenebilir)",
        category: "Kategori",
        code: "Kod",
        listPrice: "Liste fiyatı",
        projectPrice: "Projedeki fiyat",
        setupHours: "Tahmini kurulum süresi",
        setupHoursShort: "Kurulum (saat)",
        trialDays: "Deneme süresi",
        trialDaysShort: "Deneme (gün)",
        version: "Sürüm",
        versionFromChangelog: "En son sürüm notundan otomatik gelir"
      },
      form: {
        activeHint: "Pasif modüller yeni projelere eklenemez; mevcut entegrasyonlar etkilenmez.",
        codeInvalid: "2–16 karakter; harf, rakam ve tire",
        createTitle: "Yeni modül",
        dependsHint: "Bu modül projeye eklenirken eksik olan gerekli modüller de otomatik eklenir.",
        editTitle: "Modülü düzenle",
        hint: "Katalogdaki modül tüm projelerde ortaktır; fiyat ve zorunluluk proje bazında ayrıca belirlenir.",
        nameRequired: "Modül adı en az 2 karakter olmalı",
        priceInvalid: "Geçerli bir tutar girin",
        requirementsHint: "Her satıra bir gereksinim yazın.",
        requirementsPlaceholder: "Örn. Android 9+ tablet\nTermal yazıcı (ESC/POS)"
      },
      integrate: {
        depsAdded: "Gerekli modüller de eklendi: {{names}}",
        depsNote: "Bu modül için projede eksik olan gerekli modüller de “Zorunlu” olarak eklenecek: {{names}}",
        done: "{{module}}, {{project}} projesine eklendi",
        editHint: "{{module}} modülünün {{project}} projesindeki ayarları.",
        editTitle: "Entegrasyonu düzenle",
        hint: "Modülü bir projeye ekleyin; zorunluluk ve fiyat yalnız bu proje için geçerlidir.",
        module: "Modül",
        moduleRequired: "Modül seçin",
        projectRequired: "Proje seçin",
        submit: "Projeye Ekle",
        title: "Modülü projeye ekle",
        updated: "Entegrasyon güncellendi"
      },
      moreFeatures: "+{{count}} özellik daha",
      newModule: "Yeni Modül",
      noMatch: "Filtrelere uyan modül yok",
      notUsed: "Henüz hiçbir projeye eklenmedi.",
      passive: "Pasif",
      project: "Proje",
      search: "Modül adı ya da kodu ara…",
      stats: {
        active: "Aktif modül",
        integrated: "Projede kullanılan",
        links: "Toplam entegrasyon",
        modules: "Katalogdaki modül"
      },
      subtitle: "Ürün ve modül kataloğu: modülleri tanımlayın, ürünlere (projelere) entegre edin; paketleri, fiyat listesini ve sektörleri tek yerden izleyin.",
      title: "Modül ve Fiyatlar",
      unused: "Hiçbir projede olmayanlar",
      updated: "Modül güncellendi",
      usedIn: "Entegre edilen projeler ({{count}})"
    },
    colors: {
      blue: "Mavi",
      green: "Yeşil",
      navy: "Lacivert",
      orange: "Turuncu",
      violet: "Mor"
    },
    created: "Proje oluşturuldu",
    delete: "Projeyi sil",
    deleteBody: "“{{name}}” projesi; {{members}} ekip üyesi ataması ve {{items}} çalışma kaydıyla birlikte kalıcı olarak silinecek. Bu işlem geri alınamaz.",
    deleted: "Proje silindi",
    deleteTitle: "Proje silinsin mi?",
    deployment: {
      cloud: "Bulut",
      customer_server: "Müşteri Sunucusu",
      hybrid: "Hibrit"
    },
    deploymentHint: {
      cloud: "Ürünver bulut altyapısında çalışır.",
      customer_server: "İşletmenin altyapısında kurulur.",
      hybrid: "Yerel sunucu + bulut senkronizasyonu."
    },
    detail: {
      addMember: "Üye Ekle",
      tabs: {
        calendar: "Takvim",
        files: "Dosyalar",
        installations: "Kurulum ve Demo",
        kanban: "Kanban",
        sprints: "Sprintler",
        list: "Liste",
        notes: "Notlar",
        overview: "Genel Bakış",
        reports: "Raporlar",
        settings: "Ayarlar",
        tasks: "Görev Ataması"
      },
      view: "Görünüm"
    },
    discipline: {
      backend: "Backend",
      design: "Tasarım",
      frontend: "Frontend",
      installation: "Kurulum",
      management: "Yönetim",
      qa: "QA",
      sales: "Satış"
    },
    docStatus: {
      signed: "Müşteri İmzalı",
      to_sign: "İmzalanacak",
      waiting: "Beklemede"
    },
    empty: "Henüz proje yok",
    emptyHint: "İlk projeyi oluşturarak ekip, çalışma ve modül takibine başlayın.",
    fields: {
      color: "Renk",
      deployment: "Kurulum tipi",
      description: "Açıklama",
      endDate: "Bitiş tarihi",
      endDateOptional: "Bitiş tarihi (isteğe bağlı)",
      endShort: "Bitiş: {{date}}",
      noEnd: "Süresiz",
      icon: "Simge",
      key: "Görev öneki",
      kind: "Proje türü",
      name: "Proje adı",
      period: "Proje dönemi",
      sector: "Sektör",
      startDate: "Başlangıç tarihi",
      startShort: "Başlangıç: {{date}}",
      status: "Durum",
      summary: "Özet",
      summaryValue: "{{modules}} modül · {{members}} ekip üyesi · {{tasks}} aktif görev",
      updatedAt: "Son güncelleme"
    },
    files: {
      deleteBody: "“{{name}}” dosyası kalıcı olarak silinecek.",
      deleted: "Dosya silindi",
      deleteTitle: "Dosya silinsin mi?",
      download: "{{name}} dosyasını indir",
      empty: "Henüz dosya yok",
      scope: {
        all: "Tümü",
        project: "Proje dosyaları",
        tasks: "Görev ekleri"
      },
      search: "Dosya ara…",
      summary: "{{count}} dosya · {{size}}",
      upload: "Dosya Ekle",
      uploaded: "{{name}} yüklendi"
    },
    form: {
      createTitle: "Yeni proje",
      dateRequired: "Tarih seçin",
      editTitle: "Proje ayarları",
      endBeforeStart: "Bitiş tarihi başlangıçtan önce olamaz",
      endRequiredCustom: "Özel projede bitiş tarihi zorunlu",
      endBeforeTasks: "Bu tarihten sonra vadesi olan açık görevler var; önce görev vadelerini güncelleyin",
      endHintCustom: "Görev vadeleri bu tarihi aşamaz; kalan süre ve gecikmeler buna göre izlenir.",
      endHintInternal: "İç projelerde boş bırakılabilir (süresiz).",
      hint: "Proje kartında ve panolarda görünecek temel bilgiler.",
      keyHint: "2–5 harf, örn. ORV",
      keyInvalid: "2–5 harften oluşmalı",
      nameRequired: "Proje adı en az 2 karakter olmalı",
      sectorPlaceholder: "Sektör seçin",
      sectorRequired: "Sektör seçin"
    },
    kind: {
      internal: "İç proje",
      custom: "Özel proje"
    },
    kindHint: {
      internal: "Kendi ürünlerimiz ve iç işler; bitiş tarihi gerekmez.",
      custom: "Müşteriye özel iş; bitiş tarihi zorunlu, görevler bu tarihe göre izlenir."
    },
    schedule: {
      daysLeft: "{{count}} gün kaldı",
      dueToday: "Bugün bitiyor",
      daysLate: "{{count}} gün gecikti",
      overdueTasks: "Geciken görev"
    },
    history: {
      assigned: "sorumluyu {{detail}} olarak atadı",
      unassigned: "sorumluyu kaldırdı",
      reviewer: "inceleyeni {{detail}} yaptı",
      attachment: "dosya ekledi",
      checklist: "kontrol listesine “{{note}}” ekledi",
      checklist_deleted: "kontrol listesinden madde sildi",
      item_done: "“{{detail}}” maddesini tamamladı",
      item_reopened: "“{{detail}}” maddesini yeniden açtı",
      item_assigned: "“{{note}}” maddesini {{detail}} kişisine atadı",
      comment: "yorum yazdı",
      created: "görevi oluşturdu",
      status: "durumu “{{status}}” olarak güncelledi",
      sprint: "sprinti değiştirdi",
      due: "vadeyi {{detail}} yaptı",
      priority: "önceliği “{{detail}}” yaptı",
      estimate: "tahmini süreyi {{detail}} saat yaptı",
      title: "başlığı değiştirdi",
      archived: "görevi arşivledi",
      unarchived: "görevi arşivden çıkardı",
      assignment_requested: "{{detail}} için atama talebi açtı",
      assignment_approved: "{{detail}} atama talebini onayladı",
      assignment_rejected: "{{detail}} atama talebini reddetti: {{note}}",
      assignment_cancelled: "{{detail}} atama talebini geri çekti",
      updated: "görevi güncelledi"
    },
    checklistAssign: {
      title: "Maddeyi ata",
      assignee: "Sorumlu",
      due: "Vade",
      doneBy: "{{name}} tamamladı"
    },
    sprints: {
      hint: "Sprint; tarih aralığı, hedef ve personel (kapasite saatiyle). Projede aynı anda tek sprint etkin olur; etkin sprintteki personele ek görev, atanan kişi, proje lideri ve firma sahibi onayıyla eklenir.",
      new: "Yeni sprint",
      editTitle: "{{name}} sprintini düzenle",
      formHint: "Kapasite boş bırakılırsa yük karşılaştırması yapılmaz.",
      name: "Sprint adı",
      goal: "Hedef",
      endDate: "Bitiş",
      members: "Sprint personeli ve kapasite (saat)",
      noTeam: "Projede ekip üyesi yok; önce ekip ekleyin.",
      capacity: "Kapasite (sa)",
      saved: "Sprint kaydedildi",
      empty: "Henüz sprint yok",
      noSprint: "Sprint yok",
      status: { planned: "Planlandı", active: "Etkin", closed: "Kapandı" },
      progress: "{{done}} / {{total}} görev bitti",
      report: "Rapor",
      start: "Başlat",
      startTitle: "Sprint başlasın mı?",
      startBody: "{{name}} etkin olur; bundan sonra eklenen görevler ek görev sayılır ve onaya düşer.",
      started: "Sprint başladı",
      close: "Kapat",
      closeTitle: "{{name}} kapatılsın mı?",
      closeHint: "Bitmemiş {{count}} görev seçilen sprinte taşınır ya da sprintsiz kalır.",
      moveTo: "Bitmeyen görevler",
      moveNone: "Sprintten çıkar",
      closed: "Sprint kapandı; {{count}} görev taşındı",
      member: "Personel",
      assignedHours: "Atanan (sa)",
      doneHours: "Biten (sa)",
      spentHours: "Harcanan (sa)",
      over: "Kapasite aşıldı",
      tiles: { tasks: "Görev", hours: "Tahmini saat (biten / toplam)", spent: "Harcanan", added: "Sonradan eklenen", unassigned: "Atanmamış" }
    },
    assignments: {
      pageTitle: "Atama talepleri",
      pageSubtitle: "Doğrudan atama yetkisi olmayanın ataması ve etkin sprintteki personele ek görev: atanacak kişi, proje lideri ve firma sahibi onaylar. Tek ret talebi reddeder.",
      views: { pending_me: "Onayımı bekleyenler", mine: "Talep ettiklerim", all: "Tümü" },
      title: "Atama talepleri",
      none: "Atama talebi yok.",
      empty: "Talep yok",
      request: "Atama talebi aç",
      requestTitle: "{{key}} için atama talebi",
      requestHint: "Atanacak kişi, proje lideri ve firma sahibi onaylayınca görev atanır (sizin dahil olduğunuz rol kendiliğinden onaylı sayılır).",
      keepSprint: "Sprinti değiştirme",
      reason: "Talep gerekçesi",
      reasonHint: "Neden bu kişiye, neden şimdi? (onaycılar görür)",
      send: "Talebi gönder",
      summary: "{{requester}} → {{assignee}}",
      roles: { assignee: "Atanan", lead: "Proje lideri", owner: "Firma sahibi" },
      decision: { pending: "Bekliyor", approved: "Onayladı", rejected: "Reddetti" },
      status: { pending: "Onay bekliyor", approved: "Onaylandı", rejected: "Reddedildi", cancelled: "Geri çekildi" },
      notePlaceholder: "Not (ret için zorunlu)",
      approve: "Onayla ({{roles}})",
      reject: "Reddet",
      cancel: "Geri çek",
      cancelled: "Talep geri çekildi",
      done: { approved: "Onayınız kaydedildi", rejected: "Talep reddedildi" },
      pendingToast: "Atama onaya gönderildi; onaylanınca görev atanır.",
      assignedToast: "Görev atandı"
    },
    icons: {
      calendar: "Takvim",
      monitor: "Ekran",
      package: "Paket",
      stethoscope: "Stetoskop",
      store: "Mağaza",
      users: "Kişiler",
      utensils: "Restoran"
    },
    inclusion: {
      addable: "Eklenebilir",
      addableHint: "İsteğe bağlı olarak projeye eklenebilir.",
      included: "Dahil",
      includedHint: "Temel lisans kapsamında otomatik olarak dahildir."
    },
    install: {
      addStage: "Aşama Ekle",
      approvals: "İç Onay Bekleyenler ({{count}})",
      blockerCreated: "Engel eklendi",
      blockerDeleteTitle: "Engel silinsin mi?",
      blockers: "Engeller / Blokajlar ({{count}})",
      columns: {
        customer: "Müşteri",
        kind: "Tür",
        owner: "Sorumlu",
        plan: "Kurulum / Demo planı",
        status: "Durum",
        target: "Hedef tarih"
      },
      created: "Kayıt oluşturuldu",
      deleteBody: "“{{name}}” kaydı ve {{stages}} aşaması silinecek. Bağlı görevler korunur ancak müşteri bağlantıları kaldırılır.",
      deleted: "Kayıt silindi",
      deleteTitle: "Kurulum kaydı silinsin mi?",
      docCreated: "Doküman eklendi",
      docDeleteTitle: "Doküman silinsin mi?",
      documents: "Müşteri Dokümanları ve İmzalar",
      empty: "Bu filtrede kayıt yok",
      filter: {
        active: "Aktif Kurulumlar ({{count}})",
        all: "Tümü ({{count}})",
        approval: "İç Onay Bekleyen ({{count}})",
        blocked: "Blokeli ({{count}})",
        demo: "Demo ({{count}})",
        done: "Tamamlananlar ({{count}})"
      },
      form: {
        blockerHint: "{{name}} için kurulumu ya da demoyu engelleyen durum.",
        blockerRequired: "En az 5 karakter girin",
        blockerText: "Engel açıklaması",
        blockerTitle: "Engel ekle",
        city: "Şehir",
        completionInvalid: "0–100 arasında bir değer girin",
        createDemo: "Demo planla",
        createInstall: "Kurulum başlat",
        createStage: "Yeni aşama",
        customerRequired: "Müşteri adı en az 2 karakter olmalı",
        date: "Tarih",
        docHint: "{{name}} için imza süreci takip edilecek doküman.",
        docName: "Doküman adı",
        docRequired: "Doküman adı en az 2 karakter olmalı",
        docTitle: "Doküman ekle",
        editStage: "Aşamayı düzenle",
        editTitle: "Kaydı düzenle",
        hint: "{{project}} için müşteri kurulumu ya da demo çalışması.",
        noTasks: "Bu müşteriye bağlı görev yok. Görev formunda müşteri seçerek bağlayabilirsiniz.",
        severity: "Önem",
        stageHint: "{{name}} kurulum planındaki aşama.",
        stageNameRequired: "Aşama adı en az 2 karakter olmalı"
      },
      kpi: {
        active: "Aktif Kurulum",
        activeHint: "Devam eden müşteri kurulumları",
        approval: "İç Onay Bekliyor",
        approvalHint: "Teknik ekip onayı bekleyen işler",
        blocked: "Bloke / Riskli",
        blockedHint: "Kurulum veya demo blokajları",
        demo: "Demo Planlandı",
        demoHint: "Gerçekleştirilecek demo çalışmaları"
      },
      noApprovals: "Onay bekleyen görev yok.",
      noBlockers: "Açık engel yok.",
      noDocs: "Doküman eklenmedi.",
      noStages: "Henüz aşama tanımlanmadı.",
      openBoard: "Panoda Aç",
      overall: "Genel ilerleme",
      planDemo: "Demo Planla",
      reopen: "Yeniden aç",
      resolve: "Çözüldü olarak işaretle",
      stageCols: {
        completion: "Tamamlanma",
        name: "Aşama",
        planned: "Planlanan tarih",
        tasks: "İlgili görevler"
      },
      stageCreated: "Aşama eklendi",
      stageDeleteBody: "“{{name}}” aşaması {{customer}} planından kaldırılacak.",
      stageDeleted: "Aşama silindi",
      stageDeleteTitle: "Aşama silinsin mi?",
      stages: "Kurulum aşamaları",
      stageUpdated: "Aşama güncellendi",
      start: "Kurulum Başlat",
      statusBody: "{{name}} kaydının durumu “{{to}}” olarak değişecek.",
      statusTitle: "Durum değiştirilsin mi?",
      updated: "Kayıt güncellendi"
    },
    installKind: {
      demo: "Demo",
      installation: "Kurulum"
    },
    installStatus: {
      awaiting_approval: "İç Onay Bekliyor",
      blocked: "Blokeli",
      done: "Tamamlandı",
      in_progress: "Devam Ediyor",
      planned: "Planlandı"
    },
    kanban: {
      draggable: "sürüklenebilir görev kartı",
      emptyColumn: "Görev yok",
      moveTo: "“{{status}}” aşamasına taşı",
      open: "Görevi aç",
      rejectHint: "Onay reddedilirse görev ilgili aktif aşamaya geri döner.",
      workflow: "İş akışı:"
    },
    licensePriceHint: "Zorunlu modüller toplamı; abonelikler ayrı gösterilir",
    moduleCategory: {
      core: "Temel",
      integration: "Entegrasyon",
      marketing: "Pazarlama",
      operations: "Operasyon",
      reporting: "Raporlama"
    },
    modules: {
      add: "Modül Ekle",
      columns: {
        name: "Modül",
        price: "Fiyat",
        pricing: "Fiyat tipi",
        requirement: "Zorunluluk",
        status: "Durum"
      },
      count: "{{count}} modül",
      created: "Modül eklendi",
      deleteBody: "“{{name}}” modülü {{project}} projesinden çıkarılacak ve fiyat listesinden kaldırılacak.",
      deleted: "Modül projeden çıkarıldı",
      deleteTitle: "Modül projeden çıkarılsın mı?",
      empty: "Bu projede modül yok",
      emptyHint: "Lisanslanabilir modülleri ve fiyatlarını ekleyin.",
      form: {
        createTitle: "Yeni modül",
        editTitle: "Modülü düzenle",
        hint: "{{project}} projesine ait lisanslanabilir modül.",
        nameRequired: "Modül adı en az 2 karakter olmalı",
        noCandidates: "Bağımlılık için başka modül yok.",
        priceInvalid: "Geçerli bir tutar girin"
      },
      remove: "Projeden çıkar",
      requires: "Gerekli modüller",
      requiresInline: "Gerekli: {{names}}",
      title: "Proje Modülleri",
      updated: "Modül güncellendi"
    },
    moreActions: "Diğer işlemler",
    notes: {
      add: "Not Ekle",
      body: "İçerik",
      bodyRequired: "İçerik boş olamaz",
      created: "Not eklendi",
      createTitle: "Yeni not",
      deleteBody: "“{{name}}” notu kalıcı olarak silinecek.",
      deleted: "Not silindi",
      deleteTitle: "Not silinsin mi?",
      editTitle: "Notu düzenle",
      empty: "Henüz not yok",
      emptyHint: "Toplantı notları, kararlar ve teknik bilgileri ekip için burada tutun.",
      hint: "Düz metin; satır sonları korunur.",
      meta: "{{author}} · {{when}}",
      noMatch: "Aramaya uyan not yok",
      pin: "Sabitle",
      pinLabel: "Notu en üste sabitle",
      search: "Notlarda ara…",
      title: "Başlık",
      titleRequired: "Başlık en az 2 karakter olmalı",
      unpin: "Sabitlemeyi kaldır",
      updated: "Not güncellendi"
    },
    notFound: "Proje bulunamadı",
    openDetail: "Projeyi Aç",
    overview: {
      activeInstallations: "Aktif Kurulum",
      activity: "Son Hareketler",
      blockers: "Açık Engeller ({{count}})",
      installations: "Kurulum ve Demolar",
      noActivity: "Henüz hareket yok.",
      noUpcoming: "Yaklaşan görev yok.",
      openTasks: "Açık Görev",
      overdue: "Gecikmiş",
      period: "Proje dönemi: {{start}} – {{end}}",
      progress: "Proje İlerlemesi",
      upcoming: "Yaklaşan Görevler"
    },
    pricing: {
      monthly: "Aylık abonelik",
      one_time: "Tek seferlik lisans",
      yearly: "Yıllık abonelik"
    },
    pricingSuffix: {
      monthly: "/ ay",
      yearly: "/ yıl"
    },
    priority: {
      high: "Yüksek",
      low: "Düşük",
      medium: "Orta",
      urgent: "Acil"
    },
    priorityLabel: "Öncelik: {{value}}",
    releases: {
      add: "Sürüm Ekle",
      channel: {
        beta: "Beta",
        stable: "Kararlı"
      },
      created: "Sürüm eklendi",
      deleteBody: "{{project}} projesinin {{version}} sürüm kaydı silinecek.",
      deleted: "Sürüm silindi",
      deleteTitle: "Sürüm kaydı silinsin mi?",
      empty: "Henüz sürüm kaydı yok",
      form: {
        channel: "Kanal",
        createTitle: "Yeni sürüm",
        date: "Yayın tarihi",
        editTitle: "Sürümü düzenle",
        hint: "{{project}} için yayınlanan sürüm notu.",
        notes: "Sürüm notları",
        version: "Sürüm",
        versionInvalid: "Sürüm biçimi örn. v2.7 ya da 2.7.1-beta olmalı"
      },
      title: "Sürüm Geçmişi",
      updated: "Sürüm güncellendi"
    },
    reports: {
      byStatus: "Duruma göre görevler",
      byStatusHint: "İş akışındaki her aşamadaki görev sayısı",
      byType: "Türe göre görevler",
      completion: "Tamamlanma",
      completionHint: "{{done}} / {{total}} görev tamamlandı",
      done: "Tamamlanan",
      hours: "Harcanan / tahmini saat",
      hoursByMember: "Kişi başı tahmini ve harcanan saat",
      hoursHint: "Görevlerde girilen tahmini ve gerçekleşen süreler",
      installations: "Kurulum ilerlemesi",
      installHint: "Toplam {{count}} kurulum/demo kaydı",
      memberTable: "Ekip özeti (tablo)",
      open: "Açık",
      taskCount: "Görev"
    },
    requirement: {
      optional: "Opsiyonel",
      required: "Zorunlu"
    },
    rowActions: "{{name}} için işlemler",
    seeAll: "Tümünü gör",
    settings: "Proje Ayarları",
    settingsTab: {
      archive: "Projeyi arşivle",
      archiveBody: "{{name}} arşivlenecek; listelerde arşiv durumunda görünür, veriler korunur.",
      archiveHint: "Proje salt okunur takibe alınır; dilediğinizde geri açabilirsiniz.",
      archiveTitle: "Proje arşivlensin mi?",
      danger: "Tehlikeli bölge",
      dangerHint: "Bu işlemler tüm ekibi etkiler.",
      deleteHint: "Proje, görevler, kurulum kayıtları, notlar ve dosyalar kalıcı olarak silinir.",
      general: "Genel bilgiler",
      generalHint: "Görev anahtarı öneki: {{key}}",
      releasesHint: "Yayınlanan sürümler; kartlarda en son kararlı sürüm gösterilir.",
      restore: "Arşivden çıkar",
      restoreBody: "{{name}} yeniden aktif duruma alınacak.",
      restoreHint: "Proje aktif listelere geri döner.",
      restoreTitle: "Proje arşivden çıkarılsın mı?"
    },
    severity: {
      high: "Yüksek",
      low: "Düşük",
      medium: "Orta"
    },
    stageStatus: {
      done: "Tamamlandı",
      in_progress: "Devam Ediyor",
      pending: "Beklemede"
    },
    stats: {
      activeTasks: "Aktif Görev",
      deployment: "Kurulum Tipi",
      installations: "Müşteri Kurulumu",
      licensePrice: "Başlangıç Lisans Fiyatı",
      modules: "Modül",
      pendingApproval: "Onay Bekleyen",
      progress: "İlerleme",
      version: "Sürüm"
    },
    status: {
      active: "Aktif",
      archived: "Arşivlendi",
      completed: "Tamamlandı",
      paused: "Durduruldu"
    },
    taskDetail: {
      addItem: "Madde ekle…",
      addSubtask: "Alt Görev Ekle",
      approve: "Onayla",
      approveBody: "{{key}} · {{title}} onaylanıp tamamlandı olarak işaretlenecek.",
      approveTitle: "Görev onaylansın mı?",
      attachments: "Ekler",
      attachmentsCount: "Ekler ({{count}})",
      checklist: "Tamamlanma Listesi ({{done}}/{{total}})",
      commentPlaceholder: "Yorum yaz… (Kişi etiketle ile ekip arkadaşlarını etiketleyin, Ctrl+Enter ile gönderin)",
      comments: "Yorumlar",
      commentsCount: "Yorumlar ({{count}})",
      copyLink: "Bağlantıyı kopyala",
      deleteCommentBody: "Yorum kalıcı olarak silinecek.",
      deleteCommentTitle: "Yorum silinsin mi?",
      dependencies: "Bağımlılıklar ({{count}})",
      history: "Geçmiş",
      hours: "{{count}} saat",
      info: "Görev Bilgileri",
      linkCopied: "Bağlantı kopyalandı",
      mention: "Kişi etiketle",
      noChecklist: "Henüz madde yok.",
      noComments: "Henüz yorum yok.",
      noDependencies: "Bu görev başka bir göreve bağlı değil.",
      noDescription: "Açıklama eklenmemiş.",
      noSubtasks: "Alt görev yok.",
      notFound: "Görev bulunamadı",
      pickDependency: "Bağlı olunan görevi seçin",
      project: "Proje",
      reject: "Reddet",
      rejectBody: "{{key}} · {{title}} reddedilecek ve “Başlandı” aşamasına geri dönecek.",
      rejectTitle: "Onay reddedilsin mi?",
      removeDependency: "{{key}} bağımlılığını kaldır",
      removeItem: "“{{text}}” maddesini sil",
      send: "Gönder",
      statusChanged: "Durum “{{status}}” olarak güncellendi",
      submit: "Onaya Gönder",
      submitBody: "{{key}} · {{title}} inceleyen kişinin onayına gönderilecek.",
      submitTitle: "Onaya gönderilsin mi?",
      subtaskOf: "{{key}} alt görevi",
      subtasks: "Alt Görevler ({{count}})",
      time: "{{estimate}}s / {{spent}}s",
      timeHint: "Tahmini / harcanan süre (saat)",
      visibility: "Görünürlük",
      watchers: "İzleyenler"
    },
    tasks: {
      add: "Görev Ekle",
      count: "{{count}} / {{total}} görev",
      created: "{{key}} oluşturuldu",
      deleteBody: "{{key}} · {{title}} silinecek. {{count}} alt görev üst görevden ayrılır; bağımlılık ve aşama bağlantıları kaldırılır.",
      deleted: "Görev silindi",
      deleteTitle: "Görev silinsin mi?",
      empty: "Henüz görev yok",
      fields: {
        assignee: "Sorumlu",
        customer: "Müşteri",
        description: "Açıklama",
        dueDate: "Bitiş tarihi",
        estimate: "Tahmini süre (saat)",
        key: "Anahtar",
        parent: "Üst görev",
        priority: "Öncelik",
        reviewer: "İnceleyen",
        spent: "Harcanan süre (saat)",
        sprint: "Sprint",
        status: "Durum",
        title: "Başlık",
        type: "Tür"
      },
      form: {
        createTitle: "Yeni görev",
        editTitle: "{{key}} düzenle",
        hint: "{{project}} projesine görev ekleyin ya da güncelleyin.",
        hoursInvalid: "0–999 arasında bir süre girin",
        titleRequired: "Başlık en az 3 karakter olmalı"
      },
      noMatch: "Filtrelere uyan görev yok",
      searchPlaceholder: "Görevlerde ara…",
      subtask: "Alt görev",
      updated: "{{key}} güncellendi"
    },
    taskStatus: {
      approval: "Onayda",
      done: "Tamamlandı",
      in_progress: "Başlandı",
      review: "İncelemede",
      todo: "Yapılacak"
    },
    taskType: {
      demo: "Demo",
      development: "Geliştirme",
      installation: "Kurulum"
    },
    team: {
      assign: "Personel Ata",
      assigned: "Personel projeye atandı",
      empty: "Ekip henüz oluşturulmadı",
      emptyHint: "Projeye personel atayarak ekibi kurun.",
      form: {
        createTitle: "Personel ata",
        discipline: "Alan",
        editTitle: "Ekip üyesini düzenle",
        hint: "{{project}} ekibine personel ekleyin ya da görevini güncelleyin.",
        title: "Projedeki görevi",
        titleRequired: "Görev adı en az 2 karakter olmalı",
        user: "Personel",
        userRequired: "Personel seçin"
      },
      none: "Ekip yok",
      remove: "Ekipten çıkar",
      removeBody: "{{name}}, {{project}} ekibinden çıkarılacak. Sorumlu olduğu {{count}} çalışma sorumlusuz kalacak.",
      removed: "Ekipten çıkarıldı",
      removeTitle: "Ekipten çıkarılsın mı?",
      title: "Proje Ekibi ({{count}})",
      updated: "Ekip üyesi güncellendi"
    },
    updated: "Proje güncellendi",
    visibility: {
      internal: "Ekip içi",
      shared: "Müşteri ile paylaşılabilir"
    },
    work: {
      category: {
        demo: "Demolar",
        development: "Geliştirme",
        installation: "Müşteri Kurulumları"
      },
      columns: {
        actions: "İşlemler"
      },
      empty: "Bu sekmede kayıt yok",
      info: {
        demo: "Potansiyel müşterilere açılan süreli demo çalışmaları. Satışa dönüşen demolar müşteri kurulumuna taşınır.",
        development: "Projenin yazılım geliştirme görevleri. Ayrıntılı takip için proje detayındaki Kanban ve Liste görünümlerini kullanın.",
        installation: "Bu projeye ait müşteri kurulumları, müşterilere özel kurulum, eğitim ve teknik çalışmaların takibini içerir. Yazılım geliştirme görevlerinden ayrı olarak yönetilir."
      },
      unassigned: "Atanmadı"
    }
  },
  q: "q",
  updates: {
    catalog: {
      addFeatures: "Eklenecek özellikler",
      addModules: "Eklenecek modüller",
      applied: "{{product}} kataloğu eşitlendi",
      apply: "Farkı uygula",
      deactivateFeatures: "Pasiflenecek özellikler",
      deactivateModules: "Pasiflenecek modüller",
      equal: "Katalog zaten eşit; uygulanacak fark yok.",
      hint: "Ürün reposundaki katalog belgesini seçin (klinik: api/catalog/clinic.json). Önce fark gösterilir; belgede olmayan kayıt silinmez, pasiflenir.",
      invalid: "Dosya geçerli bir katalog belgesi değil",
      open: "Ürün kataloğunu eşitle",
      pick: "Katalog belgesi seç (.json)",
      title: "Ürün kataloğu senkronu",
      tooLarge: "Dosya 1 MB'tan büyük olamaz",
      updateFeatures: "Değişecek özellikler",
      updateModules: "Değişecek modüller"
    },
    last: {
      at: "Bildirim",
      awaitingRestore: "Güncelleme başarısız oldu ve kurulum eski imaja döndü; kurum sahibinin klinik panelinden yedekten geri yüklemeyi onaylaması bekleniyor.",
      empty: "Kurulum henüz güncelleme işi bildirmedi",
      error: "Hata",
      status: "Durum",
      step: "Adım",
      title: "Son güncelleme",
      version: "Sürüm"
    },
    publish: {
      done: "{{version}} yayımlandı; atanan kurulumlar sonraki heartbeat'te teklifi alır",
      hint: "Sürüm, bu imajın atandığı kurulumlara heartbeat yanıtında teklif edilir. Kurum sahibi onaylar ya da zamanlar.",
      immutable: "Yayımlanan sürüm değiştirilemez; düzeltme yeni imaj işiyle yayımlanır.",
      notes: "Sürüm notları",
      security: "Güvenlik güncellemesi",
      securityHint: "Klinik panelinde öne çıkarılır ve onaylanana kadar uyarı gösterilir.",
      submit: "Yayımla",
      title: "Sürümü yayımla",
      version: "Sürüm",
      versionInvalid: "Sürüm 1.2.3 biçiminde olmalı (isteğe bağlı ek: 1.2.3-rc.1)",
      minPanel: "En düşük masaüstü panel sürümü (isteğe bağlı)",
      minPanelHint: "Bu sürümden eski masaüstü panel, sunucu güncellenince zorunlu güncellenir. Uyumlu panel önceden yayımlanmış olmalı."
    },
    push: {
      actions: "İşlemler",
      approve: "Onayla",
      approved: "Onaylandı; worker kısa süre içinde çalıştıracak",
      configure: "SSH erişimi",
      created: "Talep",
      empty: "SSH talebi yok",
      hint: "Ajan çalışmıyorsa CP sunucuya bağlanıp ajanı bir tur çalıştırır. Ajan yalnız kurum sahibinin onayladığı işi uygular. Talebi açan onaylayamaz.",
      linked: "Sunucu kuruluma bağlandı",
      output: "Çıktı",
      reason: "Gerekçe",
      reject: "Reddet",
      rejected: "Talep reddedildi",
      request: "SSH ile çalıştır",
      requestHint: "Neden SSH yolu gerekiyor? Gerekçe audit kaydına yazılır.",
      requested: "Talep açıldı; ikinci bir yetkilinin onayı bekleniyor",
      server: "Müşteri sunucusu",
      sshMissing: "SSH tanımlı değil",
      sshReady: "SSH hazır",
      status: {
        approved: "Onaylandı",
        failed: "Başarısız",
        rejected: "Reddedildi",
        requested: "Onay bekliyor",
        running: "Çalışıyor",
        succeeded: "Tamamlandı"
      },
      title: "SSH yedek yolu",
      waitingSecond: "İkinci kişi onayı bekleniyor"
    },
    release: {
      assign: "İmaj ata",
      assigned: "Atanan sürüm",
      assignedDone: "İmaj kuruluma atandı",
      assignHint: "Kurulum, atanan imaj yayımlandığında güncelleme teklifini alır.",
      image: "İmaj",
      jobCreated: "İmaj işi oluşturuldu",
      mismatch: "Kurulumun bildirdiği paketler atanan imajınkinden farklı (güncelleme yapılmamış ya da yanlış imaj kurulmuş).",
      newJob: "İmaj işi oluştur",
      newJobHint: "Kurulumun lisanslı paketleriyle derlenecek imaj işi açılır.",
      notes: "Not (isteğe bağlı)",
      published: "Yayımlandı",
      running: "Çalışan sürüm",
      title: "Sürüm",
      unpublished: "Yayımlanmadı",
      unsigned: "imza doğrulanmadı"
    },
    ssh: {
      hint: "Özel anahtar şifrelenerek saklanır ve bir daha gösterilmez. Sunucu anahtarı parmak iziyle sabitlenir; eşleşmezse bağlanılmaz.",
      hostKey: "Sunucu anahtarı parmak izi",
      hostKeyHint: "Sunucuda şu komutun çıktısındaki SHA256:… değeri:",
      keyHint: "Yalnız bu sunucu için üretilmiş, parolasız ve /opt/clinic'te docker çalıştırabilen kullanıcının anahtarı.",
      keyReplace: "Kayıtlı bir anahtar var; yenisini girerseniz eskisinin yerini alır.",
      port: "Port",
      privateKey: "Özel anahtar",
      saved: "SSH erişimi kaydedildi",
      title: "SSH erişimi · {{name}}",
      user: "Kullanıcı"
    },
    status: {
      awaiting_restore: "Geri yükleme onayı bekliyor",
      cancelled: "İptal edildi",
      failed: "Başarısız",
      restore_requested: "Geri yükleme onaylandı",
      restored: "Yedekten geri yüklendi",
      restoring: "Geri yükleniyor",
      running: "Uygulanıyor",
      scheduled: "Zamanlandı",
      succeeded: "Tamamlandı"
    },
    step: {
      backup: "Yedek",
      health: "Sağlık kontrolü",
      maintenance: "Bakım modu",
      migrate: "Migration",
      pull: "İmaj indirme",
      restart: "Yeniden başlatma",
      restore: "Geri yükleme",
      rollback: "Eski imaja dönüş",
      verify: "İmza doğrulama"
    },
    vault: {
      hint: "Sunucu erişim sırlarını kullanan işlemler için vault PIN'inizi girin (15 dakika açık kalır).",
      pin: "Vault PIN",
      title: "Vault kilidini aç",
      unlock: "Kilidi aç",
      wrongPin: "PIN hatalı"
    }
  },
  releases: {
    status: {
      cancelled: "İptal edildi",
      done: "Tamamlandı",
      failed: "Başarısız",
      queued: "Sırada",
      running: "Çalışıyor"
    },
    assignImage: "assignImage",
    columns: {
      actions: "İşlemler",
      created: "Oluşturma",
      id: "Kimlik",
      image: "İmaj",
      jobType: "İş türü",
      status: "Durum",
      notes: "Not",
      version: "Yayın"
    },
    cosignVerified: "cosignVerified",
    imageDigest: "imageDigest",
    imageHint: "imageHint",
    imageRef: "imageRef",
    subtitle: "İmaj işleri ve cosign",
    title: "Sürümler ve imajlar",
    panel: {
      title: "Masaüstü panel sürümleri",
      hint: "Panel her müşteri için ayrı derlenir; CI imzalı paketleri taslak olarak yükler. Yayımlanan panel, o müşterinin en düşük sunucu sürümünü karşılayan kurulumlarına heartbeat'le duyurulur; yayımlanan sürüm değişmez.",
      account: "Müşteri",
      version: "Sürüm",
      minServer: "En düşük sunucu",
      packages: "Paketler",
      state: "Durum",
      draft: "Taslak",
      noPackage: "Paket yok",
      edit: "Düzenle",
      editTitle: "Panel sürümünü düzenle",
      notes: "Sürüm notları",
      minServerHint: "Bu panel daha eski sunucu sürümüne önerilmez. Boş: sınır yok.",
      save: "Kaydet",
      saved: "Panel sürümü güncellendi",
      publish: "Yayımla",
      publishConfirm: "{{version}} yayımlansın mı? Yayımlanan sürüm ve paketleri değiştirilemez.",
      published: "{{version}} yayımlandı",
      empty: "Henüz panel sürümü yüklenmedi"
    },
    updateStatus: "updateStatus",
    markReady: "Hazır işaretle",
    publish: "Yayımla",
    security: "Güvenlik güncellemesi",
    signed: "İmza doğrulandı",
    unsigned: "İmza doğrulanmadı"
  },
  renewals: {
    columns: {
      account: "Hesap",
      amount: "Tutar",
      due: "Vade",
      status: "Durum"
    },
    subtitle: "Abonelik yenileme takibi",
    title: "Yenilemeler"
  },
  reports: {
    aging: {
      "0_30": "1–30 gün gecikmiş",
      "31_60": "31–60 gün gecikmiş",
      "61_90": "61–90 gün gecikmiş",
      "90_plus": "90+ gün gecikmiş",
      not_due: "Vadesi gelmemiş"
    },
    col: {
      amount: "Tutar",
      bucket: "Vade aralığı",
      category: "Kategori",
      contract: "Sözleşme tutarı",
      conversion: "Geçiş oranı",
      count: "Adet",
      customer: "Müşteri",
      customers: "Müşteri",
      department: "Departman",
      dueOn: "Vade",
      gross: "Brüt maliyet",
      hours: "Saat (harcanan / tahmin)",
      kind: "Tür",
      location: "Lokasyon",
      module: "Modül",
      month: "Ay",
      net: "Net",
      openTasks: "Açık görev",
      overdue: "Geciken",
      people: "Kişi",
      perPerson: "Kişi başı",
      person: "Kişi",
      product: "Ürün",
      progress: "İlerleme",
      project: "Proje",
      range: "Aralık",
      reason: "Neden",
      region: "Bölge",
      remainingHours: "Kalan saat",
      rep: "Temsilci",
      sector: "Sektör",
      stage: "Aşama",
      status: "Durum",
      target: "Hedef tarih",
      tasks: "Görev",
      type: "Tür",
      winRate: "Kazanma oranı"
    },
    customers: {
      byProduct: "Ürüne göre müşteriler",
      byRegion: "Bölgeye göre müşteriler",
      bySector: "Sektöre göre müşteriler",
      daysLeft: "{{count}} gün",
      growth: "Müşteri kazanımı ve kayıp",
      growthHint: "Aylık yeni müşteri ve sözleşmesi biten müşteri sayısı",
      late: "{{count}} gün gecikti",
      modules: "Modül kullanımı",
      modulesHint: "Müşterilerde aktif, denemede ve planlanan modüller",
      openPriority: "Açık taleplerin önceliği",
      renewals: "Yaklaşan yenilemeler",
      renewalsHint: "Vadesi en yakın 8 lisans, bakım ve destek yenilemesi",
      tickets: "Destek talepleri",
      ticketsHint: "Aylık açılan ve çözülen talep sayısı",
      ticketStatus: "Talep durumu",
      ticketStatusHint: "Tüm talepler ve açık olanların önceliği"
    },
    export: {
      csv: "CSV indir",
      label: "Dışa aktar",
      title: "Rapor tablolarını indir",
      xlsx: "Excel (.xlsx) indir"
    },
    finance: {
      aging: "Alacak yaşlandırma",
      agingHint: "Açık tahsilatların vade gecikmesine göre dağılımı",
      cash: "Nakit bakiyesi",
      cashHint: "Ay sonu toplam kasa ve banka bakiyesi",
      docs: "{{count}} belge",
      expenseMix: "Gider dağılımı",
      incomeMix: "Gelir dağılımı",
      mixHint: "Seçili dönem toplamı, kategoriye göre",
      monthly: "Gelir, gider ve net sonuç",
      monthlyHint: "Aylık tahakkuk bazlı gelir ve gider; çizgi net sonucu gösterir",
      noReceivables: "Açık alacak yok",
      receivables: "En yüksek açık alacaklar",
      receivablesHint: "Tahsil edilmemiş tutarı en yüksek müşteriler"
    },
    hr: {
      byDepartment: "Departmanlara göre personel",
      employment: "Çalışma türü",
      headcount: "Personel sayısı",
      headcountHint: "Ay sonu personel sayısı (çizgi), işe giriş ve çıkışlar (çubuk)",
      locations: "Lokasyon",
      payroll: "Bordro maliyeti",
      payrollHint: "Son bordro dönemine göre departman bazında maliyet",
      tenure: "Kıdem dağılımı",
      tenureBucket: {
        "0-1": "1 yıldan az",
        "1-3": "1–3 yıl",
        "3-5": "3–5 yıl",
        "5+": "5 yıl ve üzeri"
      },
      workType: {
        hibrit: "Hibrit",
        tam_zamanli: "Tam zamanlı",
        yari_zamanli: "Yarı zamanlı"
      },
      years: "Ortalama kıdem (yıl)"
    },
    kpi: {
      activeInstalls: "Aktif kurulum",
      avgDeal: "Ortalama satış tutarı",
      avgTenure: "Ortalama kıdem",
      blockers: "Açık engel",
      cash: "Nakit bakiyesi",
      churned: "Kaybedilen müşteri",
      completed: "Tamamlanan görev",
      csat: "Müşteri memnuniyeti",
      cycle: "Ortalama satış süresi",
      dso: "Ortalama tahsil süresi",
      expense: "Gider",
      headcount: "Personel",
      hires: "İşe giriş",
      income: "Gelir",
      liveCustomers: "Canlı müşteri",
      margin: "Net kâr marjı",
      net: "Net sonuç",
      newCustomers: "Yeni müşteri",
      onTime: "Zamanında tamamlama",
      openTasks: "Açık görev",
      openTickets: "Açık destek talebi",
      overdueTasks: "Geciken görev",
      payroll: "Bordro maliyeti",
      pipelineValue: "Açık teklif değeri",
      receivable: "Açık alacak",
      resolveHours: "Ortalama çözüm süresi",
      snapshot: "Güncel durum",
      turnover: "Personel devir oranı",
      vsPrev: "önceki aya göre",
      winRate: "Kazanma oranı",
      wonValue: "Kazanılan satış"
    },
    noData: "Bu dönem için veri yok",
    ops: {
      blockers: "{{count}} engel",
      byType: "Görev türleri",
      byTypeHint: "Tüm projelerdeki görevlerin türe göre dağılımı",
      hours: "{{spent}} / {{estimate}} sa",
      installations: "Kurulumlar",
      installationsHint: "Projelerdeki müşteri kurulum ve demolarının durumu",
      openShort: "{{count}} açık",
      overdue: "{{count}} geciken",
      projectMeta: "{{total}} görev · {{installs}} kurulum",
      projects: "Proje bazında görev durumu",
      projectsHint: "Her projede görevlerin duruma göre dağılımı, gecikmeler ve efor",
      remaining: "{{hours}} sa kaldı",
      source: "Görev ve kurulum verileri Proje Panoları'ndan anlık okunur.",
      status: {
        done: "Tamamlandı",
        inProgress: "Devam ediyor",
        review: "İnceleme / onay",
        todo: "Yapılacak"
      },
      statusOf: "{{name}} görev durumu",
      throughput: "Görev akışı",
      throughputHint: "Aylık açılan ve tamamlanan görev sayısı",
      workload: "Ekip iş yükü",
      workloadHint: "Kişi başı açık görev; kırmızı kısım gecikenler"
    },
    overview: {
      activity: "Ekip aktivitesi",
      activityHint: "Görüşme, teklif ve destek talebi sayıları",
      insights: "Öne çıkanlar",
      insightsHint: "Verilerden otomatik çıkarılan notlar",
      pipeline: "Satış hattı",
      pipelineHint: "Aşamalara göre güncel müşteri sayısı",
      revenue: "Gelir ve gider",
      revenueHint: "Aylık gelir ve gider; çizgi net sonucu gösterir",
      topCustomers: "En değerli müşteriler",
      topCustomersHint: "Onaylanan tekliflerin toplamına göre"
    },
    profit: {
      income: "Gelir",
      expense: "Gider",
      salesExpense: "Satış süreci gideri",
      profit: "Kâr",
      margin: "Marj",
      budgetUsed: "Bütçe kullanımı",
      quotes: "Teklifler",
      orders: "Onaylı siparişler",
      invoiced: "Faturalanan",
      collected: "Tahsil edilen",
      outstanding: "Açık alacak",
      count: "{{count}} adet",
      records: "{{count}} kayıt",
      projects: "Projeler",
      customers: "Müşteriler",
      projectsHint: "Projeye bağlı gelir/gider kayıtları ve proje müşterilerinin satış sürecindeki görüşme giderleri",
      customersHint: "Müşteri bazında teklif, sipariş, fatura, tahsilat ve satış giderleri",
      monthly: "Aylık gelir ve gider",
      monthlyHint: "Gelir ve gider kayıtları (KDV hariç)",
      incomeSources: "Gelir kaynakları",
      expenseSources: "Gider dağılımı",
      sourcesHint: "Kategori bazında, KDV hariç",
      exVat: "KDV hariç",
      marginHint: "Kâr marjı {{margin}}",
      ordersHint: "Tahsil edilen {{collected}} · açık {{outstanding}}",
      costHint: "Satış süreci giderleri dahil ({{sales}})",
      kpi: { income: "Toplam gelir", cost: "Toplam gider", profit: "Net kâr", orders: "Satış (onaylı sipariş)" }
    },
    pages: {
      profitability: {
        subtitle: "Proje ve müşteri bazında gelir, gider ve kârlılık; gelir kaynakları ve gider dağılımı.",
        title: "Kârlılık Raporu"
      },
      customers: {
        subtitle: "Müşteri tabanı, ürün ve modül kullanımı, destek ve yenilemeler.",
        title: "Müşteri ve Destek Raporu"
      },
      finance: {
        subtitle: "Gelir-gider, nakit, kategori dağılımı ve alacak yaşlandırma.",
        title: "Finans Raporu"
      },
      hr: {
        subtitle: "Personel sayısı, departman dağılımı, bordro maliyeti ve kıdem.",
        title: "İnsan Kaynakları Raporu"
      },
      operations: {
        subtitle: "Proje görevleri, ekip iş yükü ve müşteri kurulumları.",
        title: "Proje ve Operasyon Raporu"
      },
      overview: {
        subtitle: "Şirketin finans, satış, müşteri ve operasyon göstergelerinin özeti.",
        title: "Yönetim Özeti"
      },
      sales: {
        subtitle: "Teklif ve kazanım trendleri, satış hunisi, temsilci performansı ve kayıp nedenleri.",
        title: "Satış Raporu"
      }
    },
    period: {
      "12": "Son 12 ay",
      "3": "Son 3 ay",
      "6": "Son 6 ay",
      label: "Dönem"
    },
    sales: {
      conversion: "%{{pct}} geçti",
      funnel: "Satış hunisi",
      funnelHint: "Her aşamaya ulaşan müşteri ve bir sonrakine geçiş oranı",
      lostReasons: "Kayıp nedenleri",
      lostReasonsHint: "Kaybedilen tekliflerde belirtilen neden",
      monthly: "Teklif sonuçları",
      monthlyHint: "Aylık gönderilen, kazanılan ve kaybedilen teklif",
      products: "Ürünlere göre",
      productsHint: "Ürün başına müşteri; canlıdakiler ayrıca",
      regions: "Bölgelere göre",
      regionsHint: "Satış bölgesine göre müşteri sayısı",
      reps: "Temsilci performansı",
      repsHint: "Kazanılan satış tutarına göre sıralı",
      wonValue: "Kazanılan satış tutarı",
      wonValueHint: "Aylık onaylanan teklif toplamı"
    },
    series: {
      balance: "Bakiye",
      churned: "Kaybedilen",
      completed: "Tamamlanan",
      created: "Açılan",
      exits: "Çıkış",
      expense: "Gider",
      headcount: "Personel",
      hires: "Giriş",
      income: "Gelir",
      lost: "Kaybedilen",
      meetings: "Görüşme",
      net: "Net sonuç",
      newCustomers: "Yeni müşteri",
      offers: "Teklif",
      opened: "Açılan",
      resolved: "Çözülen",
      sent: "Gönderilen",
      tickets: "Destek talebi",
      won: "Kazanılan",
      wonValue: "Kazanılan tutar"
    },
    view: {
      chart: "Grafik görünümü",
      label: "Görünüm",
      table: "Tablo görünümü"
    }
  },
  sensitive: "sensitive",
  stageKind: {
    done: "Tamamlandı",
    lost: "Kaybedildi",
    open: "Açık",
    won: "Kazanıldı"
  },
  status: "status",
  tickets: {
    columns: {
      account: "Hesap",
      created: "Oluşturma",
      module: "Modül",
      status: "Durum",
      title: "Başlık",
      subject: "Konu"
    },
    formHint: "formHint",
    messagePlaceholder: "messagePlaceholder",
    messagesTitle: "messagesTitle",
    new: "Yeni talep",
    noMessages: "noMessages",
    pickTicket: "pickTicket",
    send: "send",
    status: {
      closed: "Kapalı",
      in_progress: "İşlemde",
      open: "Açık",
      resolved: "Çözüldü"
    },
    subtitle: "Destek talepleri",
    title: "Destek"
  },
  timeline: {
    kinds: {
      email: "E-posta",
      followup: "Takip",
      license: "Lisans",
      meeting: "Görüşme",
      note: "Not",
      order: "Sipariş",
      quote: "Teklif",
      stage: "Aşama",
      task: "Görev",
      ticket: "Destek"
    },
    status: {
      acik: "Açık",
      gecikti: "Gecikti",
      gelen: "Gelen",
      giden: "Giden",
      tamamlandi: "Tamamlandı"
    }
  },
  xlsx: "xlsx"
} as const

export type Dict = typeof tr
